/*
 This file is part of GNU Taler
 (C) 2021-2023 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/*eslint quote-props: ["error", "consistent"]*/
export const strings: {[s: string]: any} = {};

strings['uk'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
        "lang": "uk"
      },
      "Cancel": [
        "Скасувати"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        "Закрити"
      ],
      "Continue": [
        "Продовжити"
      ],
      "Clear": [
        "Очистити"
      ],
      "Confirm": [
        "Підтвердити"
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        "Адреса"
      ],
      "Host": [
        "Хост"
      ],
      "Account ID": [
        "Рахунок"
      ],
      "The account owner's legal name": [
        "Ім'я власника банківського рахунку."
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        "Місто"
      ],
      "Bank host": [
        "Хост банку"
      ],
      "Bank account": [
        "Банківський рахунок"
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        "Перевірка дійсності банківського рахунку: %1$s"
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        "Призначення"
      ],
      "Receiver postal code": [
        "Дата доставки"
      ],
      "Receiver town": [
        "Дата доставки"
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        "Операція виконується..."
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        "Операція буде автоматично скасована через %1$s секунд"
      ],
      "days": [
        "дні"
      ],
      "hours": [
        "години"
      ],
      "minutes": [
        "хвилини"
      ],
      "seconds": [
        "секунди"
      ],
      "Forever": [
        "назавжди"
      ],
      "%1$sM": [
        "%1$sМ"
      ],
      "%1$sY": [
        "%1$sР"
      ],
      "%1$sd": [
        "%1$sдн."
      ],
      "%1$sh": [
        "%1$sг"
      ],
      "%1$smin": [
        "%1$sхв"
      ],
      "%1$ssec": [
        "%1$sсек"
      ],
      "Change value to never": [
        "змінити значення на ніколи"
      ],
      "Change value to empty": [
        "змінити значення на порожнє"
      ],
      "Image must be smaller than 1 MB": [
        "Зображення повинно бути меншим за 1 МБ"
      ],
      "Add": [
        "Додати"
      ],
      "Remove": [
        "Видалити"
      ],
      "Country": [
        "Країна"
      ],
      "Building number": [
        "Номер будинку"
      ],
      "Building name": [
        "Назва будинку"
      ],
      "Street": [
        "Вулиця"
      ],
      "Post code": [
        "Поштовий індекс"
      ],
      "Town location": [
        "Область міста"
      ],
      "District": [
        "Район"
      ],
      "Country subdivision": [
        "Регіон країни"
      ],
      "Additional address lines": [
        "Додаткова інформація"
      ],
      "Orders": [
        "Замовлення"
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        "Ідентифікатор банківського переказу"
      ],
      "Templates": [
        "Шаблони"
      ],
      "Product groups": [
        "Товари"
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        "Термін дії"
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        "Вебхуки"
      ],
      "Settings": [
        "Налаштування"
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        "Токен доступу"
      ],
      "Connection": [
        "З'єднання"
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        "Інстанції"
      ],
      "New": [
        "Новий"
      ],
      "List": [
        "Список"
      ],
      "Log out": [
        "Вийти"
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        "Назва інстанції в URL. Інстанція 'default' є особливою, оскільки використовується для адміністрування інших інстанцій."
      ],
      "Business name": [
        "Назва бізнесу"
      ],
      "Legal name of the business represented by this instance.": [
        "Юридична назва бізнесу, який представляє ця інстанція."
      ],
      "Email": [
        "Email"
      ],
      "Contact email": [
        "Контактний email"
      ],
      "Phone number": [
        "Номер маршрутизації."
      ],
      "Contact phone": [
        "Контактний email"
      ],
      "Website URL": [
        "URL вебсайту"
      ],
      "URL.": [
        "URL."
      ],
      "Logo": [
        "Логотип"
      ],
      "Logo image.": [
        "Зображення логотипу."
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        "Фізичне розташування продавця."
      ],
      "Jurisdiction": [
        "Юрисдикція"
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        "Юрисдикція для правових спорів з продавцем."
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        "Деталі оплати"
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        "Час, який мають клієнти для оплати замовлення до закінчення терміну дії пропозиції за замовчуванням."
      ],
      "Refund delay": [
        "Затримка автоматичного повернення"
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        "Термін банківського переказу"
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        "Максимальний час, на який обмінник може затримати переказ коштів продавцю, дозволяючи йому об'єднувати менші платежі у більші банківські перекази та знижуючи комісії за переказ."
      ],
      "Wire transfer rounding": [
        "Термін банківського переказу"
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        "замовлення не знайдено"
      ],
      "To second": [
        "секунди"
      ],
      "To minute": [
        "хвилини"
      ],
      "To hour": [
        "години"
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        "Закінчується о"
      ],
      "Required": [
        "обовʼязково"
      ],
      "Unauthorized": [
        "Авторизовано"
      ],
      "The code is not correct.": [
        "Це недійсна адреса біткойн."
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        "Алгоритм перевірки"
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        "Назад"
      ],
      "Verify": [
        "Перевірено"
      ],
      "Failed to send the verification code.": [
        "Не вдалося видалити інстанцію"
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        "замовлення не знайдено"
      ],
      "Login required": [
        "Потрібен вхід"
      ],
      "Instance name.": [
        "Ідентифікатор інстанції"
      ],
      "Instance password.": [
        "Керування запасами"
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        "Зарахований банківський рахунок"
      ],
      "Invalid": [
        "недійсний"
      ],
      "Doesn't have the pattern of an email": [
        "URL має неправильний формат"
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        "недійсний формат"
      ],
      "Max 7 lines": [
        "максимум 7 рядків"
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        "Ідентифікатор інстанції"
      ],
      "Unauthorized.": [
        "Авторизовано"
      ],
      "Conflict.": [
        "Конфлікт."
      ],
      "Not found.": [
        "замовлення не знайдено"
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        "наступний токен доступу, який буде використано"
      ],
      "Repeat password": [
        "Повторіть токен доступу"
      ],
      "Confirm the same password": [
        "підтвердити той самий токен доступу"
      ],
      "Please complete the marked fields and choose authorization method": [
        "Необхідно заповнити позначені поля та вибрати метод авторизації"
      ],
      "Confirm operation": [
        "Підтверджено"
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        "замовлення не знайдено"
      ],
      "Description": [
        "Опис"
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        "Термін дії"
      ],
      "Time the access token will be valid.": [
        "Наданий токен доступу є недійсним."
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        "Виберіть одну..."
      ],
      "Read only": [
        ""
      ],
      "All": [
        "Всі"
      ],
      "Order simple": [
        "ідентифікатор замовлення"
      ],
      "Order Point-of-Sale": [
        "Ключ точки продажу"
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        "ідентифікатор замовлення"
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        "Встановити токен доступу"
      ],
      "Please complete the marked fields": [
        "Необхідно заповнити позначені поля"
      ],
      "Access token created": [
        "Токен доступу"
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        "Інстанція 'default' ще не налаштована."
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        "Створіть інстанцію 'default', щоб почати використовувати бекофіс продавця."
      ],
      "Create access token": [
        "Встановити токен доступу"
      ],
      "Load more devices before the first one": [
        "завантажити більше шаблонів до першого"
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        "Створено о"
      ],
      "Expires at": [
        "Закінчується о"
      ],
      "Never": [
        "ніколи"
      ],
      "Remove this access token": [
        "Повторіть токен доступу"
      ],
      "Delete": [
        "Видалити"
      ],
      "Load more devices after the last one": [
        "завантажити більше шаблонів після останнього"
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        "Продуктів ще немає, додайте більше, натиснувши знак +"
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        "Встановити токен доступу"
      ],
      "Deleting an access token cannot be undone.": [
        "наступний токен доступу, який буде використано"
      ],
      "This is not a valid Bitcoin address.": [
        "Це недійсна адреса біткойн."
      ],
      "This is not a valid Ethereum address.": [
        "Це недійсна адреса Ethereum."
      ],
      "This is not a valid host.": [
        "Це недійсна адреса біткойн."
      ],
      "IBANs usually have more than 4 digits.": [
        "Номера IBAN зазвичай мають більше 4-ьох цифр"
      ],
      "IBANs usually have fewer than 34 digits.": [
        "Номера IBAN зазвичай мають менше 34-ьох цифр"
      ],
      "The IBAN's country code could not be retrieved.": [
        "Код країни IBAN не знайдено"
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        "Номер IBAN не коректний, контрольна сума не сходиться"
      ],
      "This account is not allowed.": [
        "Це недійсна адреса біткойн."
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        "Метод переказу"
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        "Виберіть один метод переказу"
      ],
      "Routing": [
        "Маршрутизація"
      ],
      "Routing number": [
        "Номер маршрутизації."
      ],
      "Account": [
        "Рахунок"
      ],
      "Account number": [
        "Номер рахунку."
      ],
      "Code": [
        "Код"
      ],
      "Business Identifier Code": [
        "Код ідентифікації бізнесу."
      ],
      "International Bank Account Number": [
        "Номер банківського рахунку."
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        "Уніфікований інтерфейс платежів."
      ],
      "Bitcoin protocol": [
        "Протокол біткойн."
      ],
      "Ethereum protocol": [
        "Протокол Ethereum."
      ],
      "Interledger protocol": [
        "Протокол Interledger."
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        "Рахунок"
      ],
      "Name of the account holder": [
        "Назва категорії"
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        "Офіційне ім'я власника рахунку."
      ],
      "Invalid url": [
        "недійсний формат"
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        "Підтвердити"
      ],
      "Server replied with \"bad request\".": [
        "Відповідь сервера з кодом помилки."
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        "Рахунок:"
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        "Тип події"
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        "Створити токен"
      ],
      "Do not change": [
        "URL обмінника"
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        "Відповідь сервера з кодом помилки."
      ],
      "Account details": [
        "Адреса рахунку"
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        "Банківський рахунок успішно видалено."
      ],
      "Delete account": [
        "Виберіть один рахунок"
      ],
      "Delete the account \"%1$s\"": [
        "не вдалося видалити продукт"
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        "наступний токен доступу, який буде використано"
      ],
      "Bank accounts": [
        "Банківський рахунок"
      ],
      "Add new account": [
        "Зарахований банківський рахунок"
      ],
      "Owner's name": [
        "Назва бізнесу"
      ],
      "Delete selected accounts from the database": [
        "видалити вибраний переказ з бази даних"
      ],
      "There are no accounts yet, add more pressing the + sign": [
        "Продуктів ще немає, додайте більше, натиснувши знак +"
      ],
      "You must provide a bank account to receive payments.": [
        "URI, що вказує на банківський рахунок для зарахування доходу."
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        "Назва"
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        "шаблон успішно видалено"
      ],
      "Add new devices": [
        "додати новий резерв"
      ],
      "ID": [
        "Ідентифікатор"
      ],
      "Total products": [
        "Загальна ціна"
      ],
      "Delete selected category from the database": [
        "видалити вибраний переказ з бази даних"
      ],
      "There are no categories yet, add more pressing the + sign": [
        "Шаблонів ще немає, додайте більше, натиснувши знак +"
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        "Назва категорії"
      ],
      "Products": [
        "Товари"
      ],
      "Image": [
        "Зображення"
      ],
      "Load more products after the last one": [
        "завантажити більше шаблонів після останнього"
      ],
      "There are no products in this category.": [
        "Керування списком продуктів у замовленні."
      ],
      "Account's KYC status": [
        "Адреса рахунку"
      ],
      "Exchange": [
        "Exchange"
      ],
      "Status": [
        "URL статусу"
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        "Потрібен вхід"
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        "Сума обов'язкова"
      ],
      "More information required.": [
        "додаткова інформація для надання контексту"
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        "Завантаження..."
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        "Немає очікуваних перевірок KYC!"
      ],
      "The account for wire transfers does not appear to be valid": [
        "перевірте ідентифікатор, він виглядає недійсним."
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        "Податки для цього продукту не налаштовані."
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        "Ви встановлюєте токен доступу для нової інстанції"
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        "Цільовий рахунок"
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        "змінити значення на невідому дату"
      ],
      "Enter description or id": [
        "Введіть ідентифікатор замовлення"
      ],
      "No match found for that description or ID.": [
        "продукти з таким описом не знайдено"
      ],
      "You must enter a valid product identifier.": [
        "Ви повинні ввести дійсний ідентифікатор продукту."
      ],
      "Quantity must be greater than 0!": [
        "Кількість має бути більше 0!"
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        "Ця кількість перевищує залишок на складі. Наразі на складі залишилося лише %1$s одиниць, які не зарезервовані."
      ],
      "Search product": [
        "нова ціна для продукту"
      ],
      "Quantity": [
        "Кількість"
      ],
      "How many products will be added": [
        "скільки продуктів буде додано"
      ],
      "Add from inventory": [
        "Додати зі складу"
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        "Податки для цього продукту не налаштовані."
      ],
      "Amount": [
        "Сума"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        "Податки можуть бути в валютах, що відрізняються від основної валюти, яку використовує продавець."
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        "Введіть валюту та значення, розділені двокрапкою, наприклад, &quot;USD:2.3&quot;."
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        "Офіційна назва податку, наприклад, ПДВ або імпортні мита."
      ],
      "Add tax to the tax list": [
        "додати податок до списку податків"
      ],
      "Describe and add a product that is not in the inventory list": [
        "опишіть і додайте продукт, якого немає в списку інвентарю"
      ],
      "Add custom product": [
        "Додати новий продукт"
      ],
      "Complete information of the product": [
        "Повна інформація про продукт"
      ],
      "Must be a number.": [
        "не є числом"
      ],
      "Must be greater than 0.": [
        "має бути більше 0"
      ],
      "Photo of the product.": [
        "фото продукту."
      ],
      "Full product description.": [
        "повний опис продукту."
      ],
      "Unit name": [
        "Одиниця"
      ],
      "Name of the product unit.": [
        "назва одиниці продукту."
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        "сума в поточній валюті."
      ],
      "How many products will be added.": [
        "скільки продуктів буде додано."
      ],
      "Taxes": [
        "Податки"
      ],
      "Total price": [
        "Загальна ціна"
      ],
      "Must be greater than 0": [
        "має бути більше 0"
      ],
      "Must have a refund deadline": [
        "повинен бути встановлений термін повернення"
      ],
      "Auto refund can't be after refund deadline": [
        "автоматичне повернення не може бути після терміну повернення"
      ],
      "Must be in the future": [
        "повинно бути в майбутньому"
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        "недійсний"
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        "Керування продуктами в замовленні"
      ],
      "%1$s products with a total price of %2$s.": [
        "%1$s товарів із загальною ціною %2$s."
      ],
      "Manage list of products in the order.": [
        "Керування списком продуктів у замовленні."
      ],
      "Remove this product from the order.": [
        "Видалити цей продукт із замовлення."
      ],
      "Products price sum": [
        "Список продуктів"
      ],
      "Total product price added up": [
        "загальна сума продукту"
      ],
      "Order price": [
        "Ціна за одиницю"
      ],
      "Amount to be paid by the customer": [
        "Сума, яку має сплатити клієнт"
      ],
      "Final order price": [
        "кінцева ціна замовлення"
      ],
      "Summary": [
        "Підсумок"
      ],
      "Title of the order to be shown to the customer": [
        "Назва замовлення, яку буде показано клієнту"
      ],
      "Shipping and fulfillment": [
        "Доставка та виконання"
      ],
      "Delivery date": [
        "Дата доставки"
      ],
      "Deadline for physical delivery assured by the merchant.": [
        "Термін фізичної доставки, гарантований продавцем."
      ],
      "Delivery location": [
        "Дата доставки"
      ],
      "Address where the products will be delivered": [
        "адреса, за якою будуть доставлені продукти"
      ],
      "Fulfillment URL": [
        "URL виконання"
      ],
      "URL to which the user will be redirected after successful payment.": [
        "URL, на який користувача буде перенаправлено після успішної оплати."
      ],
      "Fulfillment message": [
        "URL виконання"
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        "Опції оплати Taler"
      ],
      "Override default Taler payment settings for this order": [
        "Перевизначити стандартні налаштування оплати Taler для цього замовлення"
      ],
      "Payment time": [
        "Тайм-аут оплати"
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        "Термін, до якого клієнт повинен оплатити пропозицію, перш ніж вона закінчиться. Продукти з інвентарю будуть зарезервовані до цього терміну."
      ],
      "Default": [
        "Сума за замовчуванням"
      ],
      "Refund time": [
        "Повернення здійснено"
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        "Час, до якого замовлення може бути повернене продавцем."
      ],
      "Wire transfer time": [
        "Ідентифікатор банківського переказу"
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        "Термін, до якого обмінник повинен здійснити банківський переказ."
      ],
      "Auto-refund time": [
        "Затримка автоматичного повернення"
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        "Час, до якого гаманець автоматично перевірятиме повернення коштів без взаємодії з користувачем."
      ],
      "Maximum fee": [
        "Максимальна комісія за переказ"
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        "Максимальна комісія за депозит, яку продавець готовий покрити для цього замовлення. Вищі комісії за депозит повинні бути повністю покриті споживачем."
      ],
      "Create token": [
        "Створити токен"
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        "Мінімальний вік"
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        "Будь-яке значення більше 0 обмежуватиме монети, які можуть бути використані для оплати цього контракту. Якщо порожнє, вікове обмеження визначатиметься продуктами"
      ],
      "Minimum age defined by the products is %1$s": [
        "Мінімальний вік, визначений продуктами, становить %1$s"
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        "Додаткова інформація"
      ],
      "Custom information to be included in the contract for this order.": [
        "Спеціальна інформація, яка буде включена в контракт для цього замовлення."
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        "Ви повинні ввести значення у форматі JavaScript Object Notation (JSON)."
      ],
      "remove": [
        "Видалити"
      ],
      "Custom field name": [
        "Назва будинку"
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        "Термін повернення"
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        "виберіть дату, щоб показати найближчі замовлення"
      ],
      "Only show unpaid orders": [
        "показувати лише оплачені замовлення"
      ],
      "Only show paid orders": [
        "показувати лише оплачені замовлення"
      ],
      "Paid": [
        "Оплачено"
      ],
      "Only show orders with refunds": [
        "показувати лише замовлення з поверненнями"
      ],
      "Refunded": [
        "Повернено"
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        "Не перераховано"
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "Completed": [
        "Гроші перераховані"
      ],
      "Remove all filters": [
        "видалити всі фільтри"
      ],
      "Clear date filter": [
        "очистити фільтр дати"
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        "перейти до замовлення з зазначеним ідентифікатором"
      ],
      "Order id": [
        "ідентифікатор замовлення"
      ],
      "Instance unknown": [
        "Ідентифікатор інстанції"
      ],
      "Order unknown": [
        "невідомо"
      ],
      "Create order": [
        "створити замовлення"
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        "Дата"
      ],
      "Refund": [
        "Повернення"
      ],
      "copy url": [
        "скопіювати url"
      ],
      "Load more orders after the last one": [
        "завантажити більше переказів після останнього"
      ],
      "No orders have been found matching your query!": [
        "Замовлення, що відповідають вашому запиту, не знайдено!"
      ],
      "Duplicated": [
        "дубльовано"
      ],
      "This value exceeds the refundable amount.": [
        "ця сума перевищує суму, що підлягає поверненню"
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        "повернення"
      ],
      "Reason": [
        "Причина"
      ],
      "Amount to be refunded": [
        "сума до повернення"
      ],
      "Max refundable:": [
        "Макс. сума для повернення:"
      ],
      "Choose one...": [
        "Виберіть одну..."
      ],
      "Requested by the customer": [
        "запитано клієнтом"
      ],
      "Other": [
        "інше"
      ],
      "Why this order is being refunded": [
        "чому це замовлення повертається"
      ],
      "More information to give context": [
        "додаткова інформація для надання контексту"
      ],
      "now": [
        "ні"
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "This wire transfer has been notified by the payment service provider.": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "This refund is waiting to be claimed by the customer.": [
        "Сума, яку має сплатити клієнт"
      ],
      "This refund has been claimed by the customer.": [
        "Сума, яку має сплатити клієнт"
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        "Умови контракту"
      ],
      "Human-readable description of the whole purchase": [
        "читабельний опис всієї покупки"
      ],
      "Total price for the transaction": [
        "загальна ціна за транзакцію"
      ],
      "URL for this purchase": [
        "URL для цієї покупки"
      ],
      "Max fee": [
        "Максимальна комісія"
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        "максимальна загальна комісія за депозит, прийнята продавцем для цього контракту"
      ],
      "Time when this contract was generated": [
        "час, коли цей контракт було згенеровано"
      ],
      "Payment deadline": [
        "Термін оплати"
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        "після цього терміну продавець не прийматиме платежі за контрактом"
      ],
      "Refund deadline": [
        "Термін повернення"
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        "після цього терміну повернення не приймаються"
      ],
      "Wire transfer deadline": [
        "Термін банківського переказу"
      ],
      "Transfer deadline for the exchange": [
        "термін переказу для обмінника"
      ],
      "Time indicating when the order should be delivered": [
        "час, що вказує, коли замовлення має бути доставлене"
      ],
      "Where the order will be delivered": [
        "куди буде доставлене замовлення"
      ],
      "Auto-refund delay": [
        "Затримка автоматичного повернення"
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        "скільки часу гаманець повинен намагатися отримати автоматичне повернення за покупку"
      ],
      "Extra info": [
        "Додаткова інформація"
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        "додаткові дані, які інтерпретуються лише фронтендом продавця"
      ],
      "order created": [
        "Статус замовлення"
      ],
      "pay deadline": [
        "Термін оплати"
      ],
      "refund deadline": [
        "Термін повернення"
      ],
      "delivery": [
        "Дата доставки"
      ],
      "Order": [
        "Замовлення"
      ],
      "Claimed": [
        "отримано"
      ],
      "Claimed at": [
        "отримано о"
      ],
      "Timeline": [
        "Хронологія"
      ],
      "Payment details": [
        "Деталі оплати"
      ],
      "Order status": [
        "Статус замовлення"
      ],
      "Unpaid": [
        "неоплачено"
      ],
      "Product list": [
        "Список продуктів"
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        "повернення успішно створено"
      ],
      "refund created: %1$s: %2$s": [
        "повернення успішно створено"
      ],
      "refund taken: %1$s": [
        "Повернення здійснено"
      ],
      "refund taken: %1$s: %2$s": [
        "Повернення здійснено"
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        "Термін повернення"
      ],
      "Wired": [
        "перераховано"
      ],
      "Refund order": [
        "замовлення на повернення"
      ],
      "Not refundable": [
        "не підлягає поверненню"
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        "Повернена сума"
      ],
      "Refund taken": [
        "Повернення здійснено"
      ],
      "Status URL": [
        "URL статусу"
      ],
      "Refund URI": [
        "URI повернення"
      ],
      "Pay at": [
        "URL для оплати"
      ],
      "Order status URL": [
        "URL статусу замовлення"
      ],
      "Payment URI": [
        "URI оплати"
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        "Невідомий статус замовлення. Це помилка, будь ласка, зв'яжіться з адміністратором."
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        "лише літери та цифри від 2 до 7"
      ],
      "The size of the key must be 32 characters": [
        "розмір ключа повинен бути 32"
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        "Алгоритм перевірки"
      ],
      "Algorithm used to verify transactions in offline mode": [
        "Алгоритм для використання для перевірки транзакції в офлайн-режимі"
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        "згенерувати випадковий секретний ключ"
      ],
      "Random": [
        "випадковий"
      ],
      "Create another": [
        "створити замовлення"
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        "додати новий резерв"
      ],
      "Delete selected devices from the database": [
        "видалити вибраний резерв з бази даних"
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        "Ще немає інстанцій, додайте більше, натиснувши знак +"
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        "Пристрій:"
      ],
      "Algorithm to use to verify transactions in offline mode": [
        "Алгоритм для використання для перевірки транзакції в офлайн-режимі"
      ],
      "Not modified": [
        "Не перераховано"
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        "не співпадає"
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        "Ви оновлюєте токен доступу з інстанції з ідентифікатором %1$s"
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        "Підтвердити зміну"
      ],
      "Testing password change": [
        "Підтвердити зміну"
      ],
      "Password changed": [
        "Підтвердити зміну"
      ],
      "The current password is wrong.": [
        "Встановити токен доступу"
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        "Сервер не знайдено"
      ],
      "Add element to the list": [
        "додати елемент до списку"
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        "натисніть тут, щоб налаштувати запас продукту, залиште як є, і бекенд не буде контролювати запас."
      ],
      "Manage stock": [
        "Керування запасами"
      ],
      "This product has been configured without stock control": [
        "цей продукт налаштований без контролю запасів"
      ],
      "Infinite": [
        "Нескінченний"
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        "втрати не можуть бути більшими за поточні та прибуваючі (макс %1$s)"
      ],
      "Incoming": [
        "Прибуття"
      ],
      "Lost": [
        "Втрачено"
      ],
      "Current": [
        "Поточний"
      ],
      "Remove stock control for this product": [
        "видалити контроль запасів для цього продукту"
      ],
      "without stock": [
        "без запасу"
      ],
      "Next restock": [
        "Наступне поповнення"
      ],
      "Warehouse address": [
        "Адреса рахунку"
      ],
      "Invalid amount": [
        "Фіксована сума"
      ],
      "Product identification to use in URLs (for internal use only).": [
        "ідентифікація продукту для використання в URL (тільки для внутрішнього використання)."
      ],
      "Illustration of the product for customers.": [
        "ілюстрація продукту для клієнтів."
      ],
      "Product name.": [
        "Продукт"
      ],
      "Product description for customers.": [
        "опис продукту для клієнтів."
      ],
      "Age restriction": [
        "Обмежений за віком"
      ],
      "Is this product restricted for customer below certain age?": [
        "цей продукт обмежений для клієнтів молодше певного віку?"
      ],
      "Minimum age of the customer": [
        "Мінімальний вік"
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        "одиниця, що описує кількість проданого продукту (наприклад, 2 кілограми, 5 літрів, 3 предмети, 5 метрів) для клієнтів."
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        "ціна продажу для клієнтів, включаючи податки, за вищезазначені одиниці продукту."
      ],
      "Stock": [
        "Запас"
      ],
      "Inventory for products with finite supply (for internal use only).": [
        "інвентаризація продукту для продуктів з обмеженим запасом (тільки для внутрішнього використання)"
      ],
      "Taxes included in the product price, exposed to customers.": [
        "податки, включені в ціну продукту, показані клієнтам"
      ],
      "Search by category description or id": [
        "шукати продукти за їхнім описом або ідентифікатором"
      ],
      "Categories where this product will be listed on.": [
        "адреса, за якою будуть доставлені продукти."
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        "шукати продукти за їхнім описом або ідентифікатором"
      ],
      "Money pots where this product will be listed on.": [
        "адреса, за якою будуть доставлені продукти."
      ],
      "Select one": [
        "Виберіть один рахунок"
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        "шукати продукти за їхнім описом або ідентифікатором"
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        "додати продукт до інвентарю"
      ],
      "Product not found.": [
        "Сервер не знайдено"
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        "Продано"
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        "перейти на сторінку оновлення продукту"
      ],
      "Update": [
        "Оновити"
      ],
      "Remove this product from the database": [
        "видалити цей продукт з бази даних"
      ],
      "Update the product with new price": [
        "оновити продукт з новою ціною"
      ],
      "Update product with new price": [
        "оновити продукт з новою ціною"
      ],
      "Confirm update": [
        "Підтверджено"
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        "втрати не можуть бути більшими за поточні та прибуваючі (макс %1$s)"
      ],
      "Add more elements to the inventory": [
        "додати більше елементів до інвентарю"
      ],
      "Report elements lost in the inventory": [
        "повідомити про втрату елементів в інвентарі"
      ],
      "New price for the product": [
        "нова ціна для продукту"
      ],
      "There are values with errors.": [
        "є значення з помилками"
      ],
      "Update product with new stock and price": [
        "оновити продукт з новим запасом і ціною"
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        "Продуктів ще немає, додайте більше, натиснувши знак +"
      ],
      "Product (ID: %1$s) has been deleted": [
        "Продукт (ID: %1$s) оновлено"
      ],
      "Jump to product with the given product ID": [
        "перейти до замовлення з зазначеним ідентифікатором"
      ],
      "Product id": [
        "Ідентифікатор продукту"
      ],
      "Delete product": [
        "Видалено"
      ],
      "Delete the product \"%1$s\"": [
        "не вдалося видалити продукт"
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        "Ідентифікатор продукту:"
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        "Замовлення"
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        "Статус замовлення"
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        "Статус замовлення"
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        "Ціна замовлення"
      ],
      "hour": [
        "години"
      ],
      "day": [
        "дні"
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        "видалити всі фільтри"
      ],
      "Time range": [
        "Хронологія"
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        "Поточний"
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        "Тайм-аут оплати"
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        "має бути більше 0"
      ],
      "Too short": [
        "занадто короткий"
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        "Ідентифікатор"
      ],
      "Name of the template in URLs.": [
        "Назва шаблону в URL."
      ],
      "Template name": [
        "Шаблони"
      ],
      "Describe what this template stands for": [
        "Опишіть, що представляє цей шаблон"
      ],
      "Order summary": [
        "Підсумок замовлення"
      ],
      "If specified here, this template will create orders with the same summary": [
        "Якщо вказано, цей шаблон створить замовлення з однаковим підсумком"
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        "Якщо вказано, цей шаблон створить замовлення з однаковою ціною"
      ],
      "Amount is editable": [
        "Зарахована сума"
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        "Мінімальний вік"
      ],
      "Is this contract restricted to some age?": [
        "Чи обмежений цей контракт за віком?"
      ],
      "Payment timeout": [
        "Тайм-аут оплати"
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        "Скільки часу у клієнта для завершення оплати після створення замовлення."
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        "Алгоритм для використання для перевірки транзакції в офлайн-режимі."
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        "додати нові шаблони"
      ],
      "Load more templates before the first one": [
        "завантажити більше шаблонів до першого"
      ],
      "Delete selected templates from the database": [
        "видалити вибрані шаблони з бази даних"
      ],
      "Use template to create new order": [
        "використовувати шаблон для створення нового замовлення"
      ],
      "Generate a QR code for the template.": [
        "створити QR-код для шаблону."
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        "завантажити більше шаблонів після останнього"
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        "Шаблонів ще немає, додайте більше, натиснувши знак +"
      ],
      "Jump to template with the given template ID": [
        "перейти до замовлення з зазначеним ідентифікатором"
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        "додати нові шаблони"
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        "завантажити новіші шаблони"
      ],
      "Print": [
        "Друк"
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        "Якщо вказано, цей шаблон створить замовлення з однаковим підсумком"
      ],
      "If specified, this template will create orders with the same price": [
        "Якщо вказано, цей шаблон створить замовлення з однаковою ціною"
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        "Скільки часу у клієнта для завершення оплати після створення замовлення."
      ],
      "An amount is required": [
        "Сума обов'язкова"
      ],
      "An order summary is required": [
        "Підсумок замовлення обов'язковий"
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        "Нове замовлення для шаблону"
      ],
      "Amount of the order": [
        "Сума замовлення"
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        "ідентифікація продукту для використання в URL (тільки для внутрішнього використання)"
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        "Тайм-аут оплати"
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        "Закінчується о"
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        "недійсний формат"
      ],
      "Go to token family update page": [
        "перейти на сторінку оновлення продукту"
      ],
      "Remove this token family from the database": [
        "видалити цей продукт з бази даних"
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        "Шаблонів ще немає, додайте більше, натиснувши знак +."
      ],
      "Token family has been deleted.": [
        "Сімейство токенів \"%1$s\" (SLUG: %2$s) видалено"
      ],
      "Delete token family": [
        "Не вдалося видалити сімейство токенів"
      ],
      "Delete the token family \"%1$s\"": [
        "Видалення сімейства токенів %1$s ."
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        "Якщо ви видалите сімейство токенів %1$s (Slug: %2$s), всі випущені токени стануть недійсними."
      ],
      "Deleting a token family %1$s .": [
        "Видалення сімейства токенів %1$s ."
      ],
      "can't be undone": [
        "не може бути порожнім"
      ],
      "Token Family: %1$s": [
        "Сімейство токенів: %1$s"
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        "опис продукту для клієнтів"
      ],
      "Incoming wire transfers": [
        "Ідентифікатор банківського переказу"
      ],
      "Load more wire transfers preceding the first one": [
        "завантажити більше переказів до першого"
      ],
      "Expected credit": [
        "Очікуваний баланс"
      ],
      "Confirmed": [
        "Підтверджено"
      ],
      "Validated": [
        "Дійсний до"
      ],
      "Executed on": [
        "Виконано о"
      ],
      "yes": [
        "так"
      ],
      "no": [
        "ні"
      ],
      "never": [
        "ніколи"
      ],
      "unknown": [
        "невідомо"
      ],
      "Load more transfers after the last one": [
        "завантажити більше переказів після останнього"
      ],
      "Verified wire transfers": [
        "Ідентифікатор банківського переказу"
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        "Переказів ще немає, додайте більше, натиснувши знак +"
      ],
      "All accounts": [
        "Рахунок"
      ],
      "Filter by account address": [
        "фільтрувати за адресою рахунку"
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        "показувати лише замовлення, де клієнти заплатили, але банківські перекази від постачальника платежів ще не виконані"
      ],
      "Only show wire transfers confirmed by the merchant": [
        "показувати лише перекази, підтверджені продавцем"
      ],
      "Verified": [
        "Перевірено"
      ],
      "Wire transfer already confirmed.": [
        "Термін банківського переказу"
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        "підтвердити той самий токен доступу"
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        "Хронологія"
      ],
      "Transfer ID": [
        "Перекази"
      ],
      "It's not the same.": [
        "не співпадає"
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        "Ви оновлюєте токен доступу з інстанції з ідентифікатором %1$s"
      ],
      "Instance": [
        "Інстанція"
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        "Очистити"
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        "Ідентифікатор інстанції"
      ],
      "Delete this instance": [
        "Не вдалося видалити інстанцію"
      ],
      "Must be one of '%1$s'": [
        "повинно бути одним із '%1$s'"
      ],
      "URL is invalid": [
        "недійсний"
      ],
      "Webhook ID to use": [
        "ID вебхука для використання"
      ],
      "Event": [
        "Подія"
      ],
      "Payment": [
        "URI оплати"
      ],
      "Order settled": [
        "Статус замовлення"
      ],
      "Category added": [
        "шаблон успішно видалено"
      ],
      "Category updated": [
        "Підтверджено"
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        "ID вебхука для використання"
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        "Подія вебхука: чому використовується вебхук"
      ],
      "Method": [
        "Метод"
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        "Метод, що використовується вебхуком"
      ],
      "URL": [
        "URL"
      ],
      "URL of the webhook where the customer will be redirected": [
        "URL вебхука, куди буде перенаправлений клієнт"
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        "опис"
      ],
      "order's price": [
        "Ціна замовлення"
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        "сума до повернення"
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        "Заголовок"
      ],
      "Header template of the webhook": [
        "Шаблон заголовка вебхука"
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        "Шаблон тіла вебхука"
      ],
      "Webhook deleted successfully": [
        "вебхук успішно видалено"
      ],
      "Add new webhooks": [
        "додати нові вебхуки"
      ],
      "Load more webhooks before the first one": [
        "завантажити більше вебхуків до першого"
      ],
      "Event type": [
        "Тип події"
      ],
      "Delete selected webhook from the database": [
        "видалити вибраний вебхук з бази даних"
      ],
      "Load more webhooks after the last one": [
        "завантажити більше вебхуків після останнього"
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        "Вебхуків ще немає, додайте більше, натиснувши знак +"
      ],
      "Webhook updated": [
        "ID вебхука для використання"
      ],
      "Header": [
        "Заголовок"
      ],
      "Body": [
        "Тіло"
      ],
      "Body template used by the webhook": [
        "Шаблон тіла вебхука"
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        "Контактний email"
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        "Створено о"
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        "замовлення не знайдено"
      ],
      "Resetting access to the instance \"%1$s\"": [
        "Ви встановлюєте токен доступу для нової інстанції"
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        "недійсний формат"
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        "Тип події"
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        "шаблон успішно видалено"
      ],
      "Add new pots": [
        "додати нові шаблони"
      ],
      "Load more pots before the first one": [
        "завантажити більше шаблонів до першого"
      ],
      "Total": [
        "Загальна ціна"
      ],
      "Delete selected pots from the database": [
        "видалити вибраний переказ з бази даних"
      ],
      "Load more pots after the last one": [
        "завантажити більше шаблонів після останнього"
      ],
      "There are no money pots yet, add more pressing the + sign": [
        "Продуктів ще немає, додайте більше, натиснувши знак +"
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        "змінити значення на ніколи"
      ],
      "Invalid amount \"%1$s\": %2$s": [
        "Фіксована сума"
      ],
      "Descripton": [
        "Опис"
      ],
      "Totals": [
        "Загальна ціна"
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        "Список продуктів"
      ],
      "Add new group": [
        "Зарахований банківський рахунок"
      ],
      "Load more groups before the first one": [
        "завантажити більше вебхуків до першого"
      ],
      "Delete selected group from the database": [
        "видалити вибраний переказ з бази даних"
      ],
      "Load more groups after the last one": [
        "завантажити більше шаблонів після останнього"
      ],
      "There are no product groups yet, add more pressing the + sign": [
        "Продуктів ще немає, додайте більше, натиснувши знак +"
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        "додати нові шаблони"
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        "видалити вибраний переказ з бази даних"
      ],
      "There are no reports yet, add more pressing the + sign": [
        "Шаблонів ще немає, додайте більше, натиснувши знак +"
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        "Назва категорії"
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        "URI, що вказує на банківський рахунок для зарахування доходу."
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        "Сховати на сьогодні"
      ],
      "KYC verification needed": [
        "Очікування перевірки KYC"
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        "Несподівана помилка"
      ],
      "Unexpected error.": [
        "Несподівана помилка"
      ],
      "Add new instance": [
        "додати нову інстанцію"
      ],
      "Edit": [
        "Редагувати"
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        "Ще немає інстанцій, додайте більше, натиснувши знак +"
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        "Інстанція \"%1$s\" (ID: %2$s) була видалена"
      ],
      "Only show active instances": [
        "Показувати тільки активні інстанції"
      ],
      "Active": [
        "Активні"
      ],
      "Only show deleted instances": [
        "Показувати тільки видалені інстанції"
      ],
      "Deleted": [
        "Видалено"
      ],
      "Show all instances": [
        "Показати всі інстанції"
      ],
      "Delete instance": [
        "Не вдалося видалити інстанцію"
      ],
      "Delete the instance \"%1$s\"": [
        "завантажити новіші шаблони"
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        "завантажити новіші шаблони"
      ],
      "This cannot be undone!": [
        "не може бути порожнім"
      ],
      "Purge the instance": [
        "Не вдалося видалити інстанцію"
      ],
      "Purge the instance \"%1$s\"": [
        "Ви встановлюєте токен доступу для нової інстанції"
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        "Не вдалося підключитися до сервера."
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        "Назва бізнесу"
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        "Налаштування"
      ],
      "title\u0004%1$s: New bank account": [
        "Банківський рахунок"
      ],
      "title\u0004%1$s: Bank accounts": [
        "Банківський рахунок"
      ],
      "title\u0004%1$s: Update bank Account": [
        "Перевірка дійсності банківського рахунку: %1$s"
      ],
      "title\u0004%1$s: Orders": [
        "Замовлення"
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        "не вдалося оновити продукт"
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        "не вдалося оновити шаблон"
      ],
      "title\u0004%1$s: Wire transfers": [
        "Ідентифікатор банківського переказу"
      ],
      "title\u0004%1$s: Webhooks": [
        "Вебхуки"
      ],
      "title\u0004%1$s: New webhook": [
        "додати нові вебхуки"
      ],
      "title\u0004%1$s: Update webhook": [
        "не вдалося видалити вебхук"
      ],
      "title\u0004%1$s: OTP devices": [
        "додати новий резерв"
      ],
      "title\u0004%1$s: New OTP device": [
        "додати новий резерв"
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        "додати нові шаблони"
      ],
      "title\u0004%1$s: Update template": [
        "додати нові шаблони"
      ],
      "title\u0004%1$s: Templates": [
        "Шаблони"
      ],
      "title\u0004%1$s: Use template": [
        "додати нові шаблони"
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        "Не вдалося оновити сімейство токенів"
      ],
      "title\u0004%1$s: Access tokens": [
        "Токен доступу"
      ],
      "title\u0004%1$s: New access token": [
        "Новий токен доступу"
      ],
      "title\u0004New instance": [
        "додати нову інстанцію"
      ],
      "title\u0004Instances": [
        "Інстанції"
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
  "lang": "uk",
  "completeness": 62
};

strings['tr'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=n != 1;",
        "lang": "tr"
      },
      "Cancel": [
        "İptal"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        ""
      ],
      "Continue": [
        ""
      ],
      "Clear": [
        ""
      ],
      "Confirm": [
        ""
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        ""
      ],
      "Host": [
        ""
      ],
      "Account ID": [
        "Hesap"
      ],
      "The account owner's legal name": [
        ""
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        "Kasaba"
      ],
      "Bank host": [
        "Banka hesabı"
      ],
      "Bank account": [
        "Banka hesabı"
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        ""
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        "Konu"
      ],
      "Receiver postal code": [
        "Teslim tarihi"
      ],
      "Receiver town": [
        "Teslim tarihi"
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        ""
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        ""
      ],
      "days": [
        ""
      ],
      "hours": [
        ""
      ],
      "minutes": [
        ""
      ],
      "seconds": [
        ""
      ],
      "Forever": [
        ""
      ],
      "%1$sM": [
        ""
      ],
      "%1$sY": [
        ""
      ],
      "%1$sd": [
        ""
      ],
      "%1$sh": [
        ""
      ],
      "%1$smin": [
        ""
      ],
      "%1$ssec": [
        ""
      ],
      "Change value to never": [
        ""
      ],
      "Change value to empty": [
        ""
      ],
      "Image must be smaller than 1 MB": [
        ""
      ],
      "Add": [
        ""
      ],
      "Remove": [
        ""
      ],
      "Country": [
        "Ülke"
      ],
      "Building number": [
        "Bina numarası"
      ],
      "Building name": [
        "Bina adı"
      ],
      "Street": [
        "Sokak"
      ],
      "Post code": [
        "Posta kodu"
      ],
      "Town location": [
        "Kasaba konumu"
      ],
      "District": [
        "Semt"
      ],
      "Country subdivision": [
        ""
      ],
      "Additional address lines": [
        ""
      ],
      "Orders": [
        ""
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        ""
      ],
      "Templates": [
        ""
      ],
      "Product groups": [
        "Ürünler"
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        ""
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        ""
      ],
      "Settings": [
        ""
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        ""
      ],
      "Connection": [
        ""
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        ""
      ],
      "New": [
        ""
      ],
      "List": [
        ""
      ],
      "Log out": [
        ""
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        ""
      ],
      "Business name": [
        ""
      ],
      "Legal name of the business represented by this instance.": [
        ""
      ],
      "Email": [
        ""
      ],
      "Contact email": [
        ""
      ],
      "Phone number": [
        ""
      ],
      "Contact phone": [
        ""
      ],
      "Website URL": [
        ""
      ],
      "URL.": [
        ""
      ],
      "Logo": [
        ""
      ],
      "Logo image.": [
        ""
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        ""
      ],
      "Jurisdiction": [
        ""
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        ""
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        "Hesap"
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        ""
      ],
      "Refund delay": [
        ""
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        ""
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        ""
      ],
      "Wire transfer rounding": [
        ""
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        ""
      ],
      "To second": [
        ""
      ],
      "To minute": [
        ""
      ],
      "To hour": [
        ""
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        ""
      ],
      "Required": [
        ""
      ],
      "Unauthorized": [
        ""
      ],
      "The code is not correct.": [
        ""
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        ""
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        ""
      ],
      "Verify": [
        ""
      ],
      "Failed to send the verification code.": [
        ""
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Login required": [
        ""
      ],
      "Instance name.": [
        ""
      ],
      "Instance password.": [
        ""
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        "Banka hesabı"
      ],
      "Invalid": [
        ""
      ],
      "Doesn't have the pattern of an email": [
        ""
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        "Geçerlilik"
      ],
      "Max 7 lines": [
        ""
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        ""
      ],
      "Unauthorized.": [
        ""
      ],
      "Conflict.": [
        ""
      ],
      "Not found.": [
        ""
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        ""
      ],
      "Repeat password": [
        ""
      ],
      "Confirm the same password": [
        ""
      ],
      "Please complete the marked fields and choose authorization method": [
        ""
      ],
      "Confirm operation": [
        "Kasaba konumu"
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        ""
      ],
      "Description": [
        ""
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        ""
      ],
      "Time the access token will be valid.": [
        ""
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        ""
      ],
      "Read only": [
        ""
      ],
      "All": [
        ""
      ],
      "Order simple": [
        ""
      ],
      "Order Point-of-Sale": [
        ""
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        ""
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        ""
      ],
      "Please complete the marked fields": [
        ""
      ],
      "Access token created": [
        ""
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        ""
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        ""
      ],
      "Create access token": [
        "Oluşturulma"
      ],
      "Load more devices before the first one": [
        ""
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        "Oluşturulma"
      ],
      "Expires at": [
        ""
      ],
      "Never": [
        ""
      ],
      "Remove this access token": [
        ""
      ],
      "Delete": [
        ""
      ],
      "Load more devices after the last one": [
        ""
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        ""
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        "Oluşturulma"
      ],
      "Deleting an access token cannot be undone.": [
        ""
      ],
      "This is not a valid Bitcoin address.": [
        ""
      ],
      "This is not a valid Ethereum address.": [
        ""
      ],
      "This is not a valid host.": [
        ""
      ],
      "IBANs usually have more than 4 digits.": [
        ""
      ],
      "IBANs usually have fewer than 34 digits.": [
        ""
      ],
      "The IBAN's country code could not be retrieved.": [
        ""
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        ""
      ],
      "This account is not allowed.": [
        ""
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        ""
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        ""
      ],
      "Routing": [
        ""
      ],
      "Routing number": [
        "Bina numarası"
      ],
      "Account": [
        "Hesap"
      ],
      "Account number": [
        "Hesap"
      ],
      "Code": [
        ""
      ],
      "Business Identifier Code": [
        ""
      ],
      "International Bank Account Number": [
        ""
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        ""
      ],
      "Bitcoin protocol": [
        ""
      ],
      "Ethereum protocol": [
        ""
      ],
      "Interledger protocol": [
        ""
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        "Hesap"
      ],
      "Name of the account holder": [
        ""
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        ""
      ],
      "Invalid url": [
        "Geçerlilik"
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        ""
      ],
      "Server replied with \"bad request\".": [
        ""
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        "Hesap:"
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        ""
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        ""
      ],
      "Do not change": [
        ""
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        ""
      ],
      "Account details": [
        "Hesap"
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        ""
      ],
      "Delete account": [
        "Oluşturulma"
      ],
      "Delete the account \"%1$s\"": [
        "Banka hesabı"
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        ""
      ],
      "Bank accounts": [
        "Banka hesabı"
      ],
      "Add new account": [
        "Banka hesabı"
      ],
      "Owner's name": [
        ""
      ],
      "Delete selected accounts from the database": [
        ""
      ],
      "There are no accounts yet, add more pressing the + sign": [
        ""
      ],
      "You must provide a bank account to receive payments.": [
        ""
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        ""
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        ""
      ],
      "Add new devices": [
        ""
      ],
      "ID": [
        ""
      ],
      "Total products": [
        "Ürünler"
      ],
      "Delete selected category from the database": [
        ""
      ],
      "There are no categories yet, add more pressing the + sign": [
        ""
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        ""
      ],
      "Products": [
        "Ürünler"
      ],
      "Image": [
        ""
      ],
      "Load more products after the last one": [
        ""
      ],
      "There are no products in this category.": [
        ""
      ],
      "Account's KYC status": [
        "Hesap"
      ],
      "Exchange": [
        ""
      ],
      "Status": [
        ""
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        ""
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        ""
      ],
      "More information required.": [
        ""
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        ""
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        ""
      ],
      "The account for wire transfers does not appear to be valid": [
        ""
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        ""
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        ""
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        ""
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        ""
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        ""
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        ""
      ],
      "Enter description or id": [
        ""
      ],
      "No match found for that description or ID.": [
        ""
      ],
      "You must enter a valid product identifier.": [
        ""
      ],
      "Quantity must be greater than 0!": [
        ""
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        ""
      ],
      "Search product": [
        ""
      ],
      "Quantity": [
        ""
      ],
      "How many products will be added": [
        ""
      ],
      "Add from inventory": [
        ""
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        ""
      ],
      "Amount": [
        "Miktar"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        ""
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        ""
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        ""
      ],
      "Add tax to the tax list": [
        ""
      ],
      "Describe and add a product that is not in the inventory list": [
        ""
      ],
      "Add custom product": [
        ""
      ],
      "Complete information of the product": [
        ""
      ],
      "Must be a number.": [
        ""
      ],
      "Must be greater than 0.": [
        ""
      ],
      "Photo of the product.": [
        ""
      ],
      "Full product description.": [
        ""
      ],
      "Unit name": [
        ""
      ],
      "Name of the product unit.": [
        ""
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        ""
      ],
      "How many products will be added.": [
        ""
      ],
      "Taxes": [
        ""
      ],
      "Total price": [
        "Ürünler"
      ],
      "Must be greater than 0": [
        ""
      ],
      "Must have a refund deadline": [
        ""
      ],
      "Auto refund can't be after refund deadline": [
        ""
      ],
      "Must be in the future": [
        ""
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        ""
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        ""
      ],
      "%1$s products with a total price of %2$s.": [
        ""
      ],
      "Manage list of products in the order.": [
        ""
      ],
      "Remove this product from the order.": [
        ""
      ],
      "Products price sum": [
        "Ürünler"
      ],
      "Total product price added up": [
        "Ürünler"
      ],
      "Order price": [
        ""
      ],
      "Amount to be paid by the customer": [
        ""
      ],
      "Final order price": [
        ""
      ],
      "Summary": [
        ""
      ],
      "Title of the order to be shown to the customer": [
        ""
      ],
      "Shipping and fulfillment": [
        ""
      ],
      "Delivery date": [
        ""
      ],
      "Deadline for physical delivery assured by the merchant.": [
        ""
      ],
      "Delivery location": [
        "Kasaba konumu"
      ],
      "Address where the products will be delivered": [
        ""
      ],
      "Fulfillment URL": [
        ""
      ],
      "URL to which the user will be redirected after successful payment.": [
        ""
      ],
      "Fulfillment message": [
        ""
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        ""
      ],
      "Override default Taler payment settings for this order": [
        ""
      ],
      "Payment time": [
        ""
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        ""
      ],
      "Default": [
        ""
      ],
      "Refund time": [
        ""
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        ""
      ],
      "Wire transfer time": [
        ""
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        ""
      ],
      "Auto-refund time": [
        ""
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        ""
      ],
      "Maximum fee": [
        ""
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        ""
      ],
      "Create token": [
        "Oluşturulma"
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        ""
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        ""
      ],
      "Minimum age defined by the products is %1$s": [
        ""
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        ""
      ],
      "Custom information to be included in the contract for this order.": [
        ""
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        ""
      ],
      "remove": [
        ""
      ],
      "Custom field name": [
        "Bina adı"
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        ""
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        ""
      ],
      "Only show unpaid orders": [
        ""
      ],
      "Only show paid orders": [
        ""
      ],
      "Paid": [
        ""
      ],
      "Only show orders with refunds": [
        ""
      ],
      "Refunded": [
        ""
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        ""
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        ""
      ],
      "Completed": [
        ""
      ],
      "Remove all filters": [
        ""
      ],
      "Clear date filter": [
        ""
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        ""
      ],
      "Order id": [
        ""
      ],
      "Instance unknown": [
        ""
      ],
      "Order unknown": [
        ""
      ],
      "Create order": [
        "Oluşturulma"
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        ""
      ],
      "Refund": [
        ""
      ],
      "copy url": [
        ""
      ],
      "Load more orders after the last one": [
        ""
      ],
      "No orders have been found matching your query!": [
        ""
      ],
      "Duplicated": [
        ""
      ],
      "This value exceeds the refundable amount.": [
        ""
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        ""
      ],
      "Reason": [
        ""
      ],
      "Amount to be refunded": [
        ""
      ],
      "Max refundable:": [
        ""
      ],
      "Choose one...": [
        ""
      ],
      "Requested by the customer": [
        ""
      ],
      "Other": [
        ""
      ],
      "Why this order is being refunded": [
        ""
      ],
      "More information to give context": [
        ""
      ],
      "now": [
        ""
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        ""
      ],
      "This wire transfer has been notified by the payment service provider.": [
        ""
      ],
      "This refund is waiting to be claimed by the customer.": [
        ""
      ],
      "This refund has been claimed by the customer.": [
        ""
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        ""
      ],
      "Human-readable description of the whole purchase": [
        ""
      ],
      "Total price for the transaction": [
        ""
      ],
      "URL for this purchase": [
        ""
      ],
      "Max fee": [
        ""
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        ""
      ],
      "Time when this contract was generated": [
        ""
      ],
      "Payment deadline": [
        ""
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        ""
      ],
      "Refund deadline": [
        ""
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        ""
      ],
      "Wire transfer deadline": [
        ""
      ],
      "Transfer deadline for the exchange": [
        ""
      ],
      "Time indicating when the order should be delivered": [
        ""
      ],
      "Where the order will be delivered": [
        ""
      ],
      "Auto-refund delay": [
        ""
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        ""
      ],
      "Extra info": [
        ""
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        ""
      ],
      "order created": [
        ""
      ],
      "pay deadline": [
        ""
      ],
      "refund deadline": [
        ""
      ],
      "delivery": [
        ""
      ],
      "Order": [
        ""
      ],
      "Claimed": [
        ""
      ],
      "Claimed at": [
        "Oluşturulma"
      ],
      "Timeline": [
        ""
      ],
      "Payment details": [
        "Hesap"
      ],
      "Order status": [
        ""
      ],
      "Unpaid": [
        ""
      ],
      "Product list": [
        "Ürünler"
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        ""
      ],
      "refund created: %1$s: %2$s": [
        ""
      ],
      "refund taken: %1$s": [
        ""
      ],
      "refund taken: %1$s: %2$s": [
        ""
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        ""
      ],
      "Wired": [
        ""
      ],
      "Refund order": [
        ""
      ],
      "Not refundable": [
        ""
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        ""
      ],
      "Refund taken": [
        ""
      ],
      "Status URL": [
        ""
      ],
      "Refund URI": [
        ""
      ],
      "Pay at": [
        ""
      ],
      "Order status URL": [
        ""
      ],
      "Payment URI": [
        ""
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        ""
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        ""
      ],
      "The size of the key must be 32 characters": [
        ""
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        ""
      ],
      "Algorithm used to verify transactions in offline mode": [
        ""
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        ""
      ],
      "Random": [
        ""
      ],
      "Create another": [
        "Oluşturulma"
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        ""
      ],
      "Delete selected devices from the database": [
        ""
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        ""
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        ""
      ],
      "Algorithm to use to verify transactions in offline mode": [
        ""
      ],
      "Not modified": [
        ""
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        ""
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        ""
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        "Kasaba konumu"
      ],
      "Testing password change": [
        ""
      ],
      "Password changed": [
        ""
      ],
      "The current password is wrong.": [
        ""
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        "Hesap"
      ],
      "Add element to the list": [
        ""
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        ""
      ],
      "Manage stock": [
        ""
      ],
      "This product has been configured without stock control": [
        ""
      ],
      "Infinite": [
        ""
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        ""
      ],
      "Incoming": [
        ""
      ],
      "Lost": [
        ""
      ],
      "Current": [
        ""
      ],
      "Remove stock control for this product": [
        ""
      ],
      "without stock": [
        ""
      ],
      "Next restock": [
        ""
      ],
      "Warehouse address": [
        ""
      ],
      "Invalid amount": [
        "Geçerlilik"
      ],
      "Product identification to use in URLs (for internal use only).": [
        ""
      ],
      "Illustration of the product for customers.": [
        ""
      ],
      "Product name.": [
        "Ürünler"
      ],
      "Product description for customers.": [
        ""
      ],
      "Age restriction": [
        ""
      ],
      "Is this product restricted for customer below certain age?": [
        ""
      ],
      "Minimum age of the customer": [
        ""
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        ""
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        ""
      ],
      "Stock": [
        ""
      ],
      "Inventory for products with finite supply (for internal use only).": [
        ""
      ],
      "Taxes included in the product price, exposed to customers.": [
        ""
      ],
      "Search by category description or id": [
        ""
      ],
      "Categories where this product will be listed on.": [
        ""
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        ""
      ],
      "Money pots where this product will be listed on.": [
        ""
      ],
      "Select one": [
        ""
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        ""
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        ""
      ],
      "Product not found.": [
        ""
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        ""
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        ""
      ],
      "Update": [
        ""
      ],
      "Remove this product from the database": [
        ""
      ],
      "Update the product with new price": [
        ""
      ],
      "Update product with new price": [
        ""
      ],
      "Confirm update": [
        "Kasaba konumu"
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        ""
      ],
      "Add more elements to the inventory": [
        ""
      ],
      "Report elements lost in the inventory": [
        ""
      ],
      "New price for the product": [
        ""
      ],
      "There are values with errors.": [
        ""
      ],
      "Update product with new stock and price": [
        ""
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        ""
      ],
      "Product (ID: %1$s) has been deleted": [
        ""
      ],
      "Jump to product with the given product ID": [
        ""
      ],
      "Product id": [
        "Ürünler"
      ],
      "Delete product": [
        "Ürünler"
      ],
      "Delete the product \"%1$s\"": [
        ""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        "Ürünler"
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        ""
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        ""
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        ""
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        ""
      ],
      "hour": [
        ""
      ],
      "day": [
        ""
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        ""
      ],
      "Time range": [
        ""
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        ""
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        ""
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        ""
      ],
      "Too short": [
        ""
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        ""
      ],
      "Name of the template in URLs.": [
        ""
      ],
      "Template name": [
        ""
      ],
      "Describe what this template stands for": [
        ""
      ],
      "Order summary": [
        ""
      ],
      "If specified here, this template will create orders with the same summary": [
        ""
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        ""
      ],
      "Amount is editable": [
        "Hesap"
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        ""
      ],
      "Is this contract restricted to some age?": [
        ""
      ],
      "Payment timeout": [
        ""
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        ""
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        ""
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        "Banka hesabı"
      ],
      "Load more templates before the first one": [
        ""
      ],
      "Delete selected templates from the database": [
        ""
      ],
      "Use template to create new order": [
        ""
      ],
      "Generate a QR code for the template.": [
        ""
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        ""
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        ""
      ],
      "Jump to template with the given template ID": [
        ""
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        ""
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        ""
      ],
      "Print": [
        ""
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        ""
      ],
      "If specified, this template will create orders with the same price": [
        ""
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        ""
      ],
      "An amount is required": [
        ""
      ],
      "An order summary is required": [
        ""
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        ""
      ],
      "Amount of the order": [
        ""
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        ""
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        ""
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        ""
      ],
      "Go to token family update page": [
        ""
      ],
      "Remove this token family from the database": [
        ""
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        ""
      ],
      "Token family has been deleted.": [
        ""
      ],
      "Delete token family": [
        "Oluşturulma"
      ],
      "Delete the token family \"%1$s\"": [
        ""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        ""
      ],
      "Deleting a token family %1$s .": [
        ""
      ],
      "can't be undone": [
        ""
      ],
      "Token Family: %1$s": [
        ""
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        ""
      ],
      "Incoming wire transfers": [
        ""
      ],
      "Load more wire transfers preceding the first one": [
        ""
      ],
      "Expected credit": [
        ""
      ],
      "Confirmed": [
        "Kasaba konumu"
      ],
      "Validated": [
        ""
      ],
      "Executed on": [
        ""
      ],
      "yes": [
        ""
      ],
      "no": [
        ""
      ],
      "never": [
        ""
      ],
      "unknown": [
        ""
      ],
      "Load more transfers after the last one": [
        ""
      ],
      "Verified wire transfers": [
        ""
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        ""
      ],
      "All accounts": [
        "Hesap"
      ],
      "Filter by account address": [
        ""
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        ""
      ],
      "Only show wire transfers confirmed by the merchant": [
        ""
      ],
      "Verified": [
        ""
      ],
      "Wire transfer already confirmed.": [
        ""
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        ""
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        ""
      ],
      "Transfer ID": [
        ""
      ],
      "It's not the same.": [
        ""
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        ""
      ],
      "Instance": [
        ""
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        ""
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        ""
      ],
      "Delete this instance": [
        ""
      ],
      "Must be one of '%1$s'": [
        ""
      ],
      "URL is invalid": [
        ""
      ],
      "Webhook ID to use": [
        ""
      ],
      "Event": [
        ""
      ],
      "Payment": [
        ""
      ],
      "Order settled": [
        ""
      ],
      "Category added": [
        ""
      ],
      "Category updated": [
        ""
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        ""
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        ""
      ],
      "Method": [
        ""
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        ""
      ],
      "URL": [
        ""
      ],
      "URL of the webhook where the customer will be redirected": [
        ""
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        ""
      ],
      "order's price": [
        ""
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        ""
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        ""
      ],
      "Header template of the webhook": [
        ""
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        ""
      ],
      "Webhook deleted successfully": [
        ""
      ],
      "Add new webhooks": [
        ""
      ],
      "Load more webhooks before the first one": [
        ""
      ],
      "Event type": [
        ""
      ],
      "Delete selected webhook from the database": [
        ""
      ],
      "Load more webhooks after the last one": [
        ""
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        ""
      ],
      "Webhook updated": [
        ""
      ],
      "Header": [
        ""
      ],
      "Body": [
        ""
      ],
      "Body template used by the webhook": [
        ""
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        ""
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        "Oluşturulma"
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        ""
      ],
      "Resetting access to the instance \"%1$s\"": [
        ""
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        ""
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        ""
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        ""
      ],
      "Add new pots": [
        "Banka hesabı"
      ],
      "Load more pots before the first one": [
        ""
      ],
      "Total": [
        "Ürünler"
      ],
      "Delete selected pots from the database": [
        ""
      ],
      "Load more pots after the last one": [
        ""
      ],
      "There are no money pots yet, add more pressing the + sign": [
        ""
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        ""
      ],
      "Invalid amount \"%1$s\": %2$s": [
        "Geçerlilik"
      ],
      "Descripton": [
        ""
      ],
      "Totals": [
        "Ürünler"
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        "Ürünler"
      ],
      "Add new group": [
        "Banka hesabı"
      ],
      "Load more groups before the first one": [
        ""
      ],
      "Delete selected group from the database": [
        ""
      ],
      "Load more groups after the last one": [
        ""
      ],
      "There are no product groups yet, add more pressing the + sign": [
        ""
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        "Banka hesabı"
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        ""
      ],
      "There are no reports yet, add more pressing the + sign": [
        ""
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        ""
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        ""
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        ""
      ],
      "KYC verification needed": [
        ""
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        ""
      ],
      "Unexpected error.": [
        ""
      ],
      "Add new instance": [
        "Banka hesabı"
      ],
      "Edit": [
        ""
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        ""
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        ""
      ],
      "Only show active instances": [
        ""
      ],
      "Active": [
        ""
      ],
      "Only show deleted instances": [
        ""
      ],
      "Deleted": [
        ""
      ],
      "Show all instances": [
        ""
      ],
      "Delete instance": [
        ""
      ],
      "Delete the instance \"%1$s\"": [
        ""
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        ""
      ],
      "This cannot be undone!": [
        ""
      ],
      "Purge the instance": [
        ""
      ],
      "Purge the instance \"%1$s\"": [
        ""
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        ""
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        ""
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        ""
      ],
      "title\u0004%1$s: New bank account": [
        "Banka hesabı"
      ],
      "title\u0004%1$s: Bank accounts": [
        "Banka hesabı"
      ],
      "title\u0004%1$s: Update bank Account": [
        ""
      ],
      "title\u0004%1$s: Orders": [
        ""
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        ""
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        ""
      ],
      "title\u0004%1$s: Wire transfers": [
        ""
      ],
      "title\u0004%1$s: Webhooks": [
        ""
      ],
      "title\u0004%1$s: New webhook": [
        ""
      ],
      "title\u0004%1$s: Update webhook": [
        ""
      ],
      "title\u0004%1$s: OTP devices": [
        ""
      ],
      "title\u0004%1$s: New OTP device": [
        ""
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        ""
      ],
      "title\u0004%1$s: Update template": [
        ""
      ],
      "title\u0004%1$s: Templates": [
        ""
      ],
      "title\u0004%1$s: Use template": [
        ""
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        ""
      ],
      "title\u0004%1$s: Access tokens": [
        "Oluşturulma"
      ],
      "title\u0004%1$s: New access token": [
        "Oluşturulma"
      ],
      "title\u0004New instance": [
        ""
      ],
      "title\u0004Instances": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=n != 1;",
  "lang": "tr",
  "completeness": 7
};

strings['sv'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=n != 1;",
        "lang": "sv"
      },
      "Cancel": [
        "Avbryt"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        ""
      ],
      "Continue": [
        ""
      ],
      "Clear": [
        ""
      ],
      "Confirm": [
        "Bekräfta"
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        ""
      ],
      "Host": [
        ""
      ],
      "Account ID": [
        ""
      ],
      "The account owner's legal name": [
        ""
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        ""
      ],
      "Bank host": [
        ""
      ],
      "Bank account": [
        ""
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        ""
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        ""
      ],
      "Receiver postal code": [
        ""
      ],
      "Receiver town": [
        ""
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        ""
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        ""
      ],
      "days": [
        ""
      ],
      "hours": [
        ""
      ],
      "minutes": [
        ""
      ],
      "seconds": [
        ""
      ],
      "Forever": [
        ""
      ],
      "%1$sM": [
        ""
      ],
      "%1$sY": [
        ""
      ],
      "%1$sd": [
        ""
      ],
      "%1$sh": [
        ""
      ],
      "%1$smin": [
        ""
      ],
      "%1$ssec": [
        ""
      ],
      "Change value to never": [
        ""
      ],
      "Change value to empty": [
        ""
      ],
      "Image must be smaller than 1 MB": [
        ""
      ],
      "Add": [
        ""
      ],
      "Remove": [
        ""
      ],
      "Country": [
        ""
      ],
      "Building number": [
        ""
      ],
      "Building name": [
        ""
      ],
      "Street": [
        ""
      ],
      "Post code": [
        ""
      ],
      "Town location": [
        ""
      ],
      "District": [
        ""
      ],
      "Country subdivision": [
        ""
      ],
      "Additional address lines": [
        ""
      ],
      "Orders": [
        ""
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        ""
      ],
      "Templates": [
        ""
      ],
      "Product groups": [
        ""
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        ""
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        ""
      ],
      "Settings": [
        ""
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        ""
      ],
      "Connection": [
        ""
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        ""
      ],
      "New": [
        ""
      ],
      "List": [
        ""
      ],
      "Log out": [
        ""
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        ""
      ],
      "Business name": [
        ""
      ],
      "Legal name of the business represented by this instance.": [
        ""
      ],
      "Email": [
        ""
      ],
      "Contact email": [
        ""
      ],
      "Phone number": [
        ""
      ],
      "Contact phone": [
        ""
      ],
      "Website URL": [
        ""
      ],
      "URL.": [
        ""
      ],
      "Logo": [
        ""
      ],
      "Logo image.": [
        ""
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        ""
      ],
      "Jurisdiction": [
        ""
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        ""
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        ""
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        ""
      ],
      "Refund delay": [
        ""
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        ""
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        ""
      ],
      "Wire transfer rounding": [
        ""
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        ""
      ],
      "To second": [
        ""
      ],
      "To minute": [
        ""
      ],
      "To hour": [
        ""
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        ""
      ],
      "Required": [
        "Obligatoriskt"
      ],
      "Unauthorized": [
        ""
      ],
      "The code is not correct.": [
        ""
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        ""
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        ""
      ],
      "Verify": [
        ""
      ],
      "Failed to send the verification code.": [
        ""
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Login required": [
        ""
      ],
      "Instance name.": [
        ""
      ],
      "Instance password.": [
        ""
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        ""
      ],
      "Invalid": [
        ""
      ],
      "Doesn't have the pattern of an email": [
        ""
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        ""
      ],
      "Max 7 lines": [
        ""
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        ""
      ],
      "Unauthorized.": [
        ""
      ],
      "Conflict.": [
        "Bekräfta"
      ],
      "Not found.": [
        ""
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        ""
      ],
      "Repeat password": [
        ""
      ],
      "Confirm the same password": [
        ""
      ],
      "Please complete the marked fields and choose authorization method": [
        ""
      ],
      "Confirm operation": [
        ""
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        ""
      ],
      "Description": [
        ""
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        ""
      ],
      "Time the access token will be valid.": [
        ""
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        ""
      ],
      "Read only": [
        ""
      ],
      "All": [
        ""
      ],
      "Order simple": [
        ""
      ],
      "Order Point-of-Sale": [
        ""
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        ""
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        ""
      ],
      "Please complete the marked fields": [
        ""
      ],
      "Access token created": [
        ""
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        ""
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        ""
      ],
      "Create access token": [
        ""
      ],
      "Load more devices before the first one": [
        ""
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        ""
      ],
      "Expires at": [
        ""
      ],
      "Never": [
        ""
      ],
      "Remove this access token": [
        ""
      ],
      "Delete": [
        ""
      ],
      "Load more devices after the last one": [
        ""
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        ""
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        ""
      ],
      "Deleting an access token cannot be undone.": [
        ""
      ],
      "This is not a valid Bitcoin address.": [
        ""
      ],
      "This is not a valid Ethereum address.": [
        ""
      ],
      "This is not a valid host.": [
        ""
      ],
      "IBANs usually have more than 4 digits.": [
        ""
      ],
      "IBANs usually have fewer than 34 digits.": [
        ""
      ],
      "The IBAN's country code could not be retrieved.": [
        ""
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        ""
      ],
      "This account is not allowed.": [
        ""
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        ""
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        ""
      ],
      "Routing": [
        ""
      ],
      "Routing number": [
        ""
      ],
      "Account": [
        ""
      ],
      "Account number": [
        ""
      ],
      "Code": [
        ""
      ],
      "Business Identifier Code": [
        ""
      ],
      "International Bank Account Number": [
        ""
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        ""
      ],
      "Bitcoin protocol": [
        ""
      ],
      "Ethereum protocol": [
        ""
      ],
      "Interledger protocol": [
        ""
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        ""
      ],
      "Name of the account holder": [
        ""
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        ""
      ],
      "Invalid url": [
        ""
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        "Bekräfta"
      ],
      "Server replied with \"bad request\".": [
        ""
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        ""
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        ""
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        ""
      ],
      "Do not change": [
        ""
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        ""
      ],
      "Account details": [
        ""
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        ""
      ],
      "Delete account": [
        ""
      ],
      "Delete the account \"%1$s\"": [
        ""
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        ""
      ],
      "Bank accounts": [
        ""
      ],
      "Add new account": [
        ""
      ],
      "Owner's name": [
        ""
      ],
      "Delete selected accounts from the database": [
        ""
      ],
      "There are no accounts yet, add more pressing the + sign": [
        ""
      ],
      "You must provide a bank account to receive payments.": [
        ""
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        ""
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        ""
      ],
      "Add new devices": [
        ""
      ],
      "ID": [
        ""
      ],
      "Total products": [
        ""
      ],
      "Delete selected category from the database": [
        ""
      ],
      "There are no categories yet, add more pressing the + sign": [
        ""
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        ""
      ],
      "Products": [
        ""
      ],
      "Image": [
        ""
      ],
      "Load more products after the last one": [
        ""
      ],
      "There are no products in this category.": [
        ""
      ],
      "Account's KYC status": [
        ""
      ],
      "Exchange": [
        ""
      ],
      "Status": [
        ""
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        "Obligatoriskt"
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        ""
      ],
      "More information required.": [
        ""
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        ""
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        ""
      ],
      "The account for wire transfers does not appear to be valid": [
        ""
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        ""
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        ""
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        ""
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        ""
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        ""
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        ""
      ],
      "Enter description or id": [
        ""
      ],
      "No match found for that description or ID.": [
        ""
      ],
      "You must enter a valid product identifier.": [
        ""
      ],
      "Quantity must be greater than 0!": [
        ""
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        ""
      ],
      "Search product": [
        ""
      ],
      "Quantity": [
        ""
      ],
      "How many products will be added": [
        ""
      ],
      "Add from inventory": [
        ""
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        ""
      ],
      "Amount": [
        ""
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        ""
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        ""
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        ""
      ],
      "Add tax to the tax list": [
        ""
      ],
      "Describe and add a product that is not in the inventory list": [
        ""
      ],
      "Add custom product": [
        ""
      ],
      "Complete information of the product": [
        ""
      ],
      "Must be a number.": [
        ""
      ],
      "Must be greater than 0.": [
        ""
      ],
      "Photo of the product.": [
        ""
      ],
      "Full product description.": [
        ""
      ],
      "Unit name": [
        ""
      ],
      "Name of the product unit.": [
        ""
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        ""
      ],
      "How many products will be added.": [
        ""
      ],
      "Taxes": [
        ""
      ],
      "Total price": [
        ""
      ],
      "Must be greater than 0": [
        ""
      ],
      "Must have a refund deadline": [
        ""
      ],
      "Auto refund can't be after refund deadline": [
        ""
      ],
      "Must be in the future": [
        ""
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        ""
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        ""
      ],
      "%1$s products with a total price of %2$s.": [
        ""
      ],
      "Manage list of products in the order.": [
        ""
      ],
      "Remove this product from the order.": [
        ""
      ],
      "Products price sum": [
        ""
      ],
      "Total product price added up": [
        ""
      ],
      "Order price": [
        ""
      ],
      "Amount to be paid by the customer": [
        ""
      ],
      "Final order price": [
        ""
      ],
      "Summary": [
        ""
      ],
      "Title of the order to be shown to the customer": [
        ""
      ],
      "Shipping and fulfillment": [
        ""
      ],
      "Delivery date": [
        ""
      ],
      "Deadline for physical delivery assured by the merchant.": [
        ""
      ],
      "Delivery location": [
        ""
      ],
      "Address where the products will be delivered": [
        ""
      ],
      "Fulfillment URL": [
        ""
      ],
      "URL to which the user will be redirected after successful payment.": [
        ""
      ],
      "Fulfillment message": [
        ""
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        ""
      ],
      "Override default Taler payment settings for this order": [
        ""
      ],
      "Payment time": [
        ""
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        ""
      ],
      "Default": [
        ""
      ],
      "Refund time": [
        ""
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        ""
      ],
      "Wire transfer time": [
        ""
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        ""
      ],
      "Auto-refund time": [
        ""
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        ""
      ],
      "Maximum fee": [
        ""
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        ""
      ],
      "Create token": [
        ""
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        ""
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        ""
      ],
      "Minimum age defined by the products is %1$s": [
        ""
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        ""
      ],
      "Custom information to be included in the contract for this order.": [
        ""
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        ""
      ],
      "remove": [
        ""
      ],
      "Custom field name": [
        ""
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        ""
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        ""
      ],
      "Only show unpaid orders": [
        ""
      ],
      "Only show paid orders": [
        ""
      ],
      "Paid": [
        ""
      ],
      "Only show orders with refunds": [
        ""
      ],
      "Refunded": [
        ""
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        ""
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        ""
      ],
      "Completed": [
        ""
      ],
      "Remove all filters": [
        ""
      ],
      "Clear date filter": [
        ""
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        ""
      ],
      "Order id": [
        ""
      ],
      "Instance unknown": [
        ""
      ],
      "Order unknown": [
        ""
      ],
      "Create order": [
        ""
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        ""
      ],
      "Refund": [
        ""
      ],
      "copy url": [
        ""
      ],
      "Load more orders after the last one": [
        ""
      ],
      "No orders have been found matching your query!": [
        ""
      ],
      "Duplicated": [
        ""
      ],
      "This value exceeds the refundable amount.": [
        ""
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        ""
      ],
      "Reason": [
        ""
      ],
      "Amount to be refunded": [
        ""
      ],
      "Max refundable:": [
        ""
      ],
      "Choose one...": [
        ""
      ],
      "Requested by the customer": [
        ""
      ],
      "Other": [
        ""
      ],
      "Why this order is being refunded": [
        ""
      ],
      "More information to give context": [
        ""
      ],
      "now": [
        ""
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        ""
      ],
      "This wire transfer has been notified by the payment service provider.": [
        ""
      ],
      "This refund is waiting to be claimed by the customer.": [
        ""
      ],
      "This refund has been claimed by the customer.": [
        ""
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        ""
      ],
      "Human-readable description of the whole purchase": [
        ""
      ],
      "Total price for the transaction": [
        ""
      ],
      "URL for this purchase": [
        ""
      ],
      "Max fee": [
        ""
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        ""
      ],
      "Time when this contract was generated": [
        ""
      ],
      "Payment deadline": [
        ""
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        ""
      ],
      "Refund deadline": [
        ""
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        ""
      ],
      "Wire transfer deadline": [
        ""
      ],
      "Transfer deadline for the exchange": [
        ""
      ],
      "Time indicating when the order should be delivered": [
        ""
      ],
      "Where the order will be delivered": [
        ""
      ],
      "Auto-refund delay": [
        ""
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        ""
      ],
      "Extra info": [
        ""
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        ""
      ],
      "order created": [
        ""
      ],
      "pay deadline": [
        ""
      ],
      "refund deadline": [
        ""
      ],
      "delivery": [
        ""
      ],
      "Order": [
        ""
      ],
      "Claimed": [
        ""
      ],
      "Claimed at": [
        ""
      ],
      "Timeline": [
        ""
      ],
      "Payment details": [
        ""
      ],
      "Order status": [
        ""
      ],
      "Unpaid": [
        ""
      ],
      "Product list": [
        ""
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        ""
      ],
      "refund created: %1$s: %2$s": [
        ""
      ],
      "refund taken: %1$s": [
        ""
      ],
      "refund taken: %1$s: %2$s": [
        ""
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        ""
      ],
      "Wired": [
        ""
      ],
      "Refund order": [
        ""
      ],
      "Not refundable": [
        ""
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        ""
      ],
      "Refund taken": [
        ""
      ],
      "Status URL": [
        ""
      ],
      "Refund URI": [
        ""
      ],
      "Pay at": [
        ""
      ],
      "Order status URL": [
        ""
      ],
      "Payment URI": [
        ""
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        ""
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        ""
      ],
      "The size of the key must be 32 characters": [
        ""
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        ""
      ],
      "Algorithm used to verify transactions in offline mode": [
        ""
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        ""
      ],
      "Random": [
        ""
      ],
      "Create another": [
        ""
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        ""
      ],
      "Delete selected devices from the database": [
        ""
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        ""
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        ""
      ],
      "Algorithm to use to verify transactions in offline mode": [
        ""
      ],
      "Not modified": [
        ""
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        ""
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        ""
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        ""
      ],
      "Testing password change": [
        ""
      ],
      "Password changed": [
        ""
      ],
      "The current password is wrong.": [
        ""
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        ""
      ],
      "Add element to the list": [
        ""
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        ""
      ],
      "Manage stock": [
        ""
      ],
      "This product has been configured without stock control": [
        ""
      ],
      "Infinite": [
        ""
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        ""
      ],
      "Incoming": [
        ""
      ],
      "Lost": [
        ""
      ],
      "Current": [
        ""
      ],
      "Remove stock control for this product": [
        ""
      ],
      "without stock": [
        ""
      ],
      "Next restock": [
        ""
      ],
      "Warehouse address": [
        ""
      ],
      "Invalid amount": [
        ""
      ],
      "Product identification to use in URLs (for internal use only).": [
        ""
      ],
      "Illustration of the product for customers.": [
        ""
      ],
      "Product name.": [
        ""
      ],
      "Product description for customers.": [
        ""
      ],
      "Age restriction": [
        ""
      ],
      "Is this product restricted for customer below certain age?": [
        ""
      ],
      "Minimum age of the customer": [
        ""
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        ""
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        ""
      ],
      "Stock": [
        ""
      ],
      "Inventory for products with finite supply (for internal use only).": [
        ""
      ],
      "Taxes included in the product price, exposed to customers.": [
        ""
      ],
      "Search by category description or id": [
        ""
      ],
      "Categories where this product will be listed on.": [
        ""
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        ""
      ],
      "Money pots where this product will be listed on.": [
        ""
      ],
      "Select one": [
        ""
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        ""
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        ""
      ],
      "Product not found.": [
        ""
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        ""
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        ""
      ],
      "Update": [
        ""
      ],
      "Remove this product from the database": [
        ""
      ],
      "Update the product with new price": [
        ""
      ],
      "Update product with new price": [
        ""
      ],
      "Confirm update": [
        ""
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        ""
      ],
      "Add more elements to the inventory": [
        ""
      ],
      "Report elements lost in the inventory": [
        ""
      ],
      "New price for the product": [
        ""
      ],
      "There are values with errors.": [
        ""
      ],
      "Update product with new stock and price": [
        ""
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        ""
      ],
      "Product (ID: %1$s) has been deleted": [
        ""
      ],
      "Jump to product with the given product ID": [
        ""
      ],
      "Product id": [
        ""
      ],
      "Delete product": [
        ""
      ],
      "Delete the product \"%1$s\"": [
        ""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        ""
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        ""
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        ""
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        ""
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        ""
      ],
      "hour": [
        ""
      ],
      "day": [
        ""
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        ""
      ],
      "Time range": [
        ""
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        ""
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        ""
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        ""
      ],
      "Too short": [
        ""
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        ""
      ],
      "Name of the template in URLs.": [
        ""
      ],
      "Template name": [
        ""
      ],
      "Describe what this template stands for": [
        ""
      ],
      "Order summary": [
        ""
      ],
      "If specified here, this template will create orders with the same summary": [
        ""
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        ""
      ],
      "Amount is editable": [
        ""
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        ""
      ],
      "Is this contract restricted to some age?": [
        ""
      ],
      "Payment timeout": [
        ""
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        ""
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        ""
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        ""
      ],
      "Load more templates before the first one": [
        ""
      ],
      "Delete selected templates from the database": [
        ""
      ],
      "Use template to create new order": [
        ""
      ],
      "Generate a QR code for the template.": [
        ""
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        ""
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        ""
      ],
      "Jump to template with the given template ID": [
        ""
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        ""
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        ""
      ],
      "Print": [
        ""
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        ""
      ],
      "If specified, this template will create orders with the same price": [
        ""
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        ""
      ],
      "An amount is required": [
        ""
      ],
      "An order summary is required": [
        ""
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        ""
      ],
      "Amount of the order": [
        ""
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        ""
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        ""
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        ""
      ],
      "Go to token family update page": [
        ""
      ],
      "Remove this token family from the database": [
        ""
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        ""
      ],
      "Token family has been deleted.": [
        ""
      ],
      "Delete token family": [
        ""
      ],
      "Delete the token family \"%1$s\"": [
        ""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        ""
      ],
      "Deleting a token family %1$s .": [
        ""
      ],
      "can't be undone": [
        ""
      ],
      "Token Family: %1$s": [
        ""
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        ""
      ],
      "Incoming wire transfers": [
        ""
      ],
      "Load more wire transfers preceding the first one": [
        ""
      ],
      "Expected credit": [
        ""
      ],
      "Confirmed": [
        ""
      ],
      "Validated": [
        ""
      ],
      "Executed on": [
        ""
      ],
      "yes": [
        ""
      ],
      "no": [
        ""
      ],
      "never": [
        ""
      ],
      "unknown": [
        ""
      ],
      "Load more transfers after the last one": [
        ""
      ],
      "Verified wire transfers": [
        ""
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        ""
      ],
      "All accounts": [
        ""
      ],
      "Filter by account address": [
        ""
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        ""
      ],
      "Only show wire transfers confirmed by the merchant": [
        ""
      ],
      "Verified": [
        ""
      ],
      "Wire transfer already confirmed.": [
        ""
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        ""
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        ""
      ],
      "Transfer ID": [
        ""
      ],
      "It's not the same.": [
        ""
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        ""
      ],
      "Instance": [
        ""
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        ""
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        ""
      ],
      "Delete this instance": [
        ""
      ],
      "Must be one of '%1$s'": [
        ""
      ],
      "URL is invalid": [
        ""
      ],
      "Webhook ID to use": [
        ""
      ],
      "Event": [
        ""
      ],
      "Payment": [
        ""
      ],
      "Order settled": [
        ""
      ],
      "Category added": [
        ""
      ],
      "Category updated": [
        ""
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        ""
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        ""
      ],
      "Method": [
        ""
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        ""
      ],
      "URL": [
        ""
      ],
      "URL of the webhook where the customer will be redirected": [
        ""
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        ""
      ],
      "order's price": [
        ""
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        ""
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        ""
      ],
      "Header template of the webhook": [
        ""
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        ""
      ],
      "Webhook deleted successfully": [
        ""
      ],
      "Add new webhooks": [
        ""
      ],
      "Load more webhooks before the first one": [
        ""
      ],
      "Event type": [
        ""
      ],
      "Delete selected webhook from the database": [
        ""
      ],
      "Load more webhooks after the last one": [
        ""
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        ""
      ],
      "Webhook updated": [
        ""
      ],
      "Header": [
        ""
      ],
      "Body": [
        ""
      ],
      "Body template used by the webhook": [
        ""
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        ""
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        ""
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        ""
      ],
      "Resetting access to the instance \"%1$s\"": [
        ""
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        ""
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        ""
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        ""
      ],
      "Add new pots": [
        ""
      ],
      "Load more pots before the first one": [
        ""
      ],
      "Total": [
        ""
      ],
      "Delete selected pots from the database": [
        ""
      ],
      "Load more pots after the last one": [
        ""
      ],
      "There are no money pots yet, add more pressing the + sign": [
        ""
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        ""
      ],
      "Invalid amount \"%1$s\": %2$s": [
        ""
      ],
      "Descripton": [
        ""
      ],
      "Totals": [
        ""
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        ""
      ],
      "Add new group": [
        ""
      ],
      "Load more groups before the first one": [
        ""
      ],
      "Delete selected group from the database": [
        ""
      ],
      "Load more groups after the last one": [
        ""
      ],
      "There are no product groups yet, add more pressing the + sign": [
        ""
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        ""
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        ""
      ],
      "There are no reports yet, add more pressing the + sign": [
        ""
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        ""
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        ""
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        ""
      ],
      "KYC verification needed": [
        ""
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        ""
      ],
      "Unexpected error.": [
        ""
      ],
      "Add new instance": [
        ""
      ],
      "Edit": [
        ""
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        ""
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        ""
      ],
      "Only show active instances": [
        ""
      ],
      "Active": [
        ""
      ],
      "Only show deleted instances": [
        ""
      ],
      "Deleted": [
        ""
      ],
      "Show all instances": [
        ""
      ],
      "Delete instance": [
        ""
      ],
      "Delete the instance \"%1$s\"": [
        ""
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        ""
      ],
      "This cannot be undone!": [
        ""
      ],
      "Purge the instance": [
        ""
      ],
      "Purge the instance \"%1$s\"": [
        ""
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        ""
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        ""
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        ""
      ],
      "title\u0004%1$s: New bank account": [
        ""
      ],
      "title\u0004%1$s: Bank accounts": [
        ""
      ],
      "title\u0004%1$s: Update bank Account": [
        ""
      ],
      "title\u0004%1$s: Orders": [
        ""
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        ""
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        ""
      ],
      "title\u0004%1$s: Wire transfers": [
        ""
      ],
      "title\u0004%1$s: Webhooks": [
        ""
      ],
      "title\u0004%1$s: New webhook": [
        ""
      ],
      "title\u0004%1$s: Update webhook": [
        ""
      ],
      "title\u0004%1$s: OTP devices": [
        ""
      ],
      "title\u0004%1$s: New OTP device": [
        ""
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        ""
      ],
      "title\u0004%1$s: Update template": [
        ""
      ],
      "title\u0004%1$s: Templates": [
        ""
      ],
      "title\u0004%1$s: Use template": [
        ""
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        ""
      ],
      "title\u0004%1$s: Access tokens": [
        ""
      ],
      "title\u0004%1$s: New access token": [
        ""
      ],
      "title\u0004New instance": [
        ""
      ],
      "title\u0004Instances": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=n != 1;",
  "lang": "sv",
  "completeness": 0
};

strings['it'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=n != 1;",
        "lang": "it"
      },
      "Cancel": [
        ""
      ],
      "%1$s": [
        ""
      ],
      "Close": [
        ""
      ],
      "Continue": [
        ""
      ],
      "Clear": [
        ""
      ],
      "Confirm": [
        "Confermare"
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        ""
      ],
      "Host": [
        ""
      ],
      "Account ID": [
        "Importo"
      ],
      "The account owner's legal name": [
        ""
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        ""
      ],
      "Bank host": [
        ""
      ],
      "Bank account": [
        ""
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        ""
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        "Soggetto"
      ],
      "Receiver postal code": [
        ""
      ],
      "Receiver town": [
        ""
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        ""
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        ""
      ],
      "days": [
        ""
      ],
      "hours": [
        ""
      ],
      "minutes": [
        ""
      ],
      "seconds": [
        ""
      ],
      "Forever": [
        ""
      ],
      "%1$sM": [
        ""
      ],
      "%1$sY": [
        ""
      ],
      "%1$sd": [
        ""
      ],
      "%1$sh": [
        ""
      ],
      "%1$smin": [
        ""
      ],
      "%1$ssec": [
        ""
      ],
      "Change value to never": [
        ""
      ],
      "Change value to empty": [
        ""
      ],
      "Image must be smaller than 1 MB": [
        ""
      ],
      "Add": [
        ""
      ],
      "Remove": [
        ""
      ],
      "Country": [
        ""
      ],
      "Building number": [
        ""
      ],
      "Building name": [
        ""
      ],
      "Street": [
        ""
      ],
      "Post code": [
        ""
      ],
      "Town location": [
        ""
      ],
      "District": [
        ""
      ],
      "Country subdivision": [
        ""
      ],
      "Additional address lines": [
        ""
      ],
      "Orders": [
        ""
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        ""
      ],
      "Templates": [
        ""
      ],
      "Product groups": [
        ""
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        ""
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        ""
      ],
      "Settings": [
        "Impostazioni"
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        ""
      ],
      "Connection": [
        ""
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        ""
      ],
      "New": [
        ""
      ],
      "List": [
        ""
      ],
      "Log out": [
        ""
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        ""
      ],
      "Business name": [
        ""
      ],
      "Legal name of the business represented by this instance.": [
        ""
      ],
      "Email": [
        ""
      ],
      "Contact email": [
        ""
      ],
      "Phone number": [
        ""
      ],
      "Contact phone": [
        ""
      ],
      "Website URL": [
        ""
      ],
      "URL.": [
        ""
      ],
      "Logo": [
        ""
      ],
      "Logo image.": [
        ""
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        ""
      ],
      "Jurisdiction": [
        ""
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        ""
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        ""
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        ""
      ],
      "Refund delay": [
        "Rimborsato"
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        ""
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        ""
      ],
      "Wire transfer rounding": [
        ""
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        ""
      ],
      "To second": [
        ""
      ],
      "To minute": [
        ""
      ],
      "To hour": [
        ""
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        ""
      ],
      "Required": [
        "Obbligatorio"
      ],
      "Unauthorized": [
        ""
      ],
      "The code is not correct.": [
        ""
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        ""
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        "Indietro"
      ],
      "Verify": [
        ""
      ],
      "Failed to send the verification code.": [
        ""
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Login required": [
        ""
      ],
      "Instance name.": [
        ""
      ],
      "Instance password.": [
        ""
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        ""
      ],
      "Invalid": [
        ""
      ],
      "Doesn't have the pattern of an email": [
        ""
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        ""
      ],
      "Max 7 lines": [
        ""
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        ""
      ],
      "Unauthorized.": [
        ""
      ],
      "Conflict.": [
        "Confermare"
      ],
      "Not found.": [
        ""
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        ""
      ],
      "Repeat password": [
        ""
      ],
      "Confirm the same password": [
        ""
      ],
      "Please complete the marked fields and choose authorization method": [
        ""
      ],
      "Confirm operation": [
        ""
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        ""
      ],
      "Description": [
        ""
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        ""
      ],
      "Time the access token will be valid.": [
        ""
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        ""
      ],
      "Read only": [
        ""
      ],
      "All": [
        ""
      ],
      "Order simple": [
        ""
      ],
      "Order Point-of-Sale": [
        ""
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        ""
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        ""
      ],
      "Please complete the marked fields": [
        ""
      ],
      "Access token created": [
        ""
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        ""
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        ""
      ],
      "Create access token": [
        ""
      ],
      "Load more devices before the first one": [
        ""
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        ""
      ],
      "Expires at": [
        ""
      ],
      "Never": [
        ""
      ],
      "Remove this access token": [
        ""
      ],
      "Delete": [
        ""
      ],
      "Load more devices after the last one": [
        ""
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        ""
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        ""
      ],
      "Deleting an access token cannot be undone.": [
        ""
      ],
      "This is not a valid Bitcoin address.": [
        ""
      ],
      "This is not a valid Ethereum address.": [
        ""
      ],
      "This is not a valid host.": [
        ""
      ],
      "IBANs usually have more than 4 digits.": [
        ""
      ],
      "IBANs usually have fewer than 34 digits.": [
        ""
      ],
      "The IBAN's country code could not be retrieved.": [
        ""
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        ""
      ],
      "This account is not allowed.": [
        ""
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        ""
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        ""
      ],
      "Routing": [
        ""
      ],
      "Routing number": [
        ""
      ],
      "Account": [
        ""
      ],
      "Account number": [
        "Importo"
      ],
      "Code": [
        ""
      ],
      "Business Identifier Code": [
        ""
      ],
      "International Bank Account Number": [
        ""
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        ""
      ],
      "Bitcoin protocol": [
        ""
      ],
      "Ethereum protocol": [
        ""
      ],
      "Interledger protocol": [
        ""
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        ""
      ],
      "Name of the account holder": [
        ""
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        ""
      ],
      "Invalid url": [
        ""
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        "Confermare"
      ],
      "Server replied with \"bad request\".": [
        ""
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        "Conto:"
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        ""
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        ""
      ],
      "Do not change": [
        ""
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        ""
      ],
      "Account details": [
        ""
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        ""
      ],
      "Delete account": [
        ""
      ],
      "Delete the account \"%1$s\"": [
        ""
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        ""
      ],
      "Bank accounts": [
        ""
      ],
      "Add new account": [
        ""
      ],
      "Owner's name": [
        ""
      ],
      "Delete selected accounts from the database": [
        ""
      ],
      "There are no accounts yet, add more pressing the + sign": [
        ""
      ],
      "You must provide a bank account to receive payments.": [
        ""
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        ""
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        ""
      ],
      "Add new devices": [
        ""
      ],
      "ID": [
        ""
      ],
      "Total products": [
        ""
      ],
      "Delete selected category from the database": [
        ""
      ],
      "There are no categories yet, add more pressing the + sign": [
        ""
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        ""
      ],
      "Products": [
        ""
      ],
      "Image": [
        ""
      ],
      "Load more products after the last one": [
        ""
      ],
      "There are no products in this category.": [
        ""
      ],
      "Account's KYC status": [
        ""
      ],
      "Exchange": [
        ""
      ],
      "Status": [
        ""
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        "Obbligatorio"
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        ""
      ],
      "More information required.": [
        ""
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        ""
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        ""
      ],
      "The account for wire transfers does not appear to be valid": [
        ""
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        ""
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        ""
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        ""
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        ""
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        ""
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        ""
      ],
      "Enter description or id": [
        ""
      ],
      "No match found for that description or ID.": [
        ""
      ],
      "You must enter a valid product identifier.": [
        ""
      ],
      "Quantity must be greater than 0!": [
        ""
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        ""
      ],
      "Search product": [
        ""
      ],
      "Quantity": [
        ""
      ],
      "How many products will be added": [
        ""
      ],
      "Add from inventory": [
        ""
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        ""
      ],
      "Amount": [
        "Importo"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        ""
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        ""
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        ""
      ],
      "Add tax to the tax list": [
        ""
      ],
      "Describe and add a product that is not in the inventory list": [
        ""
      ],
      "Add custom product": [
        ""
      ],
      "Complete information of the product": [
        ""
      ],
      "Must be a number.": [
        ""
      ],
      "Must be greater than 0.": [
        ""
      ],
      "Photo of the product.": [
        ""
      ],
      "Full product description.": [
        ""
      ],
      "Unit name": [
        ""
      ],
      "Name of the product unit.": [
        ""
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        ""
      ],
      "How many products will be added.": [
        ""
      ],
      "Taxes": [
        ""
      ],
      "Total price": [
        ""
      ],
      "Must be greater than 0": [
        ""
      ],
      "Must have a refund deadline": [
        ""
      ],
      "Auto refund can't be after refund deadline": [
        ""
      ],
      "Must be in the future": [
        ""
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        ""
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        ""
      ],
      "%1$s products with a total price of %2$s.": [
        ""
      ],
      "Manage list of products in the order.": [
        ""
      ],
      "Remove this product from the order.": [
        ""
      ],
      "Products price sum": [
        ""
      ],
      "Total product price added up": [
        ""
      ],
      "Order price": [
        ""
      ],
      "Amount to be paid by the customer": [
        ""
      ],
      "Final order price": [
        ""
      ],
      "Summary": [
        ""
      ],
      "Title of the order to be shown to the customer": [
        ""
      ],
      "Shipping and fulfillment": [
        ""
      ],
      "Delivery date": [
        ""
      ],
      "Deadline for physical delivery assured by the merchant.": [
        ""
      ],
      "Delivery location": [
        ""
      ],
      "Address where the products will be delivered": [
        ""
      ],
      "Fulfillment URL": [
        ""
      ],
      "URL to which the user will be redirected after successful payment.": [
        ""
      ],
      "Fulfillment message": [
        ""
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        ""
      ],
      "Override default Taler payment settings for this order": [
        ""
      ],
      "Payment time": [
        ""
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        ""
      ],
      "Default": [
        ""
      ],
      "Refund time": [
        "Rimborsato"
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        ""
      ],
      "Wire transfer time": [
        ""
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        ""
      ],
      "Auto-refund time": [
        ""
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        ""
      ],
      "Maximum fee": [
        ""
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        ""
      ],
      "Create token": [
        ""
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        ""
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        ""
      ],
      "Minimum age defined by the products is %1$s": [
        ""
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        ""
      ],
      "Custom information to be included in the contract for this order.": [
        ""
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        ""
      ],
      "remove": [
        ""
      ],
      "Custom field name": [
        ""
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        ""
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        ""
      ],
      "Only show unpaid orders": [
        ""
      ],
      "Only show paid orders": [
        ""
      ],
      "Paid": [
        ""
      ],
      "Only show orders with refunds": [
        ""
      ],
      "Refunded": [
        "Rimborsato"
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        ""
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        ""
      ],
      "Completed": [
        ""
      ],
      "Remove all filters": [
        ""
      ],
      "Clear date filter": [
        ""
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        ""
      ],
      "Order id": [
        ""
      ],
      "Instance unknown": [
        ""
      ],
      "Order unknown": [
        ""
      ],
      "Create order": [
        ""
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        "Data"
      ],
      "Refund": [
        ""
      ],
      "copy url": [
        ""
      ],
      "Load more orders after the last one": [
        ""
      ],
      "No orders have been found matching your query!": [
        ""
      ],
      "Duplicated": [
        ""
      ],
      "This value exceeds the refundable amount.": [
        ""
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        "Rimborsato"
      ],
      "Reason": [
        ""
      ],
      "Amount to be refunded": [
        ""
      ],
      "Max refundable:": [
        ""
      ],
      "Choose one...": [
        ""
      ],
      "Requested by the customer": [
        ""
      ],
      "Other": [
        ""
      ],
      "Why this order is being refunded": [
        ""
      ],
      "More information to give context": [
        ""
      ],
      "now": [
        ""
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        ""
      ],
      "This wire transfer has been notified by the payment service provider.": [
        ""
      ],
      "This refund is waiting to be claimed by the customer.": [
        ""
      ],
      "This refund has been claimed by the customer.": [
        ""
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        ""
      ],
      "Human-readable description of the whole purchase": [
        ""
      ],
      "Total price for the transaction": [
        ""
      ],
      "URL for this purchase": [
        ""
      ],
      "Max fee": [
        ""
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        ""
      ],
      "Time when this contract was generated": [
        ""
      ],
      "Payment deadline": [
        ""
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        ""
      ],
      "Refund deadline": [
        ""
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        ""
      ],
      "Wire transfer deadline": [
        ""
      ],
      "Transfer deadline for the exchange": [
        ""
      ],
      "Time indicating when the order should be delivered": [
        ""
      ],
      "Where the order will be delivered": [
        ""
      ],
      "Auto-refund delay": [
        ""
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        ""
      ],
      "Extra info": [
        ""
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        ""
      ],
      "order created": [
        ""
      ],
      "pay deadline": [
        ""
      ],
      "refund deadline": [
        "Rimborsato"
      ],
      "delivery": [
        ""
      ],
      "Order": [
        ""
      ],
      "Claimed": [
        ""
      ],
      "Claimed at": [
        ""
      ],
      "Timeline": [
        ""
      ],
      "Payment details": [
        ""
      ],
      "Order status": [
        ""
      ],
      "Unpaid": [
        ""
      ],
      "Product list": [
        ""
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        ""
      ],
      "refund created: %1$s: %2$s": [
        ""
      ],
      "refund taken: %1$s": [
        ""
      ],
      "refund taken: %1$s: %2$s": [
        ""
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        ""
      ],
      "Wired": [
        ""
      ],
      "Refund order": [
        "Rimborsato"
      ],
      "Not refundable": [
        ""
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        ""
      ],
      "Refund taken": [
        ""
      ],
      "Status URL": [
        ""
      ],
      "Refund URI": [
        ""
      ],
      "Pay at": [
        ""
      ],
      "Order status URL": [
        ""
      ],
      "Payment URI": [
        ""
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        ""
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        ""
      ],
      "The size of the key must be 32 characters": [
        ""
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        ""
      ],
      "Algorithm used to verify transactions in offline mode": [
        ""
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        ""
      ],
      "Random": [
        ""
      ],
      "Create another": [
        ""
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        ""
      ],
      "Delete selected devices from the database": [
        ""
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        ""
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        ""
      ],
      "Algorithm to use to verify transactions in offline mode": [
        ""
      ],
      "Not modified": [
        ""
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        ""
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        ""
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        ""
      ],
      "Testing password change": [
        ""
      ],
      "Password changed": [
        ""
      ],
      "The current password is wrong.": [
        ""
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        "Importo"
      ],
      "Add element to the list": [
        ""
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        ""
      ],
      "Manage stock": [
        ""
      ],
      "This product has been configured without stock control": [
        ""
      ],
      "Infinite": [
        ""
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        ""
      ],
      "Incoming": [
        ""
      ],
      "Lost": [
        ""
      ],
      "Current": [
        ""
      ],
      "Remove stock control for this product": [
        ""
      ],
      "without stock": [
        ""
      ],
      "Next restock": [
        ""
      ],
      "Warehouse address": [
        ""
      ],
      "Invalid amount": [
        ""
      ],
      "Product identification to use in URLs (for internal use only).": [
        ""
      ],
      "Illustration of the product for customers.": [
        ""
      ],
      "Product name.": [
        ""
      ],
      "Product description for customers.": [
        ""
      ],
      "Age restriction": [
        ""
      ],
      "Is this product restricted for customer below certain age?": [
        ""
      ],
      "Minimum age of the customer": [
        ""
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        ""
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        ""
      ],
      "Stock": [
        ""
      ],
      "Inventory for products with finite supply (for internal use only).": [
        ""
      ],
      "Taxes included in the product price, exposed to customers.": [
        ""
      ],
      "Search by category description or id": [
        ""
      ],
      "Categories where this product will be listed on.": [
        ""
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        ""
      ],
      "Money pots where this product will be listed on.": [
        ""
      ],
      "Select one": [
        ""
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        ""
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        ""
      ],
      "Product not found.": [
        ""
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        ""
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        ""
      ],
      "Update": [
        ""
      ],
      "Remove this product from the database": [
        ""
      ],
      "Update the product with new price": [
        ""
      ],
      "Update product with new price": [
        ""
      ],
      "Confirm update": [
        ""
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        ""
      ],
      "Add more elements to the inventory": [
        ""
      ],
      "Report elements lost in the inventory": [
        ""
      ],
      "New price for the product": [
        ""
      ],
      "There are values with errors.": [
        ""
      ],
      "Update product with new stock and price": [
        ""
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        ""
      ],
      "Product (ID: %1$s) has been deleted": [
        ""
      ],
      "Jump to product with the given product ID": [
        ""
      ],
      "Product id": [
        ""
      ],
      "Delete product": [
        ""
      ],
      "Delete the product \"%1$s\"": [
        ""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        ""
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        ""
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        ""
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        ""
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        ""
      ],
      "hour": [
        ""
      ],
      "day": [
        ""
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        ""
      ],
      "Time range": [
        ""
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        ""
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        ""
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        ""
      ],
      "Too short": [
        ""
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        ""
      ],
      "Name of the template in URLs.": [
        ""
      ],
      "Template name": [
        ""
      ],
      "Describe what this template stands for": [
        ""
      ],
      "Order summary": [
        ""
      ],
      "If specified here, this template will create orders with the same summary": [
        ""
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        ""
      ],
      "Amount is editable": [
        ""
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        ""
      ],
      "Is this contract restricted to some age?": [
        ""
      ],
      "Payment timeout": [
        ""
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        ""
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        ""
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        ""
      ],
      "Load more templates before the first one": [
        ""
      ],
      "Delete selected templates from the database": [
        ""
      ],
      "Use template to create new order": [
        ""
      ],
      "Generate a QR code for the template.": [
        ""
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        ""
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        ""
      ],
      "Jump to template with the given template ID": [
        ""
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        ""
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        ""
      ],
      "Print": [
        ""
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        ""
      ],
      "If specified, this template will create orders with the same price": [
        ""
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        ""
      ],
      "An amount is required": [
        ""
      ],
      "An order summary is required": [
        ""
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        ""
      ],
      "Amount of the order": [
        ""
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        ""
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        ""
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        ""
      ],
      "Go to token family update page": [
        ""
      ],
      "Remove this token family from the database": [
        ""
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        ""
      ],
      "Token family has been deleted.": [
        ""
      ],
      "Delete token family": [
        ""
      ],
      "Delete the token family \"%1$s\"": [
        ""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        ""
      ],
      "Deleting a token family %1$s .": [
        ""
      ],
      "can't be undone": [
        ""
      ],
      "Token Family: %1$s": [
        ""
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        ""
      ],
      "Incoming wire transfers": [
        ""
      ],
      "Load more wire transfers preceding the first one": [
        ""
      ],
      "Expected credit": [
        ""
      ],
      "Confirmed": [
        ""
      ],
      "Validated": [
        ""
      ],
      "Executed on": [
        ""
      ],
      "yes": [
        ""
      ],
      "no": [
        ""
      ],
      "never": [
        ""
      ],
      "unknown": [
        ""
      ],
      "Load more transfers after the last one": [
        ""
      ],
      "Verified wire transfers": [
        ""
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        ""
      ],
      "All accounts": [
        ""
      ],
      "Filter by account address": [
        ""
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        ""
      ],
      "Only show wire transfers confirmed by the merchant": [
        ""
      ],
      "Verified": [
        ""
      ],
      "Wire transfer already confirmed.": [
        ""
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        ""
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        ""
      ],
      "Transfer ID": [
        ""
      ],
      "It's not the same.": [
        ""
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        ""
      ],
      "Instance": [
        ""
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        ""
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        ""
      ],
      "Delete this instance": [
        ""
      ],
      "Must be one of '%1$s'": [
        ""
      ],
      "URL is invalid": [
        ""
      ],
      "Webhook ID to use": [
        ""
      ],
      "Event": [
        ""
      ],
      "Payment": [
        ""
      ],
      "Order settled": [
        ""
      ],
      "Category added": [
        ""
      ],
      "Category updated": [
        ""
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        ""
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        ""
      ],
      "Method": [
        ""
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        ""
      ],
      "URL": [
        ""
      ],
      "URL of the webhook where the customer will be redirected": [
        ""
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        ""
      ],
      "order's price": [
        ""
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        ""
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        ""
      ],
      "Header template of the webhook": [
        ""
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        ""
      ],
      "Webhook deleted successfully": [
        ""
      ],
      "Add new webhooks": [
        ""
      ],
      "Load more webhooks before the first one": [
        ""
      ],
      "Event type": [
        ""
      ],
      "Delete selected webhook from the database": [
        ""
      ],
      "Load more webhooks after the last one": [
        ""
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        ""
      ],
      "Webhook updated": [
        ""
      ],
      "Header": [
        ""
      ],
      "Body": [
        ""
      ],
      "Body template used by the webhook": [
        ""
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        ""
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        ""
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        ""
      ],
      "Resetting access to the instance \"%1$s\"": [
        ""
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        ""
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        ""
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        ""
      ],
      "Add new pots": [
        ""
      ],
      "Load more pots before the first one": [
        ""
      ],
      "Total": [
        ""
      ],
      "Delete selected pots from the database": [
        ""
      ],
      "Load more pots after the last one": [
        ""
      ],
      "There are no money pots yet, add more pressing the + sign": [
        ""
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        ""
      ],
      "Invalid amount \"%1$s\": %2$s": [
        ""
      ],
      "Descripton": [
        ""
      ],
      "Totals": [
        ""
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        ""
      ],
      "Add new group": [
        ""
      ],
      "Load more groups before the first one": [
        ""
      ],
      "Delete selected group from the database": [
        ""
      ],
      "Load more groups after the last one": [
        ""
      ],
      "There are no product groups yet, add more pressing the + sign": [
        ""
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        ""
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        ""
      ],
      "There are no reports yet, add more pressing the + sign": [
        ""
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        ""
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        ""
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        ""
      ],
      "KYC verification needed": [
        ""
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        ""
      ],
      "Unexpected error.": [
        ""
      ],
      "Add new instance": [
        ""
      ],
      "Edit": [
        ""
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        ""
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        ""
      ],
      "Only show active instances": [
        ""
      ],
      "Active": [
        ""
      ],
      "Only show deleted instances": [
        ""
      ],
      "Deleted": [
        ""
      ],
      "Show all instances": [
        ""
      ],
      "Delete instance": [
        ""
      ],
      "Delete the instance \"%1$s\"": [
        ""
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        ""
      ],
      "This cannot be undone!": [
        ""
      ],
      "Purge the instance": [
        ""
      ],
      "Purge the instance \"%1$s\"": [
        ""
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        ""
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        ""
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        "Impostazioni"
      ],
      "title\u0004%1$s: New bank account": [
        ""
      ],
      "title\u0004%1$s: Bank accounts": [
        ""
      ],
      "title\u0004%1$s: Update bank Account": [
        ""
      ],
      "title\u0004%1$s: Orders": [
        ""
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        ""
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        ""
      ],
      "title\u0004%1$s: Wire transfers": [
        ""
      ],
      "title\u0004%1$s: Webhooks": [
        ""
      ],
      "title\u0004%1$s: New webhook": [
        ""
      ],
      "title\u0004%1$s: Update webhook": [
        ""
      ],
      "title\u0004%1$s: OTP devices": [
        ""
      ],
      "title\u0004%1$s: New OTP device": [
        ""
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        ""
      ],
      "title\u0004%1$s: Update template": [
        ""
      ],
      "title\u0004%1$s: Templates": [
        ""
      ],
      "title\u0004%1$s: Use template": [
        ""
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        ""
      ],
      "title\u0004%1$s: Access tokens": [
        ""
      ],
      "title\u0004%1$s: New access token": [
        ""
      ],
      "title\u0004New instance": [
        ""
      ],
      "title\u0004Instances": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=n != 1;",
  "lang": "it",
  "completeness": 2
};

strings['he'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=4; plural=(n == 1) ? 0 : ((n == 2) ? 1 : ((n > 10 && n % 10 == 0) ? 2 : 3));",
        "lang": "he"
      },
      "Cancel": [
        ""
      ],
      "%1$s": [
        ""
      ],
      "Close": [
        ""
      ],
      "Continue": [
        ""
      ],
      "Clear": [
        ""
      ],
      "Confirm": [
        ""
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        ""
      ],
      "Host": [
        ""
      ],
      "Account ID": [
        ""
      ],
      "The account owner's legal name": [
        ""
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        ""
      ],
      "Bank host": [
        ""
      ],
      "Bank account": [
        ""
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        ""
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        ""
      ],
      "Receiver postal code": [
        ""
      ],
      "Receiver town": [
        ""
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        ""
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        ""
      ],
      "days": [
        ""
      ],
      "hours": [
        ""
      ],
      "minutes": [
        ""
      ],
      "seconds": [
        ""
      ],
      "Forever": [
        ""
      ],
      "%1$sM": [
        ""
      ],
      "%1$sY": [
        ""
      ],
      "%1$sd": [
        ""
      ],
      "%1$sh": [
        ""
      ],
      "%1$smin": [
        ""
      ],
      "%1$ssec": [
        ""
      ],
      "Change value to never": [
        ""
      ],
      "Change value to empty": [
        ""
      ],
      "Image must be smaller than 1 MB": [
        ""
      ],
      "Add": [
        ""
      ],
      "Remove": [
        ""
      ],
      "Country": [
        ""
      ],
      "Building number": [
        ""
      ],
      "Building name": [
        ""
      ],
      "Street": [
        ""
      ],
      "Post code": [
        ""
      ],
      "Town location": [
        ""
      ],
      "District": [
        ""
      ],
      "Country subdivision": [
        ""
      ],
      "Additional address lines": [
        ""
      ],
      "Orders": [
        ""
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        ""
      ],
      "Templates": [
        ""
      ],
      "Product groups": [
        ""
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        ""
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        ""
      ],
      "Settings": [
        ""
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        ""
      ],
      "Connection": [
        ""
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        ""
      ],
      "New": [
        ""
      ],
      "List": [
        ""
      ],
      "Log out": [
        ""
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        ""
      ],
      "Business name": [
        ""
      ],
      "Legal name of the business represented by this instance.": [
        ""
      ],
      "Email": [
        ""
      ],
      "Contact email": [
        ""
      ],
      "Phone number": [
        ""
      ],
      "Contact phone": [
        ""
      ],
      "Website URL": [
        ""
      ],
      "URL.": [
        ""
      ],
      "Logo": [
        ""
      ],
      "Logo image.": [
        ""
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        ""
      ],
      "Jurisdiction": [
        ""
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        ""
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        ""
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        ""
      ],
      "Refund delay": [
        ""
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        ""
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        ""
      ],
      "Wire transfer rounding": [
        ""
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        ""
      ],
      "To second": [
        ""
      ],
      "To minute": [
        ""
      ],
      "To hour": [
        ""
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        ""
      ],
      "Required": [
        ""
      ],
      "Unauthorized": [
        ""
      ],
      "The code is not correct.": [
        ""
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        ""
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        ""
      ],
      "Verify": [
        ""
      ],
      "Failed to send the verification code.": [
        ""
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Login required": [
        ""
      ],
      "Instance name.": [
        ""
      ],
      "Instance password.": [
        ""
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        ""
      ],
      "Invalid": [
        ""
      ],
      "Doesn't have the pattern of an email": [
        ""
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        ""
      ],
      "Max 7 lines": [
        ""
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        ""
      ],
      "Unauthorized.": [
        ""
      ],
      "Conflict.": [
        ""
      ],
      "Not found.": [
        ""
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        ""
      ],
      "Repeat password": [
        ""
      ],
      "Confirm the same password": [
        ""
      ],
      "Please complete the marked fields and choose authorization method": [
        ""
      ],
      "Confirm operation": [
        ""
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        ""
      ],
      "Description": [
        ""
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        ""
      ],
      "Time the access token will be valid.": [
        ""
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        ""
      ],
      "Read only": [
        ""
      ],
      "All": [
        ""
      ],
      "Order simple": [
        ""
      ],
      "Order Point-of-Sale": [
        ""
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        ""
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        ""
      ],
      "Please complete the marked fields": [
        ""
      ],
      "Access token created": [
        ""
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        ""
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        ""
      ],
      "Create access token": [
        ""
      ],
      "Load more devices before the first one": [
        ""
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        ""
      ],
      "Expires at": [
        ""
      ],
      "Never": [
        ""
      ],
      "Remove this access token": [
        ""
      ],
      "Delete": [
        ""
      ],
      "Load more devices after the last one": [
        ""
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        ""
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        ""
      ],
      "Deleting an access token cannot be undone.": [
        ""
      ],
      "This is not a valid Bitcoin address.": [
        ""
      ],
      "This is not a valid Ethereum address.": [
        ""
      ],
      "This is not a valid host.": [
        ""
      ],
      "IBANs usually have more than 4 digits.": [
        ""
      ],
      "IBANs usually have fewer than 34 digits.": [
        ""
      ],
      "The IBAN's country code could not be retrieved.": [
        ""
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        ""
      ],
      "This account is not allowed.": [
        ""
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        ""
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        ""
      ],
      "Routing": [
        ""
      ],
      "Routing number": [
        ""
      ],
      "Account": [
        ""
      ],
      "Account number": [
        ""
      ],
      "Code": [
        ""
      ],
      "Business Identifier Code": [
        ""
      ],
      "International Bank Account Number": [
        ""
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        ""
      ],
      "Bitcoin protocol": [
        ""
      ],
      "Ethereum protocol": [
        ""
      ],
      "Interledger protocol": [
        ""
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        ""
      ],
      "Name of the account holder": [
        ""
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        ""
      ],
      "Invalid url": [
        ""
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        ""
      ],
      "Server replied with \"bad request\".": [
        ""
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        ""
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        ""
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        ""
      ],
      "Do not change": [
        ""
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        ""
      ],
      "Account details": [
        ""
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        ""
      ],
      "Delete account": [
        ""
      ],
      "Delete the account \"%1$s\"": [
        ""
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        ""
      ],
      "Bank accounts": [
        ""
      ],
      "Add new account": [
        ""
      ],
      "Owner's name": [
        ""
      ],
      "Delete selected accounts from the database": [
        ""
      ],
      "There are no accounts yet, add more pressing the + sign": [
        ""
      ],
      "You must provide a bank account to receive payments.": [
        ""
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        ""
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        ""
      ],
      "Add new devices": [
        ""
      ],
      "ID": [
        ""
      ],
      "Total products": [
        ""
      ],
      "Delete selected category from the database": [
        ""
      ],
      "There are no categories yet, add more pressing the + sign": [
        ""
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        ""
      ],
      "Products": [
        ""
      ],
      "Image": [
        ""
      ],
      "Load more products after the last one": [
        ""
      ],
      "There are no products in this category.": [
        ""
      ],
      "Account's KYC status": [
        ""
      ],
      "Exchange": [
        ""
      ],
      "Status": [
        ""
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        ""
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        ""
      ],
      "More information required.": [
        ""
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        ""
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        ""
      ],
      "The account for wire transfers does not appear to be valid": [
        ""
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        ""
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        ""
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        ""
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        ""
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        ""
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        ""
      ],
      "Enter description or id": [
        ""
      ],
      "No match found for that description or ID.": [
        ""
      ],
      "You must enter a valid product identifier.": [
        ""
      ],
      "Quantity must be greater than 0!": [
        ""
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        ""
      ],
      "Search product": [
        ""
      ],
      "Quantity": [
        ""
      ],
      "How many products will be added": [
        ""
      ],
      "Add from inventory": [
        ""
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        ""
      ],
      "Amount": [
        ""
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        ""
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        ""
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        ""
      ],
      "Add tax to the tax list": [
        ""
      ],
      "Describe and add a product that is not in the inventory list": [
        ""
      ],
      "Add custom product": [
        ""
      ],
      "Complete information of the product": [
        ""
      ],
      "Must be a number.": [
        ""
      ],
      "Must be greater than 0.": [
        ""
      ],
      "Photo of the product.": [
        ""
      ],
      "Full product description.": [
        ""
      ],
      "Unit name": [
        ""
      ],
      "Name of the product unit.": [
        ""
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        ""
      ],
      "How many products will be added.": [
        ""
      ],
      "Taxes": [
        ""
      ],
      "Total price": [
        ""
      ],
      "Must be greater than 0": [
        ""
      ],
      "Must have a refund deadline": [
        ""
      ],
      "Auto refund can't be after refund deadline": [
        ""
      ],
      "Must be in the future": [
        ""
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        ""
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        ""
      ],
      "%1$s products with a total price of %2$s.": [
        ""
      ],
      "Manage list of products in the order.": [
        ""
      ],
      "Remove this product from the order.": [
        ""
      ],
      "Products price sum": [
        ""
      ],
      "Total product price added up": [
        ""
      ],
      "Order price": [
        ""
      ],
      "Amount to be paid by the customer": [
        ""
      ],
      "Final order price": [
        ""
      ],
      "Summary": [
        ""
      ],
      "Title of the order to be shown to the customer": [
        ""
      ],
      "Shipping and fulfillment": [
        ""
      ],
      "Delivery date": [
        ""
      ],
      "Deadline for physical delivery assured by the merchant.": [
        ""
      ],
      "Delivery location": [
        ""
      ],
      "Address where the products will be delivered": [
        ""
      ],
      "Fulfillment URL": [
        ""
      ],
      "URL to which the user will be redirected after successful payment.": [
        ""
      ],
      "Fulfillment message": [
        ""
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        ""
      ],
      "Override default Taler payment settings for this order": [
        ""
      ],
      "Payment time": [
        ""
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        ""
      ],
      "Default": [
        ""
      ],
      "Refund time": [
        ""
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        ""
      ],
      "Wire transfer time": [
        ""
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        ""
      ],
      "Auto-refund time": [
        ""
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        ""
      ],
      "Maximum fee": [
        ""
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        ""
      ],
      "Create token": [
        ""
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        ""
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        ""
      ],
      "Minimum age defined by the products is %1$s": [
        ""
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        ""
      ],
      "Custom information to be included in the contract for this order.": [
        ""
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        ""
      ],
      "remove": [
        ""
      ],
      "Custom field name": [
        ""
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        ""
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        ""
      ],
      "Only show unpaid orders": [
        ""
      ],
      "Only show paid orders": [
        ""
      ],
      "Paid": [
        ""
      ],
      "Only show orders with refunds": [
        ""
      ],
      "Refunded": [
        ""
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        ""
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        ""
      ],
      "Completed": [
        ""
      ],
      "Remove all filters": [
        ""
      ],
      "Clear date filter": [
        ""
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        ""
      ],
      "Order id": [
        ""
      ],
      "Instance unknown": [
        ""
      ],
      "Order unknown": [
        ""
      ],
      "Create order": [
        ""
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        ""
      ],
      "Refund": [
        ""
      ],
      "copy url": [
        ""
      ],
      "Load more orders after the last one": [
        ""
      ],
      "No orders have been found matching your query!": [
        ""
      ],
      "Duplicated": [
        ""
      ],
      "This value exceeds the refundable amount.": [
        ""
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        ""
      ],
      "Reason": [
        ""
      ],
      "Amount to be refunded": [
        ""
      ],
      "Max refundable:": [
        ""
      ],
      "Choose one...": [
        ""
      ],
      "Requested by the customer": [
        ""
      ],
      "Other": [
        ""
      ],
      "Why this order is being refunded": [
        ""
      ],
      "More information to give context": [
        ""
      ],
      "now": [
        ""
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        ""
      ],
      "This wire transfer has been notified by the payment service provider.": [
        ""
      ],
      "This refund is waiting to be claimed by the customer.": [
        ""
      ],
      "This refund has been claimed by the customer.": [
        ""
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        ""
      ],
      "Human-readable description of the whole purchase": [
        ""
      ],
      "Total price for the transaction": [
        ""
      ],
      "URL for this purchase": [
        ""
      ],
      "Max fee": [
        ""
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        ""
      ],
      "Time when this contract was generated": [
        ""
      ],
      "Payment deadline": [
        ""
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        ""
      ],
      "Refund deadline": [
        ""
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        ""
      ],
      "Wire transfer deadline": [
        ""
      ],
      "Transfer deadline for the exchange": [
        ""
      ],
      "Time indicating when the order should be delivered": [
        ""
      ],
      "Where the order will be delivered": [
        ""
      ],
      "Auto-refund delay": [
        ""
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        ""
      ],
      "Extra info": [
        ""
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        ""
      ],
      "order created": [
        ""
      ],
      "pay deadline": [
        ""
      ],
      "refund deadline": [
        ""
      ],
      "delivery": [
        ""
      ],
      "Order": [
        ""
      ],
      "Claimed": [
        ""
      ],
      "Claimed at": [
        ""
      ],
      "Timeline": [
        ""
      ],
      "Payment details": [
        ""
      ],
      "Order status": [
        ""
      ],
      "Unpaid": [
        ""
      ],
      "Product list": [
        ""
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        ""
      ],
      "refund created: %1$s: %2$s": [
        ""
      ],
      "refund taken: %1$s": [
        ""
      ],
      "refund taken: %1$s: %2$s": [
        ""
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        ""
      ],
      "Wired": [
        ""
      ],
      "Refund order": [
        ""
      ],
      "Not refundable": [
        ""
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        ""
      ],
      "Refund taken": [
        ""
      ],
      "Status URL": [
        ""
      ],
      "Refund URI": [
        ""
      ],
      "Pay at": [
        ""
      ],
      "Order status URL": [
        ""
      ],
      "Payment URI": [
        ""
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        ""
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        ""
      ],
      "The size of the key must be 32 characters": [
        ""
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        ""
      ],
      "Algorithm used to verify transactions in offline mode": [
        ""
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        ""
      ],
      "Random": [
        ""
      ],
      "Create another": [
        ""
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        ""
      ],
      "Delete selected devices from the database": [
        ""
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        ""
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        ""
      ],
      "Algorithm to use to verify transactions in offline mode": [
        ""
      ],
      "Not modified": [
        ""
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        ""
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        ""
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        ""
      ],
      "Testing password change": [
        ""
      ],
      "Password changed": [
        ""
      ],
      "The current password is wrong.": [
        ""
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        ""
      ],
      "Add element to the list": [
        ""
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        ""
      ],
      "Manage stock": [
        ""
      ],
      "This product has been configured without stock control": [
        ""
      ],
      "Infinite": [
        ""
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        ""
      ],
      "Incoming": [
        ""
      ],
      "Lost": [
        ""
      ],
      "Current": [
        ""
      ],
      "Remove stock control for this product": [
        ""
      ],
      "without stock": [
        ""
      ],
      "Next restock": [
        ""
      ],
      "Warehouse address": [
        ""
      ],
      "Invalid amount": [
        ""
      ],
      "Product identification to use in URLs (for internal use only).": [
        ""
      ],
      "Illustration of the product for customers.": [
        ""
      ],
      "Product name.": [
        ""
      ],
      "Product description for customers.": [
        ""
      ],
      "Age restriction": [
        ""
      ],
      "Is this product restricted for customer below certain age?": [
        ""
      ],
      "Minimum age of the customer": [
        ""
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        ""
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        ""
      ],
      "Stock": [
        ""
      ],
      "Inventory for products with finite supply (for internal use only).": [
        ""
      ],
      "Taxes included in the product price, exposed to customers.": [
        ""
      ],
      "Search by category description or id": [
        ""
      ],
      "Categories where this product will be listed on.": [
        ""
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        ""
      ],
      "Money pots where this product will be listed on.": [
        ""
      ],
      "Select one": [
        ""
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        ""
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        ""
      ],
      "Product not found.": [
        ""
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        ""
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        ""
      ],
      "Update": [
        ""
      ],
      "Remove this product from the database": [
        ""
      ],
      "Update the product with new price": [
        ""
      ],
      "Update product with new price": [
        ""
      ],
      "Confirm update": [
        ""
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        ""
      ],
      "Add more elements to the inventory": [
        ""
      ],
      "Report elements lost in the inventory": [
        ""
      ],
      "New price for the product": [
        ""
      ],
      "There are values with errors.": [
        ""
      ],
      "Update product with new stock and price": [
        ""
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        ""
      ],
      "Product (ID: %1$s) has been deleted": [
        ""
      ],
      "Jump to product with the given product ID": [
        ""
      ],
      "Product id": [
        ""
      ],
      "Delete product": [
        ""
      ],
      "Delete the product \"%1$s\"": [
        ""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        ""
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        ""
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        ""
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        ""
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        ""
      ],
      "hour": [
        ""
      ],
      "day": [
        ""
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        ""
      ],
      "Time range": [
        ""
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        ""
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        ""
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        ""
      ],
      "Too short": [
        ""
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        ""
      ],
      "Name of the template in URLs.": [
        ""
      ],
      "Template name": [
        ""
      ],
      "Describe what this template stands for": [
        ""
      ],
      "Order summary": [
        ""
      ],
      "If specified here, this template will create orders with the same summary": [
        ""
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        ""
      ],
      "Amount is editable": [
        ""
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        ""
      ],
      "Is this contract restricted to some age?": [
        ""
      ],
      "Payment timeout": [
        ""
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        ""
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        ""
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        ""
      ],
      "Load more templates before the first one": [
        ""
      ],
      "Delete selected templates from the database": [
        ""
      ],
      "Use template to create new order": [
        ""
      ],
      "Generate a QR code for the template.": [
        ""
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        ""
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        ""
      ],
      "Jump to template with the given template ID": [
        ""
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        ""
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        ""
      ],
      "Print": [
        ""
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        ""
      ],
      "If specified, this template will create orders with the same price": [
        ""
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        ""
      ],
      "An amount is required": [
        ""
      ],
      "An order summary is required": [
        ""
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        ""
      ],
      "Amount of the order": [
        ""
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        ""
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        ""
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        ""
      ],
      "Go to token family update page": [
        ""
      ],
      "Remove this token family from the database": [
        ""
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        ""
      ],
      "Token family has been deleted.": [
        ""
      ],
      "Delete token family": [
        ""
      ],
      "Delete the token family \"%1$s\"": [
        ""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        ""
      ],
      "Deleting a token family %1$s .": [
        ""
      ],
      "can't be undone": [
        ""
      ],
      "Token Family: %1$s": [
        ""
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        ""
      ],
      "Incoming wire transfers": [
        ""
      ],
      "Load more wire transfers preceding the first one": [
        ""
      ],
      "Expected credit": [
        ""
      ],
      "Confirmed": [
        ""
      ],
      "Validated": [
        ""
      ],
      "Executed on": [
        ""
      ],
      "yes": [
        ""
      ],
      "no": [
        ""
      ],
      "never": [
        ""
      ],
      "unknown": [
        ""
      ],
      "Load more transfers after the last one": [
        ""
      ],
      "Verified wire transfers": [
        ""
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        ""
      ],
      "All accounts": [
        ""
      ],
      "Filter by account address": [
        ""
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        ""
      ],
      "Only show wire transfers confirmed by the merchant": [
        ""
      ],
      "Verified": [
        ""
      ],
      "Wire transfer already confirmed.": [
        ""
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        ""
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        ""
      ],
      "Transfer ID": [
        ""
      ],
      "It's not the same.": [
        ""
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        ""
      ],
      "Instance": [
        ""
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        ""
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        ""
      ],
      "Delete this instance": [
        ""
      ],
      "Must be one of '%1$s'": [
        ""
      ],
      "URL is invalid": [
        ""
      ],
      "Webhook ID to use": [
        ""
      ],
      "Event": [
        ""
      ],
      "Payment": [
        ""
      ],
      "Order settled": [
        ""
      ],
      "Category added": [
        ""
      ],
      "Category updated": [
        ""
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        ""
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        ""
      ],
      "Method": [
        ""
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        ""
      ],
      "URL": [
        ""
      ],
      "URL of the webhook where the customer will be redirected": [
        ""
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        ""
      ],
      "order's price": [
        ""
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        ""
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        ""
      ],
      "Header template of the webhook": [
        ""
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        ""
      ],
      "Webhook deleted successfully": [
        ""
      ],
      "Add new webhooks": [
        ""
      ],
      "Load more webhooks before the first one": [
        ""
      ],
      "Event type": [
        ""
      ],
      "Delete selected webhook from the database": [
        ""
      ],
      "Load more webhooks after the last one": [
        ""
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        ""
      ],
      "Webhook updated": [
        ""
      ],
      "Header": [
        ""
      ],
      "Body": [
        ""
      ],
      "Body template used by the webhook": [
        ""
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        ""
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        ""
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        ""
      ],
      "Resetting access to the instance \"%1$s\"": [
        ""
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        ""
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        ""
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        ""
      ],
      "Add new pots": [
        ""
      ],
      "Load more pots before the first one": [
        ""
      ],
      "Total": [
        ""
      ],
      "Delete selected pots from the database": [
        ""
      ],
      "Load more pots after the last one": [
        ""
      ],
      "There are no money pots yet, add more pressing the + sign": [
        ""
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        ""
      ],
      "Invalid amount \"%1$s\": %2$s": [
        ""
      ],
      "Descripton": [
        ""
      ],
      "Totals": [
        ""
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        ""
      ],
      "Add new group": [
        ""
      ],
      "Load more groups before the first one": [
        ""
      ],
      "Delete selected group from the database": [
        ""
      ],
      "Load more groups after the last one": [
        ""
      ],
      "There are no product groups yet, add more pressing the + sign": [
        ""
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        ""
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        ""
      ],
      "There are no reports yet, add more pressing the + sign": [
        ""
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        ""
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        ""
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        ""
      ],
      "KYC verification needed": [
        ""
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        ""
      ],
      "Unexpected error.": [
        ""
      ],
      "Add new instance": [
        ""
      ],
      "Edit": [
        ""
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        ""
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        ""
      ],
      "Only show active instances": [
        ""
      ],
      "Active": [
        ""
      ],
      "Only show deleted instances": [
        ""
      ],
      "Deleted": [
        ""
      ],
      "Show all instances": [
        ""
      ],
      "Delete instance": [
        ""
      ],
      "Delete the instance \"%1$s\"": [
        ""
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        ""
      ],
      "This cannot be undone!": [
        ""
      ],
      "Purge the instance": [
        ""
      ],
      "Purge the instance \"%1$s\"": [
        ""
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        ""
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        ""
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        ""
      ],
      "title\u0004%1$s: New bank account": [
        ""
      ],
      "title\u0004%1$s: Bank accounts": [
        ""
      ],
      "title\u0004%1$s: Update bank Account": [
        ""
      ],
      "title\u0004%1$s: Orders": [
        ""
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        ""
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        ""
      ],
      "title\u0004%1$s: Wire transfers": [
        ""
      ],
      "title\u0004%1$s: Webhooks": [
        ""
      ],
      "title\u0004%1$s: New webhook": [
        ""
      ],
      "title\u0004%1$s: Update webhook": [
        ""
      ],
      "title\u0004%1$s: OTP devices": [
        ""
      ],
      "title\u0004%1$s: New OTP device": [
        ""
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        ""
      ],
      "title\u0004%1$s: Update template": [
        ""
      ],
      "title\u0004%1$s: Templates": [
        ""
      ],
      "title\u0004%1$s: Use template": [
        ""
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        ""
      ],
      "title\u0004%1$s: Access tokens": [
        ""
      ],
      "title\u0004%1$s: New access token": [
        ""
      ],
      "title\u0004New instance": [
        ""
      ],
      "title\u0004Instances": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=4; plural=(n == 1) ? 0 : ((n == 2) ? 1 : ((n > 10 && n % 10 == 0) ? 2 : 3));",
  "lang": "he",
  "completeness": 0
};

strings['fr'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=(n!=1);",
        "lang": "fr"
      },
      "Cancel": [
        "Annuler"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        "Fermer"
      ],
      "Continue": [
        "Continuer"
      ],
      "Clear": [
        "Effacer"
      ],
      "Confirm": [
        "Confirmer"
      ],
      "Correct form": [
        "Corriger le formulaire"
      ],
      "Comparing account details": [
        "Comparaison des informations sur le compte"
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        "La connexion à l'URL de l'information du compte a réussi, mais les données obtenues diffèrent de celles saisies dans le formulaire."
      ],
      "Field": [
        "Champ"
      ],
      "In the form": [
        "Dans le formulaire"
      ],
      "Reported": [
        "Rapporté"
      ],
      "Type": [
        "Type"
      ],
      "IBAN": [
        "IBAN"
      ],
      "Address": [
        "Adresse"
      ],
      "Host": [
        "Hôte"
      ],
      "Account ID": [
        "Identifiant"
      ],
      "The account owner's legal name": [
        "Le nom légal de la personne titulaire du compte"
      ],
      "The postal code of the account owner's address": [
        "Le code postal de la personne titulaire du compte"
      ],
      "Town": [
        "Ville"
      ],
      "Bank host": [
        "Serveur de la banque"
      ],
      "Bank account": [
        "Compte bancaire"
      ],
      "BIC": [
        "Code BIC"
      ],
      "OK": [
        "D'accord"
      ],
      "Validate bank account: %1$s": [
        "Valider le compte bancaire : %1$s"
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        "Afin de prouver que vous êtes bien le bénéficiaire du compte bancaire, vous devez transférer un petit montant au compte bancaire spécifié avec le sujet suivant."
      ],
      "Step 1:": [
        "Étape 1 :"
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        "Copiez et collez l'IBAN et le nom légal du titulaire du compte dans le champ de votre application bancaire ou votre site web réservé au destinataire du virement."
      ],
      "Beneficiary": [
        "Bénéficiaire"
      ],
      "Step 2:": [
        "Étape 2 :"
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        "Copiez ce code et collez-le dans le champ 'référence/objet' de votre application bancaire ou du site web de votre banque."
      ],
      "Subject": [
        "Référence"
      ],
      "Receiver postal code": [
        "Code postal de la personne bénéficiaire"
      ],
      "Receiver town": [
        "Ville de la personnes bénéficiaire"
      ],
      "Step 3:": [
        "Étape 3 :"
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        "Sélectionnez le montant le plus petit possible pour un virement bancaire dans votre application bancaire ou sur le site Web de votre banque en ligne."
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        "Assurez-vous que L'ENSEMBLE des données sont correctes, y compris la "
      ],
      "Verification code": [
        "Code de vérification"
      ],
      "It will expire at %1$s": [
        "Il expirera à %1$s"
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        "Le défi a expiré et ne peut plus être résolu mais vous pouvez revenir en arrière et recommencer."
      ],
      "Back": [
        "Retour"
      ],
      "Verify": [
        "Vérifier"
      ],
      "Failed to send the verification code.": [
        "Echec de l'envoi du code de vérification."
      ],
      "The request was valid, but the server is refusing action.": [
        "La requête était valide, mais le serveur refuse de l'honorer."
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Le système ne reconnaît pas ce facteur d'identification."
      ],
      "Code transmission failed.": [
        "La transmission du code a échoué."
      ],
      "Already solved.": [
        "Déjà résolu."
      ],
      "It is too early to request another transmission of the challenge.": [
        "C'est trop tôt pour demander une nouvelle transmission de ce défi."
      ],
      "Multi-factor authentication required.": [
        "L'identification multi-facteurs est requise."
      ],
      "You need to complete all of this requirements.": [
        "Vous devez répondre à l'ensemble des exigences."
      ],
      "You need to complete at least one of this requirements.": [
        "Vous devez répondre à au-moins l'une de ces exigences."
      ],
      "An SMS to the phone number ending with %1$s": [
        "Un SMS au numéro de téléphone se terminant par \"%1$s\""
      ],
      "An email to the address starting with %1$s": [
        "Un courriel à l'adresse commençant par \"%1$s\""
      ],
      "You have to wait until %1$s to send a new code.": [
        "Vous devez attendre jusqu'à %1$s pour envoyer un nouveau code."
      ],
      "I have a code": [
        "J'ai un code"
      ],
      "Send me a message": [
        "Envoyez-moi un message"
      ],
      "Logged in": [
        "Identifié"
      ],
      "Not found": [
        "Introuvable"
      ],
      "Login required": [
        "Identification requise"
      ],
      "Instance name.": [
        "Identifiant de la boutique."
      ],
      "Instance password.": [
        "Mot de passe de la boutique."
      ],
      "Forgot password": [
        "J'ai oublié mon mot de passe"
      ],
      "Create new account": [
        "Créer un nouveau compte"
      ],
      "Invalid": [
        "Invalide"
      ],
      "Doesn't have the pattern of an email": [
        "Cela ne ressemble pas à une addresse de courriel"
      ],
      "Should start with +": [
        "Le numéro international devrait commencer par +"
      ],
      "A phone number consists of numbers only": [
        "Un numéro de téléphone n'est composé que de chiffres"
      ],
      "Invalid value": [
        "Valeur invalide"
      ],
      "Max 7 lines": [
        "Sept lignes au maximum"
      ],
      "Doesn't match": [
        "Ne correspond pas"
      ],
      "Instance created": [
        "La boutique a été créée"
      ],
      "Unauthorized.": [
        "Non autorisé."
      ],
      "Conflict.": [
        "Conflit."
      ],
      "Not found.": [
        "Introuvable."
      ],
      "New password": [
        "Nouveau mot de passe"
      ],
      "Next password to be used": [
        "Prochain mot de passe à utiliser"
      ],
      "Repeat password": [
        "Répéter le mot de passe"
      ],
      "Confirm the same password": [
        "Confirmer ce mot de passe"
      ],
      "Please complete the marked fields and choose authorization method": [
        "Merci de remplir les champs marqués et de choisir une méthode d'autorisation"
      ],
      "Confirm operation": [
        "Confirmer l'opération"
      ],
      "Check the password.": [
        "Vérifier le mot de passe."
      ],
      "Instance not found.": [
        "La boutique est introuvable."
      ],
      "Description": [
        "Description"
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        "Cela vous aide à vous remémorer où ce jeton d'accès est utilisé avant de l'effacer."
      ],
      "Duration": [
        "Durée"
      ],
      "Time the access token will be valid.": [
        "Durée de validité du jeton d'accès."
      ],
      "Refreshable access tokens can pose a security risk!": [
        "Les jetons d'accès renouvelables peuvent poser un risque de sécurité !"
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        "La durée des jetons d'accès renouvelables peut être étendue avant leur expiration, ce qui procure à quiconque l'utilise un accès indéfini. N'utilisez cette méthode que si vous savez ce que vous faîtes et avez évalué les risques associés notamment aux permissions accordées dans ce contexte."
      ],
      "Scope": [
        "Contexte"
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        "Le contexte définit un jeu de privilèges pour le jeton d'accès. Les jetons renouvelables possèdent le privilège d'étendre leur durée de vie."
      ],
      "Allows all operations without limit.": [
        "Permettre toutes les opérations sans limite."
      ],
      "Allows all operations to read information.": [
        "Permettre toutes les opérations de lecture."
      ],
      "Allows the creation of orders and checking of payment status.": [
        "Permettre la création de commandes et la vérification de l'état des paiements."
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        "Permettre la création des commandes, la vérification de l'état des paiements et le vérouillage des stocks."
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        "Permettre la création des commandes, la vérification de l'état des paiements et des remboursements."
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        "Permettre la création des commandes, la vérification de l'état des paiements, le vérouillage des stocks et des remboursements."
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        "\n\n#. screenid: 29\n#: packages/merchant-backoffice-ui/src/paths/instance/accessTokens/create/CreatePage.tsx:224\n#, c-format\nmsgid \n",
        "Le serveur a renvoyé une réponse invalide : \"%1$s\"."
      ],
      "No exchange keys": [
        "Aucune clé d'échange"
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        "Le serveur est encore en cours de synchronisation avec le fournisseur de service de paiement."
      ],
      "No transfers can be made from this account": [
        "Aucun virement bancaire ne peut être effectué depuis ce compte."
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        "Le système bancaire ne peut pas effectuer de virement entre les comptes du fournisseur de service de paiement et vos comptes en banque. Aussi vous ne "
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        "Le prestataire du service de paiement requière une vérification du compte."
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        "Vous définissez le jeton d'accès pour la nouvelle instance"
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        "Interface"
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        "Devises prises en charge"
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        "Changer la valeur pour une date inconnue"
      ],
      "Enter description or id": [
        "Entrez soit une description soit un identifiant"
      ],
      "No match found for that description or ID.": [
        "aucune correspondance de trouvée pour cette description ou cet identifiant"
      ],
      "You must enter a valid product identifier.": [
        "Vous devez entrer un identifiant de produit valide."
      ],
      "Quantity must be greater than 0!": [
        "La quantité doit être supérieure à 0 !"
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        "Cette quantité dépasse le stock restant. Actuellement, il ne reste que %1$s unités non réservées en stock."
      ],
      "Search product": [
        "Recherche produit"
      ],
      "Quantity": [
        "Quantité"
      ],
      "How many products will be added": [
        "Combien de produits seront ajoutés"
      ],
      "Add from inventory": [
        "Ajouter depuis l'inventaire"
      ],
      "This product has %1$s applicable taxes configured.": [
        "Ce produit a %1$s taxes applicables configurées."
      ],
      "No taxes configured for this product.": [
        "Aucune taxe n'est configurée pour ce produit."
      ],
      "Amount": [
        "Montant"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        "Les taxes peuvent être libellées dans des monnaies différentes de la monnaie principale utilisée par le commerçant."
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        "Saisissez la devise et la valeur séparées par deux points, par exemple &quot;USD:2.3&quot ;."
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        "Nom légal de la taxe, par exemple TVA ou droits d'importation."
      ],
      "Add tax to the tax list": [
        "Ajouter une taxe à la liste des taxes"
      ],
      "Describe and add a product that is not in the inventory list": [
        "Décrire et ajouter un produit qui ne figure pas dans la liste d'inventaire"
      ],
      "Add custom product": [
        "Ajouter un produit personnalisé"
      ],
      "Complete information of the product": [
        "Informations complètes sur le produit"
      ],
      "Must be a number.": [
        "Doit être un nombre"
      ],
      "Must be greater than 0.": [
        "Doit être supérieur à 0"
      ],
      "Photo of the product.": [
        "Photo du produit."
      ],
      "Full product description.": [
        "Description détaillée du produit."
      ],
      "Unit name": [
        "Nom de l'unité"
      ],
      "Name of the product unit.": [
        "Nom de l'unité du produit."
      ],
      "Price per unit": [
        "Prix à l'unité"
      ],
      "Amount in the current currency.": [
        "Montant dans la monnaie courante."
      ],
      "How many products will be added.": [
        "Combien de produits seront ajoutés."
      ],
      "Taxes": [
        "Taxes"
      ],
      "Total price": [
        "Prix total"
      ],
      "Must be greater than 0": [
        "Doit être supérieur à 0"
      ],
      "Must have a refund deadline": [
        "Le délai de remboursement doit être fixé"
      ],
      "Auto refund can't be after refund deadline": [
        "Le remboursement automatique ne peut pas être effectué après la date limite de remboursement"
      ],
      "Must be in the future": [
        "Doit être dans le future"
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        "Ceci n'est pas un serveur valide."
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        "Aucun exchange ne pourra accepter le paiement en raison des exigences en matière de connaissance du client (procédure KYC)."
      ],
      "Manage products in order": [
        "Gérer les produits dans l'ordre"
      ],
      "%1$s products with a total price of %2$s.": [
        "%1$s produits pour un prix total de %2$s."
      ],
      "Manage list of products in the order.": [
        "Gérer la liste des produits dans la commande."
      ],
      "Remove this product from the order.": [
        "Retirer ce produit de la commande."
      ],
      "Products price sum": [
        "Liste des produits"
      ],
      "Total product price added up": [
        "Prix total des produits additionnés"
      ],
      "Order price": [
        "Prix par article"
      ],
      "Amount to be paid by the customer": [
        "Montant à payer par le client"
      ],
      "Final order price": [
        "Prix final de la commande"
      ],
      "Summary": [
        "Résumé"
      ],
      "Title of the order to be shown to the customer": [
        "Titre de la commande à afficher au client"
      ],
      "Shipping and fulfillment": [
        "Expédition et traitement des commandes"
      ],
      "Delivery date": [
        "Date de livraison"
      ],
      "Deadline for physical delivery assured by the merchant.": [
        "Date limite de livraison physique assurée par le commerçant."
      ],
      "Delivery location": [
        "Date de livraison"
      ],
      "Address where the products will be delivered": [
        "Adresse de livraison des produits"
      ],
      "Fulfillment URL": [
        "URL du service de traitement des commandes"
      ],
      "URL to which the user will be redirected after successful payment.": [
        "URL vers laquelle l'utilisateur sera redirigé après un paiement réussi."
      ],
      "Fulfillment message": [
        "URL du service de traitement des commandes"
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        "Options de paiement Taler"
      ],
      "Override default Taler payment settings for this order": [
        "Remplacer les paramètres de paiement par défaut de Taler pour cette commande"
      ],
      "Payment time": [
        "Délai de paiement"
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        "Délai accordé au client pour payer l'offre avant qu'elle n'expire. Les produits en stock seront réservés jusqu'à cette date. Le temps commence à courir après la création de la commande."
      ],
      "Default": [
        "Par défaut"
      ],
      "Refund time": [
        "Délai de remboursement"
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        "Délai pendant lequel la commande peut être remboursée par le commerçant. Le temps commence à la création de la commande."
      ],
      "Wire transfer time": [
        "Délai de virement"
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        "Temps nécessaire à l'exchange pour effectuer le virement. Le temps commence à la création de la commande."
      ],
      "Auto-refund time": [
        "Délai de remboursement automatique"
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        "Délai jusqu'auquel le portefeuille vérifiera automatiquement les remboursements sans intervention de l'utilisateur."
      ],
      "Maximum fee": [
        "Frais maximums"
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        "Frais maximums que le commerçant est prêt à couvrir pour cette commande. Les frais de dépôt plus élevés doivent être intégralement pris en charge par le consommateur."
      ],
      "Create token": [
        "Créer un jeton"
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        "Si l'identifiant de la commande est facile à deviner, le jeton empêchera les utilisateurs de voler les commandes d'autres personnes."
      ],
      "Minimum age required": [
        "Âge minimum requis"
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        "Toute valeur supérieure à 0 limitera le type de pièces pouvant être utilisées pour payer ce contrat. Si la valeur est vide, la restriction d'âge sera définie par les produits"
      ],
      "Minimum age defined by the products is %1$s": [
        "L'âge minimum défini par les produits est de %1$s"
      ],
      "No product with age restriction in this order": [
        "Aucun produit avec restriction d'âge dans cette commande"
      ],
      "Additional information": [
        "Informations complémentaires"
      ],
      "Custom information to be included in the contract for this order.": [
        "Informations personnalisées à inclure dans le contrat pour cette commande."
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        "Vous devez saisir une valeur en JavaScript Object Notation (JSON)."
      ],
      "remove": [
        "Effacer"
      ],
      "Custom field name": [
        "Nom du champ personnalisé"
      ],
      "Disabled": [
        "Désactivé"
      ],
      "No deadline": [
        "Aucune date limite"
      ],
      "Deadline at %1$s": [
        "Date limite à %1$s"
      ],
      "Select date to show nearby orders": [
        "Sélectionnez la date pour afficher les commandes proches"
      ],
      "Only show unpaid orders": [
        "Afficher uniquement les commandes payées"
      ],
      "Only show paid orders": [
        "Afficher uniquement les commandes payées"
      ],
      "Paid": [
        "Payée"
      ],
      "Only show orders with refunds": [
        "Afficher uniquement les commandes avec remboursement"
      ],
      "Refunded": [
        "Remboursée"
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        "Virement non effectué"
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "Completed": [
        "Transferé"
      ],
      "Remove all filters": [
        "Effacer tous les filtres"
      ],
      "Clear date filter": [
        "Effacer le filtre de date"
      ],
      "Jump to date (%1$s)": [
        "Aller à la date (%1$s)"
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        "Aller à la commande en fonction d'un identifiant de produit"
      ],
      "Order id": [
        "Identifiant de commande"
      ],
      "Instance unknown": [
        "Identifiant d'instance"
      ],
      "Order unknown": [
        "inconnu"
      ],
      "Create order": [
        "Créer une commande"
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        "Date"
      ],
      "Refund": [
        "Remboursement"
      ],
      "copy url": [
        "copiez l'URL"
      ],
      "Load more orders after the last one": [
        "Charger d'autres commandes après la dernière"
      ],
      "No orders have been found matching your query!": [
        "Aucune commande n'a été trouvée correspondant à votre requête !"
      ],
      "Duplicated": [
        "Dupliqué"
      ],
      "This value exceeds the refundable amount.": [
        "Cette valeur dépasse le montant remboursable"
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        "Des exigences en matière de connaissance du client (KYC) sont en suspens."
      ],
      "refund": [
        "Remboursement"
      ],
      "Reason": [
        "Référence"
      ],
      "Amount to be refunded": [
        "Montant à rembourser"
      ],
      "Max refundable:": [
        "Remboursement maximum :"
      ],
      "Choose one...": [
        "Choisissez un ..."
      ],
      "Requested by the customer": [
        "A la demande du client"
      ],
      "Other": [
        "Autre"
      ],
      "Why this order is being refunded": [
        "Pourquoi cette commande est-elle remboursée"
      ],
      "More information to give context": [
        "Plus d'informations pour situer le contexte"
      ],
      "now": [
        "non"
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "This wire transfer has been notified by the payment service provider.": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "This refund is waiting to be claimed by the customer.": [
        "Montant à payer par le client"
      ],
      "This refund has been claimed by the customer.": [
        "Montant à payer par le client"
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        "Conditions du contrat"
      ],
      "Human-readable description of the whole purchase": [
        "Description en langage courant de l'ensemble de la transaction"
      ],
      "Total price for the transaction": [
        "Prix total de la transaction"
      ],
      "URL for this purchase": [
        "URL de cet achat"
      ],
      "Max fee": [
        "Frais maximums"
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        "Montant total maximum des frais de dépôt acceptés par le commerçant pour ce contrat"
      ],
      "Time when this contract was generated": [
        "Heure à laquelle ce contrat a été généré"
      ],
      "Payment deadline": [
        "Date limite de paiement"
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        "Passé ce délai, le commerçant n'acceptera plus de paiements pour le contrat"
      ],
      "Refund deadline": [
        "Date limite de remboursement"
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        "Passé ce délai, aucun remboursement ne sera accepté"
      ],
      "Wire transfer deadline": [
        "Date limite pour les virements"
      ],
      "Transfer deadline for the exchange": [
        "Date limite de transfert pour l'exchange"
      ],
      "Time indicating when the order should be delivered": [
        "Date à laquelle la commande doit être livrée"
      ],
      "Where the order will be delivered": [
        "Lieu de livraison de la commande"
      ],
      "Auto-refund delay": [
        "Délai de remboursement automatique"
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        "Combien de temps le portefeuille doit-il essayer d'obtenir un remboursement automatique de l'achat"
      ],
      "Extra info": [
        "Infos supplémentaires"
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        "Données supplémentaires qui ne sont interprétées que par le frontend du commerçant"
      ],
      "order created": [
        "Statut de la commande"
      ],
      "pay deadline": [
        "Date limite de paiement"
      ],
      "refund deadline": [
        "Date limite de remboursement"
      ],
      "delivery": [
        "Date de livraison"
      ],
      "Order": [
        "Commande"
      ],
      "Claimed": [
        "Idées pour les projets réclamées"
      ],
      "Claimed at": [
        "Réclamée à"
      ],
      "Timeline": [
        "Calendrier"
      ],
      "Payment details": [
        "Modalités de paiement"
      ],
      "Order status": [
        "Statut de la commande"
      ],
      "Unpaid": [
        "Non payé"
      ],
      "Product list": [
        "Liste des produits"
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        "Création réussie du remboursement"
      ],
      "refund created: %1$s: %2$s": [
        "Création réussie du remboursement"
      ],
      "refund taken: %1$s": [
        "Remboursement pris"
      ],
      "refund taken: %1$s: %2$s": [
        "Remboursement pris"
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        "Aucune date limite"
      ],
      "Wired": [
        "Virement effectué"
      ],
      "Refund order": [
        "Rembourser la commande"
      ],
      "Not refundable": [
        "Non remboursable"
      ],
      "Next event in": [
        "Nouvel évènement dans"
      ],
      "The order was wired.": [
        "La demande a été annulée."
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        "Montant remboursé"
      ],
      "Refund taken": [
        "Remboursement pris"
      ],
      "Status URL": [
        "URL de l'état"
      ],
      "Refund URI": [
        "URI de remboursement"
      ],
      "Pay at": [
        "URL de paiement"
      ],
      "Order status URL": [
        "URL de l'état de la commande"
      ],
      "Payment URI": [
        "URI de payment"
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        "Statut de la commande inconnu. Il s'agit d'une erreur, veuillez contacter l'administrateur."
      ],
      "Invalid. Please enter letters and numbers only.": [
        "Invalide. Veuillez n'insérer que des caractères et des chiffres"
      ],
      "Just letters and numbers from 2 to 7": [
        "Juste des lettres et des chiffres de 2 à 7"
      ],
      "The size of the key must be 32 characters": [
        "La clé doit comporter exactement 32 caractères"
      ],
      "Internal ID on the system": [
        "Identifiant interne au système"
      ],
      "Useful to identify the device physically": [
        "Utile pour identifier physiquement l'appareil"
      ],
      "Verification algorithm": [
        "Algorithme de vérification"
      ],
      "Algorithm used to verify transactions in offline mode": [
        "Algorithme utilisé pour vérifier la transaction en mode hors ligne"
      ],
      "Device key": [
        "Clé de l'appareil"
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        "Veillez à ce que votre mot de passe soit très difficile à deviner ou utilisez le générateur aléatoire"
      ],
      "Your device needs to match exactly the same value": [
        "Votre appareil doit afficher exactement la même valeur"
      ],
      "Generate random secret key": [
        "Générer une clé secrète aléatoire"
      ],
      "Random": [
        "Aléatoire"
      ],
      "Create another": [
        "Créer une commande"
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        "Vous pouvez scanner le code QR suivant avec votre appareil ou enregistrer la clé avant de continuer."
      ],
      "OTP devices": [
        "Appareils OTP"
      ],
      "Delete selected devices from the database": [
        "Supprimer les appareils sélectionnés de la base de données"
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        "Il n'y a pas encore d'appareil, ajoutez-en un en appuyant sur le signe +"
      ],
      "Template id is unknown": [
        "Identifiant du modèle inconnu"
      ],
      "The provided information is inconsistent with the current state of the template": [
        "Les informations fournies ne correspondent pas à l'état actuel du modèle"
      ],
      "Device:": [
        "Appareil :"
      ],
      "Algorithm to use to verify transactions in offline mode": [
        "Algorithme à utiliser pour vérifier les transactions en mode hors ligne"
      ],
      "Not modified": [
        "Pas de modification"
      ],
      "Be sure to be very hard to guess or use the random generator": [
        "Veillez à ce qu'il soit très difficile à deviner ou utilisez le générateur aléatoire"
      ],
      "Your device need to have exactly the same value": [
        "Votre appareil doit avoir exactement la même valeur"
      ],
      "Change key": [
        "Changer la clé"
      ],
      "Is not the same": [
        "N'est pas le même"
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        "Vous mettez à jour le jeton d'accès de l'instance dont l'identifiant est %1$s"
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        "Confirmer le changement"
      ],
      "Testing password change": [
        "Mot de passe"
      ],
      "Password changed": [
        "Mot de passe"
      ],
      "The current password is wrong.": [
        "Avec mot de passe"
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        "Identifiant du produit"
      ],
      "Add element to the list": [
        "Ajouter l'élément à la liste"
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        "Cliquez ici pour configurer le stock du produit, laissez-le tel quel et le backend ne contrôlera pas le stock."
      ],
      "Manage stock": [
        "Gestion du stock"
      ],
      "This product has been configured without stock control": [
        "Ce produit a été configuré sans contrôle du stock"
      ],
      "Infinite": [
        "Infini"
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        "Le retrait ne peut pas dépasser le stock actuel plus les quantitées entrantes (maximum %1$s)"
      ],
      "Incoming": [
        "Arrivées"
      ],
      "Lost": [
        "Perte"
      ],
      "Current": [
        "Courant"
      ],
      "Remove stock control for this product": [
        "Supprimer le contrôle des stocks pour ce produit"
      ],
      "without stock": [
        "sans stock"
      ],
      "Next restock": [
        "Prochain réapprovisionnement"
      ],
      "Warehouse address": [
        "Adresse de l'entrepôt"
      ],
      "Invalid amount": [
        "Montant invalide"
      ],
      "Product identification to use in URLs (for internal use only).": [
        "Identification du produit à utiliser dans les URL (à usage interne uniquement)."
      ],
      "Illustration of the product for customers.": [
        "Illustration du produit pour les clients."
      ],
      "Product name.": [
        "Identifiant du produit"
      ],
      "Product description for customers.": [
        "Description du produit pour les clients."
      ],
      "Age restriction": [
        "Restriction d'âge"
      ],
      "Is this product restricted for customer below certain age?": [
        "Ce produit est-il interdit aux personnes en dessous d'un certain âge ?"
      ],
      "Minimum age of the customer": [
        "Âge minimum du client"
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        "Unité décrivant la quantité de produits vendus (par exemple, 2 kilogrammes, 5 litres, 3 articles, 5 mètres) aux clients."
      ],
      "Example: kg, items or liters": [
        "Exemple : kg, pièces ou litres"
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        "Prix de vente TTC des produits pour les clients, correspondant aux unités de produits ci-dessus."
      ],
      "Stock": [
        "Stock"
      ],
      "Inventory for products with finite supply (for internal use only).": [
        "Inventaire des produits dont l'offre est limitée (à usage interne uniquement)."
      ],
      "Taxes included in the product price, exposed to customers.": [
        "Taxes incluses dans le prix du produit, communiquées aux clients."
      ],
      "Search by category description or id": [
        "Recherche par description de catégorie ou par identifiant"
      ],
      "Categories where this product will be listed on.": [
        "Catégories dans lesquelles ce produit sera rangé."
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        "Recherche par description ou identifiant de produit"
      ],
      "Money pots where this product will be listed on.": [
        "Catégories dans lesquelles ce produit sera rangé."
      ],
      "Select one": [
        "Compte en banque"
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        "Recherche par description ou identifiant de produit"
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        "Ajouter le produit à l'inventaire"
      ],
      "Product not found.": [
        "Identifiant du produit"
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        "Ventes"
      ],
      "Sold": [
        "Vendu"
      ],
      "Free": [
        "Libre"
      ],
      "Go to product update page": [
        "Aller à la page de modification du produit"
      ],
      "Update": [
        "Modification"
      ],
      "Remove this product from the database": [
        "Effacer ce produit de la base de données"
      ],
      "Update the product with new price": [
        "Modifier le prix du produit"
      ],
      "Update product with new price": [
        "Modifier le prix du produit"
      ],
      "Confirm update": [
        "Confirmer la modification"
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        "La perte ne peut pas être supérieure au courant + entrées (max %1$s)"
      ],
      "Add more elements to the inventory": [
        "Ajouter d'autres éléments à l'inventaire"
      ],
      "Report elements lost in the inventory": [
        "Signaler les éléments perdus dans l'inventaire"
      ],
      "New price for the product": [
        "Nouveau prix pour le produit"
      ],
      "There are values with errors.": [
        "Certaines valeurs ont des erreurs"
      ],
      "Update product with new stock and price": [
        "Changer le stock et le prix du produit"
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        "Il n'y a pas encore de produits, ajoutez-en en appuyant sur le signe +"
      ],
      "Product (ID: %1$s) has been deleted": [
        "Le produit (identifiant : %1$s) a été modifié"
      ],
      "Jump to product with the given product ID": [
        "Aller directement au produit avec son identifiant"
      ],
      "Product id": [
        "Identifiant du produit"
      ],
      "Delete product": [
        "Effacées"
      ],
      "Delete the product \"%1$s\"": [
        "Impossible d'effacer le produit"
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        "Si vous effacez le produit nommé %1$s (identifiant : %2$s), le stock et toutes les informations liées seront perdus"
      ],
      "Deleting a product cannot be undone.": [
        "La suppression d'un produit est irréversible."
      ],
      "Product id:": [
        "Identifiant du produit :"
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        "Commandes"
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        "Statut de la commande"
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        "Statut de la commande"
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        "prix de la commande"
      ],
      "hour": [
        "heures"
      ],
      "day": [
        "jours"
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        "Effacer tous les filtres"
      ],
      "Time range": [
        "Calendrier"
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        "Courant"
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        "Délai de paiement"
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        "Doit être supérieur à 0"
      ],
      "Too short": [
        "Trop court"
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        "Identifiant"
      ],
      "Name of the template in URLs.": [
        "Nom du modèle dans les URLs."
      ],
      "Template name": [
        "Modèles"
      ],
      "Describe what this template stands for": [
        "Décrire ce que ce modèle représente"
      ],
      "Order summary": [
        "Résumé de la commande"
      ],
      "If specified here, this template will create orders with the same summary": [
        "S'il est utilisé, ce modèle créera des commandes avec le même résumé"
      ],
      "Summary is editable": [
        "Le résumé est éditable"
      ],
      "Allow the user to change the summary.": [
        "Autoriser l'utilisateur à modifier le résumé."
      ],
      "If specified here, this template will create orders with the same price": [
        "S'il est utilisé, ce modèle créera des commandes avec le même prix"
      ],
      "Amount is editable": [
        "Le montant est modifiable"
      ],
      "Allow the user to select the amount to pay.": [
        "Permettre à l'utilisateur de sélectionner le montant à payer."
      ],
      "Currency is editable": [
        "La devise est modifiable"
      ],
      "Allow the user to change currency.": [
        "Permettre à l'utilisateur de changer de devise."
      ],
      "Supported currencies": [
        "Devises prises en charge"
      ],
      "Supported currencies: %1$s": [
        "Devises prises en charge : %1$s"
      ],
      "Minimum age": [
        "Age minimum"
      ],
      "Is this contract restricted to some age?": [
        "Ce contrat doit-il contenir une limite d'âge ?"
      ],
      "Payment timeout": [
        "Délai de paiement"
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        "De combien de temps le client dispose pour le paiement après la création de la commande."
      ],
      "OTP device": [
        "Appareil OTP"
      ],
      "Use to verify transactions in offline mode.": [
        "A utiliser pour vérifier la transaction en mode hors ligne."
      ],
      "No OTP device.": [
        "Aucun appareil OTP."
      ],
      "Add one first": [
        "Ajouter un premier élément"
      ],
      "No device": [
        "Aucun appareil"
      ],
      "Add new templates": [
        "Ajouter de nouveaux modèles"
      ],
      "Load more templates before the first one": [
        "Ajouter de nouveaux modèles avant le premier"
      ],
      "Delete selected templates from the database": [
        "Effacer les modèles sélectionnés de la base de données"
      ],
      "Use template to create new order": [
        "Utiliser le modèle pour créer une nouvelle commande"
      ],
      "Generate a QR code for the template.": [
        "Créer un code QR pour le modèle."
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        "Ajouter des modèles après le dernier"
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        "Il n'y a pas encore de modèles, ajoutez-en en appuyant sur le signe +"
      ],
      "Jump to template with the given template ID": [
        "Aller directement au modèle avec cet identifiant"
      ],
      "Template identification": [
        "Identification du modèle"
      ],
      "Delete template": [
        "Suppression d'un modèle"
      ],
      "Delete the template \"%1$s\"": [
        "Suppression d'un modèle"
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        "Si vous effacez le modèle %1$s (identifiant : %2$s) vous pourriez perdre des informations"
      ],
      "Deleting a template cannot be undone.": [
        "La suppression d'un produit est irréversible."
      ],
      "Print": [
        "Imprimer"
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        "S'il est utilisé, ce modèle créera des commandes avec le même résumé."
      ],
      "If specified, this template will create orders with the same price": [
        "S'il est utilisé, ce modèle créera des commandes avec le même prix"
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        "De combien de temps le client dispose pour le paiement après la création de la commande."
      ],
      "An amount is required": [
        "Montant obligatoire"
      ],
      "An order summary is required": [
        "Un résumé de la commande est obligatoire"
      ],
      "No more stock for product with ID \"%1$s\".": [
        "Il n'y a plus de stock pour le produit dont l'identifiant est \"%1$s\"."
      ],
      "New order from template": [
        "Nouvelle commande à partir d'un modèle"
      ],
      "Amount of the order": [
        "Montant de la commande"
      ],
      "Slug": [
        "Type"
      ],
      "Token family slug to use in URLs (for internal use only)": [
        "Type de famille de jetons à utiliser dans les URL (à usage interne uniquement)"
      ],
      "Kind": [
        "Type"
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        "Délai de paiement"
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        "Familles de jetons"
      ],
      "Add token family": [
        "Ajouter une famille de jetons"
      ],
      "Valid Before": [
        "Valide jusqu'à"
      ],
      "Go to token family update page": [
        "Aller à la page de modification des familles de jetons"
      ],
      "Remove this token family from the database": [
        "Effacer cette famille de jetons de la base de données"
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        "Il n'y a pas encore de familles de jetons, ajoutez la première en appuyant sur le signe +."
      ],
      "Token family has been deleted.": [
        "Famille de jetons \"%1$s\" (type : %2$s) a été effacée"
      ],
      "Delete token family": [
        "Échec de la suppression de la famille de jetons"
      ],
      "Delete the token family \"%1$s\"": [
        "Suppression de la famille de jetons %1$s ."
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        "Si vous supprimez la famille de jetons %1$s ( Catégorie : %2$s), tous les jetons émis deviendront invalides."
      ],
      "Deleting a token family %1$s .": [
        "Suppression de la famille de jetons %1$s ."
      ],
      "can't be undone": [
        "ne peut être annulé"
      ],
      "Token Family: %1$s": [
        "Famille de jetons : %1$s"
      ],
      "User-readable token family name": [
        "Nom de famille du jeton compréhensible par l'utilisateur"
      ],
      "Token family description for customers": [
        "Description de la famille de jetons pour les clients"
      ],
      "Incoming wire transfers": [
        "Virements bancaires"
      ],
      "Load more wire transfers preceding the first one": [
        "Charger des virements avant le premier"
      ],
      "Expected credit": [
        "Exécuté le"
      ],
      "Confirmed": [
        "Confirmé"
      ],
      "Validated": [
        "Valide à partir de"
      ],
      "Executed on": [
        "Exécuté le"
      ],
      "yes": [
        "oui"
      ],
      "no": [
        "non"
      ],
      "never": [
        "jamais"
      ],
      "unknown": [
        "inconnu"
      ],
      "Load more transfers after the last one": [
        "Ajouter des virements après le dernier"
      ],
      "Verified wire transfers": [
        "Virements bancaires"
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        "Il n'y a pas encore de virements, ajoutez-en en appuyant sur le signe +"
      ],
      "All accounts": [
        "Tous les comptes"
      ],
      "Filter by account address": [
        "Filtre sur l'adresse du compte"
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        "Afficher uniquement les commandes qui ont déjà été transférées par le prestataire de services de paiement"
      ],
      "Only show wire transfers confirmed by the merchant": [
        "Afficher uniquement les virements bancaires confirmés par le commerçant"
      ],
      "Verified": [
        "Vérifié"
      ],
      "Wire transfer already confirmed.": [
        "Date limite pour les virements"
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        "Confirmez le même jeton d'accès"
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        "Calendrier"
      ],
      "Transfer ID": [
        "Virements"
      ],
      "It's not the same.": [
        "N'est pas le même"
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        "Vous modifiez le jeton d'accès de l'instance dont l'identifiant est \"%1$s\""
      ],
      "Instance": [
        "Instances"
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        "Purger"
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        "Identifiant d'instance"
      ],
      "Delete this instance": [
        "Suppression d'une instance %1$s ."
      ],
      "Must be one of '%1$s'": [
        "Doit être l'un des éléments suivants '%1$s'"
      ],
      "URL is invalid": [
        "La chaine JSON est invalide"
      ],
      "Webhook ID to use": [
        "Identifiant du Webhook à utiliser"
      ],
      "Event": [
        "Evènement"
      ],
      "Payment": [
        "URI de payment"
      ],
      "Order settled": [
        "Statut de la commande"
      ],
      "Category added": [
        "Nom de la catégorie"
      ],
      "Category updated": [
        "Nom de la catégorie"
      ],
      "Inventory added": [
        "Inventaire"
      ],
      "Inventory updated": [
        "Inventaire"
      ],
      "Inventory deleted": [
        "Inventaire"
      ],
      "The event of the webhook: why the webhook is used": [
        "L'événement du webhook : pourquoi le webhook est-il utilisé"
      ],
      "Method": [
        "Méthode"
      ],
      "GET": [
        "GET"
      ],
      "POST": [
        "POST"
      ],
      "PUT": [
        "PUT"
      ],
      "PATCH": [
        "PATCH"
      ],
      "HEAD": [
        "HEAD"
      ],
      "Method used by the webhook": [
        "Méthode utilisée par le webhook"
      ],
      "URL": [
        "URL"
      ],
      "URL of the webhook where the customer will be redirected": [
        "URL du webhook où le client sera redirigé"
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        "Le texte ci-dessous prend en charge le moteur de modèle %1$s. Toute chaîne comprise entre %2$s et %3$s sera remplacée par la valeur de la variable correspondante."
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        "Par exemple, %1$s sera remplacé par le prix de la commande"
      ],
      "The short list of variables are:": [
        "La liste restreinte des variables est la suivante :"
      ],
      "order's description": [
        "description de la commande"
      ],
      "order's price": [
        "prix de la commande"
      ],
      "order's unique identification": [
        "identification unique de la commande"
      ],
      "the amount that was being refunded": [
        "le montant remboursé"
      ],
      "the reason entered by the merchant staff for granting the refund": [
        "la raison invoquée par le personnel du commerçant pour accorder le remboursement"
      ],
      "time of the refund in nanoseconds since 1970": [
        "instant du remboursement en nanosecondes depuis 1970"
      ],
      "Http header": [
        "Entête"
      ],
      "Header template of the webhook": [
        "Modèle d'entête pour le webhook"
      ],
      "Http body": [
        "body HTTP"
      ],
      "Body template used by the webhook.": [
        "Modèle de body pour le webhook"
      ],
      "Webhook deleted successfully": [
        "Suppression réussie du webhook"
      ],
      "Add new webhooks": [
        "Ajouter de nouveaux webhooks"
      ],
      "Load more webhooks before the first one": [
        "Ajouter des webhooks avant le premier"
      ],
      "Event type": [
        "Type d'évènement"
      ],
      "Delete selected webhook from the database": [
        "Supprimer le webhook sélectionné de la base de données"
      ],
      "Load more webhooks after the last one": [
        "Ajouter des webhooks après le dernier"
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        "Il n'y a pas encore de webhook, ajoutez-en en appuyant sur le signe +"
      ],
      "Webhook updated": [
        "Webhook modifié"
      ],
      "Header": [
        "Entête"
      ],
      "Body": [
        "Corps"
      ],
      "Body template used by the webhook": [
        "Modèle de body pour le webhook"
      ],
      "There is another instance with this username.": [
        "Affiche plus d'options dans le formulaire de configuration de l'instance"
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        "Email de contact"
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        "Créé à"
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        "Votre instance n'a pas été trouvée"
      ],
      "Resetting access to the instance \"%1$s\"": [
        "Vous définissez le jeton d'accès pour la nouvelle instance"
      ],
      "Reset": [
        ""
      ],
      "Language": [
        "Langue"
      ],
      "Date format": [
        "Format de la date"
      ],
      "How the date is going to be displayed": [
        "Comment la date sera affichée"
      ],
      "Merchant type": [
        "Type d'évènement"
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        "Mode dévelopeur"
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        "Inventaire"
      ],
      "Add new pots": [
        "Ajouter de nouveaux modèles"
      ],
      "Load more pots before the first one": [
        "Ajouter de nouveaux modèles avant le premier"
      ],
      "Total": [
        "Prix total"
      ],
      "Delete selected pots from the database": [
        "Supprimer les comptes sélectionnés de la base de données"
      ],
      "Load more pots after the last one": [
        "Ajouter des produits après le dernier"
      ],
      "There are no money pots yet, add more pressing the + sign": [
        "Il n'y a pas encore de compte, ajoutez-en un en appuyant sur le signe +"
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        "Changer la valeur pour jamais"
      ],
      "Invalid amount \"%1$s\": %2$s": [
        "Montant invalide"
      ],
      "Descripton": [
        "Description"
      ],
      "Totals": [
        "Total des produits"
      ],
      "There is already a money pot with the same id.": [
        "Affiche plus d'options dans le formulaire de configuration de l'instance"
      ],
      "Product group deleted": [
        "Liste des produits"
      ],
      "Add new group": [
        "Ajouter un nouveau compte"
      ],
      "Load more groups before the first one": [
        "Ajouter des webhooks avant le premier"
      ],
      "Delete selected group from the database": [
        "Supprimer les comptes sélectionnés de la base de données"
      ],
      "Load more groups after the last one": [
        "Ajouter des produits après le dernier"
      ],
      "There are no product groups yet, add more pressing the + sign": [
        "Il n'y a pas encore de produits, ajoutez-en en appuyant sur le signe +"
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        "Ajouter de nouveaux modèles"
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        "Supprimer la catégorie sélectionnée de la base de données"
      ],
      "There are no reports yet, add more pressing the + sign": [
        "Il n'y a pas encore de catégorie, ajoutez-en en appuyant sur le signe +"
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        "Nom de la catégorie"
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        "Vous devez associer un compte bancaire pour recevoir des fonds."
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        "Sans cela, le backend du commerçant refusera de créer de nouvelles commandes."
      ],
      "Hide for today": [
        "Cacher pour aujourd'hui"
      ],
      "KYC verification needed": [
        "Vérification de l'identité du client (KYC) nécessaire"
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        "Certains transferts sont suspendus jusqu'à ce que la procédure de vérification de l'identité du client (KYC) soit achevée. Pour plus d'informations, consultez la section KYC dans le panneau de gauche"
      ],
      "The request reached a timeout, check your connection.": [
        "La demande a dépassé le temps de traitement maximum, vérifiez votre connexion."
      ],
      "The request was cancelled.": [
        "La demande a été annulée."
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        "Un grand nombre de demandes ont été adressées au même serveur et cette action a été ralentie."
      ],
      "The server's response was malformed.": [
        "La réponse du serveur est malformée."
      ],
      "Could not complete the request due to a network problem.": [
        "La demande n'a pas pu être traitée en raison d'un problème de réseau."
      ],
      "Unexpected request error.": [
        "Erreur inattendue sur la requête."
      ],
      "Unexpected error.": [
        "Erreur inattendue."
      ],
      "Add new instance": [
        "Ajouter une nouvelle instance"
      ],
      "Edit": [
        "Editer"
      ],
      "Change password": [
        "Avec mot de passe"
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        "Il n'y a pas encore d'instance, ajoutez-en une en appuyant sur le signe +"
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        "L'instance \"%1$s\" (identifiant : %2$s) a été effacée"
      ],
      "Only show active instances": [
        "N'afficher que les instances actives"
      ],
      "Active": [
        "Actives"
      ],
      "Only show deleted instances": [
        "N'afficher que les instances effacées"
      ],
      "Deleted": [
        "Effacées"
      ],
      "Show all instances": [
        "Afficher toutes les instances"
      ],
      "Delete instance": [
        "Suppression d'une instance %1$s ."
      ],
      "Delete the instance \"%1$s\"": [
        "Suppression d'une instance %1$s ."
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        "Si vous supprimez l'instance nommée %1$s (ID : %2$s), le commerçant ne sera plus en mesure de traiter les commandes ou les remboursements"
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        "Cette action supprime la clé privée de l'instance, mais préserve toutes les données de transaction. Vous pouvez toujours accéder à ces données après avoir supprimé l'instance."
      ],
      "Deleting an instance %1$s": [
        "Suppression d'une instance %1$s ."
      ],
      "This cannot be undone!": [
        "ne peut être annulé"
      ],
      "Purge the instance": [
        "Suppression d'une instance %1$s ."
      ],
      "Purge the instance \"%1$s\"": [
        "Purge d'une instance %1$s ."
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        "Si vous purgez l'instance nommée %1$s (ID : %2$s), vous supprimerez également toutes ses données de transaction."
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        "L'instance disparaîtra de votre liste et vous ne pourrez plus accéder à ses données."
      ],
      "Purging an instance %1$s": [
        "Purge d'une instance %1$s ."
      ],
      "checking compatibility with server...": [
        "vérification de la compatibilité avec le serveur..."
      ],
      "Contacting the server failed": [
        "Impossible de contacter le serveur"
      ],
      "The server version is not supported": [
        "La version du serveur n'est pas supportée"
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        "Version supportée \"%1$s\", version du serveur \"%2$s\"."
      ],
      "Business Name": [
        "Nom de l'entreprise"
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        "Configuration"
      ],
      "title\u0004%1$s: New bank account": [
        "Compte bancaire"
      ],
      "title\u0004%1$s: Bank accounts": [
        "Comptes bancaires"
      ],
      "title\u0004%1$s: Update bank Account": [
        "Valider le compte bancaire : %1$s"
      ],
      "title\u0004%1$s: Orders": [
        "Commandes"
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        "Inventaire"
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        "Modification du produit impossible"
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        "Impossible de modifier la catégorie"
      ],
      "title\u0004%1$s: Wire transfers": [
        "Virements bancaires"
      ],
      "title\u0004%1$s: Webhooks": [
        "Webhooks"
      ],
      "title\u0004%1$s: New webhook": [
        "Ajouter de nouveaux webhooks"
      ],
      "title\u0004%1$s: Update webhook": [
        "Impossible de modifier le webhook"
      ],
      "title\u0004%1$s: OTP devices": [
        "Appareils OTP"
      ],
      "title\u0004%1$s: New OTP device": [
        "Aucun appareil OTP."
      ],
      "title\u0004%1$s: Update OTP device": [
        "Appareil OTP"
      ],
      "title\u0004%1$s: New template": [
        "Utiliser le modèle"
      ],
      "title\u0004%1$s: Update template": [
        "Utiliser le modèle"
      ],
      "title\u0004%1$s: Templates": [
        "Modèles"
      ],
      "title\u0004%1$s: Use template": [
        "Utiliser le modèle"
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        "Ajouter une famille de jetons"
      ],
      "title\u0004%1$s: Update token family": [
        "Impossible de mettre à jour la famille de jetons"
      ],
      "title\u0004%1$s: Access tokens": [
        "Jeton d'accès"
      ],
      "title\u0004%1$s: New access token": [
        "Nouveau jeton d'accès"
      ],
      "title\u0004New instance": [
        "Ajouter une nouvelle boutique"
      ],
      "title\u0004Instances": [
        "Boutiques"
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=(n!=1);",
  "lang": "fr",
  "completeness": 82
};

strings['es'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=n != 1;",
        "lang": "es"
      },
      "Cancel": [
        "Cancelar"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        "Cerrar"
      ],
      "Continue": [
        "Continuar"
      ],
      "Clear": [
        "Limpiar"
      ],
      "Confirm": [
        "Confirmar"
      ],
      "Correct form": [
        "Formulario correcto"
      ],
      "Comparing account details": [
        "Comparando detalles de cuenta"
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        "La conexión a la URL de información de cuenta fue exitosa, pero la información de cuenta reportada no coincide con los detalles del formulario."
      ],
      "Field": [
        "Campo"
      ],
      "In the form": [
        "En el formulario"
      ],
      "Reported": [
        "Reportado"
      ],
      "Type": [
        "Tipo"
      ],
      "IBAN": [
        "IBAN"
      ],
      "Address": [
        "Dirección"
      ],
      "Host": [
        "Host"
      ],
      "Account ID": [
        "ID de cuenta"
      ],
      "The account owner's legal name": [
        "El nombre legal del titular de la cuenta"
      ],
      "The postal code of the account owner's address": [
        "El código postal del domicilio del titular de la cuenta"
      ],
      "Town": [
        "Ciudad"
      ],
      "Bank host": [
        "Host del banco"
      ],
      "Bank account": [
        "Cuenta bancaria"
      ],
      "BIC": [
        "BIC"
      ],
      "OK": [
        "Aceptar"
      ],
      "Validate bank account: %1$s": [
        "Validar cuenta bancaria: %1$s"
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        "Para demostrar que sos el titular beneficiario de la cuenta bancaria, debés realizar una transferencia de un monto pequeño a la cuenta indicada con el asunto que figura a continuación."
      ],
      "Step 1:": [
        "Paso 1:"
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        "Copiá y pegá este IBAN y el nombre legal del titular beneficiario en los campos correspondientes de tu aplicación bancaria o sitio web de banca en línea."
      ],
      "Beneficiary": [
        "Beneficiario"
      ],
      "Step 2:": [
        "Paso 2:"
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        "Copiá este texto y pegalo en el campo 'Asunto' o 'Concepto' de tu aplicación bancaria o sitio web de banca en línea."
      ],
      "Subject": [
        "Asunto"
      ],
      "Receiver postal code": [
        "Código postal del destinatario"
      ],
      "Receiver town": [
        "Ciudad del destinatario"
      ],
      "Step 3:": [
        "Paso 3:"
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        "Seleccioná el monto mínimo posible para una transferencia bancaria en tu aplicación bancaria o sitio web de banca en línea."
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        "Asegurate de que TODOS los datos sean correctos, especialmente el asunto, y que estés eligiendo la cuenta bancaria desde la que realmente querés realizar la transferencia. Podés usar los botones de copiar (%1$s) para evitar errores de tipeo, o usar el URI \"payto://\" de más abajo para copiar un único valor."
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        "Si tu aplicación bancaria permite realizar transferencias mediante códigos QR estándar, intentá escanear el siguiente:"
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        "Como alternativa, si tu banco ya soporta el estándar 'PayTo URI', podés usar este enlace %1$s en su lugar"
      ],
      "Operation in progress...": [
        "Operación en progreso..."
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        "La operación se cancelará automáticamente después de %1$s segundos"
      ],
      "days": [
        "días"
      ],
      "hours": [
        "horas"
      ],
      "minutes": [
        "minutos"
      ],
      "seconds": [
        "segundos"
      ],
      "Forever": [
        "Siempre"
      ],
      "%1$sM": [
        "%1$sM"
      ],
      "%1$sY": [
        "%1$sA"
      ],
      "%1$sd": [
        "%1$sd"
      ],
      "%1$sh": [
        "%1$sh"
      ],
      "%1$smin": [
        "%1$smin"
      ],
      "%1$ssec": [
        "%1$sseg"
      ],
      "Change value to never": [
        "Cambiar valor a nunca"
      ],
      "Change value to empty": [
        "Cambiar valor a vacío"
      ],
      "Image must be smaller than 1 MB": [
        "La imagen debe ser menor a 1 MB"
      ],
      "Add": [
        "Agregar"
      ],
      "Remove": [
        "Eliminar"
      ],
      "Country": [
        "País"
      ],
      "Building number": [
        "Número de edificio"
      ],
      "Building name": [
        "Nombre del edificio"
      ],
      "Street": [
        "Calle"
      ],
      "Post code": [
        "Código postal"
      ],
      "Town location": [
        "Ubicación de la ciudad"
      ],
      "District": [
        "Distrito"
      ],
      "Country subdivision": [
        "Subdivisión del país"
      ],
      "Additional address lines": [
        "Líneas de dirección adicionales"
      ],
      "Orders": [
        "Órdenes"
      ],
      "Inventory": [
        "Inventario"
      ],
      "Categories": [
        "Categorías"
      ],
      "Wire transfers": [
        "Transferencias bancarias"
      ],
      "Templates": [
        "Plantillas"
      ],
      "Product groups": [
        "Grupos de productos"
      ],
      "Money pots": [
        "Fondos"
      ],
      "Reports": [
        "Informes"
      ],
      "Statistics": [
        "Estadísticas"
      ],
      "Subscriptions and Discounts": [
        "Suscripciones y descuentos"
      ],
      "Configuration": [
        "Configuración"
      ],
      "OTP Devices": [
        "Dispositivos OTP"
      ],
      "Webhooks": [
        "Webhooks"
      ],
      "Settings": [
        "Configuración"
      ],
      "Password": [
        "Contraseña"
      ],
      "Access tokens": [
        "Tokens de acceso"
      ],
      "Connection": [
        "Conexión"
      ],
      "Personalization": [
        "Personalización"
      ],
      "Instances": [
        "Instancias"
      ],
      "New": [
        "Nueva"
      ],
      "List": [
        "Lista"
      ],
      "Log out": [
        "Cerrar sesión"
      ],
      "Username": [
        "Usuario"
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        "Nombre de la instancia en las URL. La instancia 'admin' es especial ya que se utiliza para administrar otras instancias."
      ],
      "Business name": [
        "Nombre del negocio"
      ],
      "Legal name of the business represented by this instance.": [
        "Nombre legal del negocio representado por esta instancia."
      ],
      "Email": [
        "Correo electrónico"
      ],
      "Contact email": [
        "Correo electrónico de contacto"
      ],
      "Phone number": [
        "Número de teléfono"
      ],
      "Contact phone": [
        "Teléfono de contacto"
      ],
      "Website URL": [
        "URL del sitio web"
      ],
      "URL.": [
        "URL."
      ],
      "Logo": [
        "Logotipo"
      ],
      "Logo image.": [
        "Imagen del logotipo."
      ],
      "Pay transaction fee": [
        "Pagar comisión de transacción"
      ],
      "Cover the transaction cost or pass it on to the user.": [
        "Absorber el costo de transacción o trasladárselo al usuario."
      ],
      "Physical location of the merchant.": [
        "Ubicación física del comerciante."
      ],
      "Jurisdiction": [
        "Jurisdicción"
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        "Jurisdicción para disputas legales con el comerciante."
      ],
      "Default cut-off times": [
        "Plazos predeterminados"
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        "Estos valores se usarán si no se sobreescriben al crear una orden."
      ],
      "Payment delay": [
        "Plazo de pago"
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        "Tiempo que tienen los clientes para pagar una orden antes de que la oferta expire de forma predeterminada."
      ],
      "Refund delay": [
        "Plazo de reembolso"
      ],
      "Time merchants have to refund an order.": [
        "Tiempo que tiene el comerciante para reembolsar una orden."
      ],
      "Wire transfer delay": [
        "Plazo de transferencia bancaria"
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        "Tiempo máximo que un proveedor puede demorar en transferir fondos al comerciante, lo que le permite agrupar pagos menores en transferencias más grandes y reducir las comisiones."
      ],
      "Wire transfer rounding": [
        "Redondeo de transferencia bancaria"
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        "Intervalo al que deben redondearse los plazos de transferencia."
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        "Por ejemplo, si establecés el intervalo en día, el plazo de transferencia se redondeará a medianoche."
      ],
      "No rounding": [
        "Sin redondeo"
      ],
      "To second": [
        "Al segundo"
      ],
      "To minute": [
        "Al minuto"
      ],
      "To hour": [
        "A la hora"
      ],
      "To day": [
        "Al día"
      ],
      "To week": [
        "A la semana"
      ],
      "To month": [
        "Al mes"
      ],
      "To quarter": [
        "Al trimestre"
      ],
      "To year": [
        "Al año"
      ],
      "Expired": [
        "Vencido"
      ],
      "Required": [
        "Requerido"
      ],
      "Unauthorized": [
        "No autorizado"
      ],
      "The code is not correct.": [
        "El código no es correcto."
      ],
      "The challenge is not known anymore.": [
        "El desafío ya no es reconocido."
      ],
      "Too many attempts trying to solve the challenge.": [
        "Demasiados intentos para resolver el desafío."
      ],
      "Validation code sent.": [
        "Código de validación enviado."
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        "El código de verificación enviado al número de teléfono que termina en \"%1$s\""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        "El código de verificación enviado a la dirección de correo que comienza con \"%1$s\""
      ],
      "Verification code": [
        "Código de verificación"
      ],
      "It will expire at %1$s": [
        "Vencerá el %1$s"
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        "El desafío venció y no puede resolverse, pero podés volver atrás y crear uno nuevo."
      ],
      "Back": [
        "Volver"
      ],
      "Verify": [
        "Verificar"
      ],
      "Failed to send the verification code.": [
        "No se pudo enviar el código de verificación."
      ],
      "The request was valid, but the server is refusing action.": [
        "La solicitud fue válida, pero el servidor rechazó la acción."
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "El backend no reconoce el desafío MFA especificado."
      ],
      "Code transmission failed.": [
        "Falló la transmisión del código."
      ],
      "Already solved.": [
        "Ya fue resuelto."
      ],
      "It is too early to request another transmission of the challenge.": [
        "Es demasiado pronto para solicitar otro envío del desafío."
      ],
      "Multi-factor authentication required.": [
        "Se requiere autenticación multifactor."
      ],
      "You need to complete all of this requirements.": [
        "Tenés que completar todos estos requisitos."
      ],
      "You need to complete at least one of this requirements.": [
        "Tenés que completar al menos uno de estos requisitos."
      ],
      "An SMS to the phone number ending with %1$s": [
        "Un SMS al número de teléfono que termina en %1$s"
      ],
      "An email to the address starting with %1$s": [
        "Un correo electrónico a la dirección que comienza con %1$s"
      ],
      "You have to wait until %1$s to send a new code.": [
        "Tenés que esperar hasta %1$s para enviar un nuevo código."
      ],
      "I have a code": [
        "Tengo un código"
      ],
      "Send me a message": [
        "Enviarme un mensaje"
      ],
      "Logged in": [
        "Sesión iniciada"
      ],
      "Not found": [
        "No encontrado"
      ],
      "Login required": [
        "Se requiere iniciar sesión"
      ],
      "Instance name.": [
        "Nombre de la instancia."
      ],
      "Instance password.": [
        "Contraseña de la instancia."
      ],
      "Forgot password": [
        "Olvidé mi contraseña"
      ],
      "Create new account": [
        "Crear nueva cuenta"
      ],
      "Invalid": [
        "No válido"
      ],
      "Doesn't have the pattern of an email": [
        "No tiene el formato de un correo electrónico"
      ],
      "Should start with +": [
        "Debe comenzar con +"
      ],
      "A phone number consists of numbers only": [
        "Un número de teléfono contiene únicamente dígitos"
      ],
      "Invalid value": [
        "Valor no válido"
      ],
      "Max 7 lines": [
        "Máximo 7 líneas"
      ],
      "Doesn't match": [
        "No coincide"
      ],
      "Instance created": [
        "Instancia creada"
      ],
      "Unauthorized.": [
        "No autorizado."
      ],
      "Conflict.": [
        "Conflicto."
      ],
      "Not found.": [
        "No encontrado."
      ],
      "New password": [
        "Nueva contraseña"
      ],
      "Next password to be used": [
        "Próxima contraseña a utilizar"
      ],
      "Repeat password": [
        "Repetir contraseña"
      ],
      "Confirm the same password": [
        "Confirmá la misma contraseña"
      ],
      "Please complete the marked fields and choose authorization method": [
        "Por favor completá los campos marcados y elegí un método de autorización"
      ],
      "Confirm operation": [
        "Confirmar operación"
      ],
      "Check the password.": [
        "Verificá la contraseña."
      ],
      "Instance not found.": [
        "Instancia no encontrada."
      ],
      "Description": [
        "Descripción"
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        "Te ayuda a recordar dónde se está usando este token de acceso antes de eliminarlo."
      ],
      "Duration": [
        "Duración"
      ],
      "Time the access token will be valid.": [
        "Tiempo durante el cual el token de acceso será válido."
      ],
      "Refreshable access tokens can pose a security risk!": [
        "¡Los tokens de acceso renovables pueden representar un riesgo de seguridad!"
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        "Los tokens de acceso renovables pueden actualizarse antes de que venza su tiempo de vida, otorgando acceso ilimitado a quien los posea. Usá esta opción solo si sabés lo que estás haciendo y evaluaste los riesgos asociados, especialmente respecto a los permisos otorgados por el alcance."
      ],
      "Scope": [
        "Alcance"
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        "El alcance define el conjunto de permisos del token de acceso. Los tokens renovables tienen permiso para extender el tiempo de vencimiento."
      ],
      "Allows all operations without limit.": [
        "Permite todas las operaciones sin restricción."
      ],
      "Allows all operations to read information.": [
        "Permite todas las operaciones de lectura de información."
      ],
      "Allows the creation of orders and checking of payment status.": [
        "Permite crear órdenes y consultar el estado de pago."
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        "Permite crear órdenes, consultar el estado de pago y bloquear inventario."
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        "Permite crear órdenes, consultar el estado de pago y gestionar reembolsos."
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        "Permite crear órdenes, consultar el estado de pago, bloquear inventario y gestionar reembolsos."
      ],
      "Allows all operations to read information with extendable expiration time.": [
        "Permite todas las operaciones de lectura con tiempo de vencimiento extendible."
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        "Permite crear órdenes y consultar el estado de pago con tiempo de vencimiento extendible."
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        "Permite crear órdenes, consultar el estado de pago y bloquear inventario con tiempo de vencimiento extendible."
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        "Permite crear órdenes, consultar el estado de pago y gestionar reembolsos con tiempo de vencimiento extendible."
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        "Permite crear órdenes, consultar el estado de pago, bloquear inventario y gestionar reembolsos con tiempo de vencimiento extendible."
      ],
      "All (refreshable)": [
        "Todo (renovable)"
      ],
      "Spa": [
        "Spa"
      ],
      "Spa (refreshable)": [
        "Spa (renovable)"
      ],
      "Choose one": [
        "Elegir uno"
      ],
      "Read only": [
        "Solo lectura"
      ],
      "All": [
        "Todo"
      ],
      "Order simple": [
        "Orden simple"
      ],
      "Order Point-of-Sale": [
        "Orden punto de venta"
      ],
      "Order management": [
        "Gestión de órdenes"
      ],
      "Order full": [
        "Orden completa"
      ],
      "Read only (refreshable)": [
        "Solo lectura (renovable)"
      ],
      "Order simple (refreshable)": [
        "Orden simple (renovable)"
      ],
      "Order Point-of-Sale (refreshable)": [
        "Orden punto de venta (renovable)"
      ],
      "Order management (refreshable)": [
        "Gestión de órdenes (renovable)"
      ],
      "Order full (refreshable)": [
        "Orden completa (renovable)"
      ],
      "Current password": [
        "Contraseña actual"
      ],
      "Please complete the marked fields": [
        "Por favor completá los campos marcados"
      ],
      "Access token created": [
        "Token de acceso creado"
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        "Copiá el valor del token de acceso y guardalo, ya que no podrás recuperarlo más adelante."
      ],
      "Token": [
        "Token"
      ],
      "This token will never expire": [
        "Este token nunca vencerá"
      ],
      "This token will be available until %1$s": [
        "Este token estará disponible hasta el %1$s"
      ],
      "No 'admin' instance configured yet.": [
        "Aún no se configuró ninguna instancia 'admin'."
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        "Creá una instancia 'admin' para comenzar a usar el backoffice del comerciante."
      ],
      "Create access token": [
        "Crear token de acceso"
      ],
      "Load more devices before the first one": [
        "Cargar más dispositivos antes del primero"
      ],
      "Load first page": [
        "Cargar primera página"
      ],
      "Created at": [
        "Creado el"
      ],
      "Expires at": [
        "Vence el"
      ],
      "Never": [
        "Nunca"
      ],
      "Remove this access token": [
        "Eliminar este token de acceso"
      ],
      "Delete": [
        "Borrar"
      ],
      "Load more devices after the last one": [
        "Cargar más dispositivos después del último"
      ],
      "Load next page": [
        "Cargar siguiente página"
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        "Aún no hay sesiones activas, agregá una presionando el signo +"
      ],
      "Forbidden.": [
        "Acceso denegado."
      ],
      "Delete access token": [
        "Eliminar token de acceso"
      ],
      "Deleting an access token cannot be undone.": [
        "La eliminación de un token de acceso no puede deshacerse."
      ],
      "This is not a valid Bitcoin address.": [
        "Esta no es una dirección de Bitcoin válida."
      ],
      "This is not a valid Ethereum address.": [
        "Esta no es una dirección de Ethereum válida."
      ],
      "This is not a valid host.": [
        "Este no es un host válido."
      ],
      "IBANs usually have more than 4 digits.": [
        "Los IBAN generalmente tienen más de 4 dígitos."
      ],
      "IBANs usually have fewer than 34 digits.": [
        "Los IBAN generalmente tienen menos de 34 dígitos."
      ],
      "The IBAN's country code could not be retrieved.": [
        "No se pudo obtener el código de país del IBAN."
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        "El IBAN no es válido porque el dígito verificador es incorrecto."
      ],
      "This account is not allowed.": [
        "Esta cuenta no está permitida."
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        "Ninguno de los métodos de transferencia soportados por el servidor es compatible con esta aplicación. Configuración del servidor: %1$s"
      ],
      "Wire method": [
        "Método de transferencia"
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        "Seleccioná el método que querés usar para transferir tus ganancias a tu cuenta comercial."
      ],
      "Select a wire method...": [
        "Seleccioná un método de transferencia..."
      ],
      "Routing": [
        "Enrutamiento"
      ],
      "Routing number": [
        "Número de enrutamiento"
      ],
      "Account": [
        "Cuenta"
      ],
      "Account number": [
        "Número de cuenta"
      ],
      "Code": [
        "Código"
      ],
      "Business Identifier Code": [
        "Código de identificación de empresa"
      ],
      "International Bank Account Number": [
        "Número de cuenta bancaria internacional"
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        "tu número de cuenta bancaria, p. ej. DE12 0000 1111 2222 3333 00"
      ],
      "Unified Payment Interface": [
        "Interfaz de pago unificada"
      ],
      "Bitcoin protocol": [
        "Protocolo Bitcoin"
      ],
      "Ethereum protocol": [
        "Protocolo Ethereum"
      ],
      "Interledger protocol": [
        "Protocolo Interledger"
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        "Ingresá los datos sin esquema. Se puede incluir una subruta:"
      ],
      "Cyclos host": [
        "Host de Cyclos"
      ],
      "cyclos account": [
        "Cuenta Cyclos"
      ],
      "Name of the account holder": [
        "Nombre del titular de la cuenta"
      ],
      "John Doe": [
        "Juan Pérez"
      ],
      "Legal name of the person holding the account.": [
        "Nombre legal de la persona titular de la cuenta."
      ],
      "Invalid url": [
        "URL no válida"
      ],
      "URL must end with a '/'": [
        "La URL debe terminar con '/'"
      ],
      "URL must not contain params": [
        "La URL no debe contener parámetros"
      ],
      "URL must not hash param": [
        "La URL no debe contener parámetro de hash"
      ],
      "Conflict": [
        "Conflicto"
      ],
      "Server replied with \"bad request\".": [
        "El servidor respondió con un error de solicitud incorrecta."
      ],
      "Unauthorized, check credentials.": [
        "No autorizado, verificá las credenciales."
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        "El endpoint no parece ser un API Taler Revenue."
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        "La solicitud fue correcta, pero el servidor del banco no respondió con el valor apropiado para 'credit_account', por lo que no podemos confirmar que sea la misma cuenta bancaria."
      ],
      "Unsupported type of account": [
        "Tipo de cuenta no soportado"
      ],
      "Account:": [
        "Cuenta:"
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        "Si el banco soporta el API Taler Revenue, podés agregar la URL del endpoint a continuación para mantener la información de ingresos sincronizada."
      ],
      "Endpoint URL": [
        "URL del endpoint"
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        "Desde dónde el comerciante puede descargar información sobre las transferencias bancarias entrantes a esta cuenta"
      ],
      "Auth type": [
        "Tipo de autenticación"
      ],
      "Choose the authentication type for the account info URL": [
        "Elegí el tipo de autenticación para la URL de información de cuenta"
      ],
      "Without authentication": [
        "Sin autenticación"
      ],
      "With username and password": [
        "Con usuario y contraseña"
      ],
      "With token": [
        "Con token"
      ],
      "Do not change": [
        "No modificar"
      ],
      "Username to access the account information.": [
        "Usuario para acceder a la información de la cuenta."
      ],
      "Password to access the account information.": [
        "Contraseña para acceder a la información de la cuenta."
      ],
      "Access token to access the account information.": [
        "Token de acceso para acceder a la información de la cuenta."
      ],
      "Match": [
        "Coincidencia"
      ],
      "Check where the information match against the server info.": [
        "Verificá si la información coincide con la del servidor."
      ],
      "Compare info from server with account form": [
        "Comparar la información del servidor con el formulario de la cuenta"
      ],
      "Test": [
        "Probar"
      ],
      "Server didn't like the request we made.": [
        "El servidor rechazó la solicitud realizada."
      ],
      "Account details": [
        "Detalles de la cuenta"
      ],
      "Check if the information matches the server info.": [
        "Verificá si la información coincide con la del servidor."
      ],
      "The bank account has been deleted.": [
        "La cuenta bancaria fue eliminada."
      ],
      "Delete account": [
        "Eliminar cuenta"
      ],
      "Delete the account \"%1$s\"": [
        "Eliminar la cuenta \"%1$s\""
      ],
      "Invalid payto: \"%1$s\"": [
        "Payto no válido: \"%1$s\""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        "Si eliminás la cuenta con nombre %1$s se perderá toda su información"
      ],
      "Deleting an account can't be undone.": [
        "La eliminación de una cuenta no puede deshacerse."
      ],
      "Bank accounts": [
        "Cuentas bancarias"
      ],
      "Add new account": [
        "Agregar nueva cuenta"
      ],
      "Owner's name": [
        "Nombre del titular"
      ],
      "Delete selected accounts from the database": [
        "Eliminar las cuentas seleccionadas de la base de datos"
      ],
      "There are no accounts yet, add more pressing the + sign": [
        "Aún no hay cuentas, agregá más presionando el signo +"
      ],
      "You must provide a bank account to receive payments.": [
        "Debés configurar una cuenta bancaria para recibir pagos."
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        "Sin esta información, no podrás crear nuevas órdenes de pago que se transfieran a una cuenta bancaria."
      ],
      "Invalid. Please use only letters and numbers.": [
        "No válido. Usá únicamente letras y números."
      ],
      "Name": [
        "Nombre"
      ],
      "Category name": [
        "Nombre de la categoría"
      ],
      "Category deleted": [
        "Categoría eliminada"
      ],
      "Add new devices": [
        "Agregar nuevos dispositivos"
      ],
      "ID": [
        "ID"
      ],
      "Total products": [
        "Total de productos"
      ],
      "Delete selected category from the database": [
        "Eliminar la categoría seleccionada de la base de datos"
      ],
      "There are no categories yet, add more pressing the + sign": [
        "Aún no hay categorías, agregá más presionando el signo +"
      ],
      "Id:": [
        "ID:"
      ],
      "Name of the category": [
        "Nombre de la categoría"
      ],
      "Products": [
        "Productos"
      ],
      "Image": [
        "Imagen"
      ],
      "Load more products after the last one": [
        "Cargar más productos después del último"
      ],
      "There are no products in this category.": [
        "No hay productos en esta categoría."
      ],
      "Account's KYC status": [
        "Estado KYC de la cuenta"
      ],
      "Exchange": [
        "Exchange"
      ],
      "Status": [
        "Estado"
      ],
      "Ok": [
        "Ok"
      ],
      "Action required": [
        "Se requiere acción"
      ],
      "Warning": [
        "Advertencia"
      ],
      "Error": [
        "Error"
      ],
      "Bank account verification required.": [
        "Se requiere verificación de cuenta bancaria."
      ],
      "More information required.": [
        "Se requiere más información."
      ],
      "Awaiting for account review.": [
        "Esperando revisión de la cuenta."
      ],
      "Ready": [
        "Listo"
      ],
      "Syncing...": [
        "Sincronizando..."
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        "Error interno del servicio de pago. Contactá al administrador o intentá más tarde."
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        "Error interno del backend del comerciante. Contactá al administrador o intentá más tarde."
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        "Tiempo de espera agotado del servicio de pago. Contactá al administrador o intentá más tarde."
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        "Servicio de pago inaccesible. Contactá al administrador o intentá más tarde."
      ],
      "Incompatible core banking system.": [
        "Sistema bancario central incompatible."
      ],
      "Backend internal error. Contact administrator or check again later.": [
        "Error interno del backend. Contactá al administrador o intentá más tarde."
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        "La respuesta del servicio de pago no es válida. Contactá al administrador o intentá más tarde."
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        "El proveedor del servicio de pago no puede realizar transferencias a esta cuenta."
      ],
      "No pending kyc verification!": [
        "¡No hay verificaciones KYC pendientes!"
      ],
      "The account for wire transfers does not appear to be valid": [
        "La cuenta para transferencias bancarias no parece ser válida"
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        "El servicio backend respondió con \"%1$s\", lo cual no es válido."
      ],
      "No exchange keys": [
        "Sin claves de exchange"
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        "El servicio backend aún se está sincronizando con el proveedor de servicios de pago."
      ],
      "No transfers can be made from this account": [
        "No se pueden realizar transferencias desde esta cuenta"
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        "El sistema bancario central no puede realizar transferencias entre las cuentas del proveedor de servicios de pago y tus cuentas bancarias. Por lo tanto, no podés usar este proveedor. Atentamente, el Exchange de Taler."
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        "Debés completar un proceso KYC (Conocé a tu Cliente) según lo exigen las regulaciones o leyes financieras"
      ],
      "The payment service provider requires more information.": [
        "El proveedor de servicios de pago requiere más información."
      ],
      "Click here to complete this step.": [
        "Hacé clic aquí para completar este paso."
      ],
      "We are waiting for the access token to be present. Check again later.": [
        "Estamos esperando que el token de acceso esté disponible. Intentá de nuevo más tarde."
      ],
      "Awaiting AML review": [
        "Esperando revisión AML"
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        "Esta cuenta no puede usarse. El proveedor de servicios de pago debe verificar la información de la cuenta de forma manual."
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        "Esta cuenta fue configurada exitosamente para su uso con el proveedor de servicios de pago."
      ],
      "Logic bug": [
        "Error de lógica"
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        "El servicio backend detectó un error interno. Contactá al administrador del sistema o intentá más tarde."
      ],
      "Internal error": [
        "Error interno"
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        "El proveedor de servicios de pago detectó un error interno. Contactá al administrador del sistema o intentá más tarde."
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        "El proveedor de servicios del comerciante detectó un error interno. Contactá al administrador del sistema o intentá más tarde."
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        "El servicio backend no pudo contactar al proveedor de servicios de pago por un tiempo de espera agotado. Contactá al administrador o intentá más tarde."
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        "No se pudo contactar al proveedor de servicios de pago. Contactá al administrador del sistema o intentá más tarde."
      ],
      "Unsupported account": [
        "Cuenta no soportada"
      ],
      "This exchange does not support the given account.": [
        "Este exchange no soporta la cuenta indicada."
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        "El proveedor de servicios de pago respondió con un estado no válido. Contactá al administrador del sistema o intentá más tarde."
      ],
      "Change value to unknown date": [
        "Cambiar valor a fecha desconocida"
      ],
      "Enter description or id": [
        "Ingresá una descripción o ID"
      ],
      "No match found for that description or ID.": [
        "No se encontró ninguna coincidencia para esa descripción o ID."
      ],
      "You must enter a valid product identifier.": [
        "Debés ingresar un identificador de producto válido."
      ],
      "Quantity must be greater than 0!": [
        "¡La cantidad debe ser mayor que 0!"
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        "Esta cantidad supera el stock disponible. Actualmente solo quedan %1$s unidades sin reservar en el stock."
      ],
      "Search product": [
        "Buscar producto"
      ],
      "Quantity": [
        "Cantidad"
      ],
      "How many products will be added": [
        "Cuántos productos se agregarán"
      ],
      "Add from inventory": [
        "Agregar del inventario"
      ],
      "This product has %1$s applicable taxes configured.": [
        "Este producto tiene %1$s impuestos aplicables configurados."
      ],
      "No taxes configured for this product.": [
        "No hay impuestos configurados para este producto."
      ],
      "Amount": [
        "Monto"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        "Los impuestos pueden estar en monedas distintas a la moneda principal utilizada por el comerciante."
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        "Ingresá la moneda y el valor separados por dos puntos (p. ej., &quot;USD:2.3&quot;)."
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        "Nombre legal del impuesto, p. ej. IVA o derechos de importación."
      ],
      "Add tax to the tax list": [
        "Agregar impuesto a la lista de impuestos"
      ],
      "Describe and add a product that is not in the inventory list": [
        "Describí y agregá un producto que no está en la lista de inventario"
      ],
      "Add custom product": [
        "Agregar producto personalizado"
      ],
      "Complete information of the product": [
        "Completá la información del producto"
      ],
      "Must be a number.": [
        "Debe ser un número."
      ],
      "Must be greater than 0.": [
        "Debe ser mayor que 0."
      ],
      "Photo of the product.": [
        "Foto del producto."
      ],
      "Full product description.": [
        "Descripción completa del producto."
      ],
      "Unit name": [
        "Nombre de la unidad"
      ],
      "Name of the product unit.": [
        "Nombre de la unidad del producto."
      ],
      "Price per unit": [
        "Precio por unidad"
      ],
      "Amount in the current currency.": [
        "Monto en la moneda actual."
      ],
      "How many products will be added.": [
        "Cuántos productos se agregarán."
      ],
      "Taxes": [
        "Impuestos"
      ],
      "Total price": [
        "Precio total"
      ],
      "Must be greater than 0": [
        "Debe ser mayor que 0"
      ],
      "Must have a refund deadline": [
        "Debe tener un plazo de reembolso"
      ],
      "Auto refund can't be after refund deadline": [
        "El reembolso automático no puede ser posterior al plazo de reembolso"
      ],
      "Must be in the future": [
        "Debe ser en el futuro"
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        "Debe especificarse una URL de cumplimiento o un mensaje de cumplimiento."
      ],
      "is not a valid URL": [
        "no es una URL válida"
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        "No hay cuentas bancarias activas configuradas. Debe haber al menos una cuenta bancaria disponible para crear nuevas órdenes"
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        "El producto con ID \"%1$s\" está agotado."
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        "Ningún exchange aceptará pagos debido a requisitos de KYC."
      ],
      "Manage products in order": [
        "Gestionar productos en la orden"
      ],
      "%1$s products with a total price of %2$s.": [
        "%1$s productos con un precio total de %2$s."
      ],
      "Manage list of products in the order.": [
        "Gestionar la lista de productos en la orden."
      ],
      "Remove this product from the order.": [
        "Quitar este producto de la orden."
      ],
      "Products price sum": [
        "Suma de precios de productos"
      ],
      "Total product price added up": [
        "Precio total acumulado de los productos"
      ],
      "Order price": [
        "Precio de la orden"
      ],
      "Amount to be paid by the customer": [
        "Monto a pagar por el cliente"
      ],
      "Final order price": [
        "Precio final de la orden"
      ],
      "Summary": [
        "Resumen"
      ],
      "Title of the order to be shown to the customer": [
        "Título de la orden que se mostrará al cliente"
      ],
      "Shipping and fulfillment": [
        "Envío y cumplimiento"
      ],
      "Delivery date": [
        "Fecha de entrega"
      ],
      "Deadline for physical delivery assured by the merchant.": [
        "Plazo para la entrega física garantizada por el comerciante."
      ],
      "Delivery location": [
        "Lugar de entrega"
      ],
      "Address where the products will be delivered": [
        "Dirección a donde se entregarán los productos"
      ],
      "Fulfillment URL": [
        "URL de cumplimiento"
      ],
      "URL to which the user will be redirected after successful payment.": [
        "URL a la que se redirigirá al usuario luego de un pago exitoso."
      ],
      "Fulfillment message": [
        "Mensaje de cumplimiento"
      ],
      "Message shown to the customer after paying for the order.": [
        "Mensaje que se le muestra al cliente después de pagar la orden."
      ],
      "Taler payment options": [
        "Opciones de pago de Taler"
      ],
      "Override default Taler payment settings for this order": [
        "Sobreescribir la configuración de pago predeterminada de Taler para esta orden"
      ],
      "Payment time": [
        "Tiempo de pago"
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        "Tiempo que tiene el cliente para pagar antes de que la oferta venza. Los productos del inventario quedarán reservados hasta este plazo. El tiempo comienza a contar desde la creación de la orden."
      ],
      "Default": [
        "Predeterminado"
      ],
      "Refund time": [
        "Tiempo de reembolso"
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        "Tiempo durante el cual el comerciante puede reembolsar la orden. El tiempo comienza a contar desde la creación de la orden."
      ],
      "Wire transfer time": [
        "Tiempo de transferencia bancaria"
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        "Tiempo que tiene el exchange para realizar la transferencia bancaria. El tiempo comienza a contar desde la creación de la orden."
      ],
      "Auto-refund time": [
        "Tiempo de reembolso automático"
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        "Tiempo hasta el cual la billetera verificará automáticamente si hay reembolsos sin necesidad de intervención del usuario."
      ],
      "Maximum fee": [
        "Comisión máxima"
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        "Comisiones máximas que el comerciante está dispuesto a cubrir para esta orden. Las comisiones de depósito superiores deben ser cubiertas íntegramente por el consumidor."
      ],
      "Create token": [
        "Crear token"
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        "Si el ID de la orden es fácil de adivinar, el token impedirá que otros usuarios puedan reclamarla."
      ],
      "Minimum age required": [
        "Edad mínima requerida"
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        "Cualquier valor mayor que 0 limitará las monedas que pueden usarse para pagar este contrato. Si se deja vacío, la restricción de edad la definirán los productos"
      ],
      "Minimum age defined by the products is %1$s": [
        "La edad mínima definida por los productos es %1$s"
      ],
      "No product with age restriction in this order": [
        "No hay productos con restricción de edad en esta orden"
      ],
      "Additional information": [
        "Información adicional"
      ],
      "Custom information to be included in the contract for this order.": [
        "Información personalizada que se incluirá en el contrato de esta orden."
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        "Debés ingresar un valor en notación de objetos JavaScript (JSON)."
      ],
      "remove": [
        "quitar"
      ],
      "Custom field name": [
        "Nombre del campo personalizado"
      ],
      "Disabled": [
        "Deshabilitado"
      ],
      "No deadline": [
        "Sin plazo"
      ],
      "Deadline at %1$s": [
        "Plazo el %1$s"
      ],
      "Select date to show nearby orders": [
        "Seleccioná una fecha para mostrar órdenes cercanas"
      ],
      "Only show unpaid orders": [
        "Mostrar solo órdenes sin pagar"
      ],
      "Only show paid orders": [
        "Mostrar solo órdenes pagas"
      ],
      "Paid": [
        "Pagado"
      ],
      "Only show orders with refunds": [
        "Mostrar solo órdenes con reembolsos"
      ],
      "Refunded": [
        "Reembolsado"
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        "Mostrar solo órdenes pagas cuya transferencia bancaria aún está pendiente."
      ],
      "Not wired": [
        "Sin transferir"
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        "Mostrar solo las órdenes que ya fueron transferidas por el proveedor de servicios de pago"
      ],
      "Completed": [
        "Completado"
      ],
      "Remove all filters": [
        "Eliminar todos los filtros"
      ],
      "Clear date filter": [
        "Borrar filtro de fecha"
      ],
      "Jump to date (%1$s)": [
        "Ir a la fecha (%1$s)"
      ],
      "Gone.": [
        "Eliminado."
      ],
      "UnavailableForLegalReasons.": [
        "No disponible por razones legales."
      ],
      "Jump to order with the given product ID": [
        "Ir a la orden con el ID de producto indicado"
      ],
      "Order id": [
        "ID de orden"
      ],
      "Instance unknown": [
        "Instancia desconocida"
      ],
      "Order unknown": [
        "Orden desconocida"
      ],
      "Create order": [
        "Crear orden"
      ],
      "The instance doesn't exist": [
        "La instancia no existe"
      ],
      "The order doesn't exist": [
        "La orden no existe"
      ],
      "Date": [
        "Fecha"
      ],
      "Refund": [
        "Reembolso"
      ],
      "copy url": [
        "copiar URL"
      ],
      "Load more orders after the last one": [
        "Cargar más órdenes después de la última"
      ],
      "No orders have been found matching your query!": [
        "¡No se encontraron órdenes que coincidan con tu búsqueda!"
      ],
      "Duplicated": [
        "Duplicado"
      ],
      "This value exceeds the refundable amount.": [
        "Este valor supera el monto reembolsable."
      ],
      "Forbidden": [
        "Acceso denegado"
      ],
      "Gone": [
        "Eliminado"
      ],
      "There are pending KYC requirements.": [
        "Hay requisitos de KYC pendientes."
      ],
      "refund": [
        "reembolsar"
      ],
      "Reason": [
        "Motivo"
      ],
      "Amount to be refunded": [
        "Monto a reembolsar"
      ],
      "Max refundable:": [
        "Máximo reembolsable:"
      ],
      "Choose one...": [
        "Elegí uno..."
      ],
      "Requested by the customer": [
        "Solicitado por el cliente"
      ],
      "Other": [
        "Otro"
      ],
      "Why this order is being refunded": [
        "Por qué se está reembolsando esta orden"
      ],
      "More information to give context": [
        "Información adicional para dar contexto"
      ],
      "now": [
        "ahora"
      ],
      "This is when the time for making refund has been expired.": [
        "Este es el momento en que venció el plazo para realizar el reembolso."
      ],
      "This is when the time for making the payment has been expired.": [
        "Este es el momento en que venció el plazo para realizar el pago."
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        "Este es el momento en que el proveedor de servicios de pago ejecutará la transferencia bancaria."
      ],
      "This wire transfer has been notified by the payment service provider.": [
        "Esta transferencia bancaria fue notificada por el proveedor de servicios de pago."
      ],
      "This refund is waiting to be claimed by the customer.": [
        "Este reembolso está esperando a ser reclamado por el cliente."
      ],
      "This refund has been claimed by the customer.": [
        "Este reembolso fue reclamado por el cliente."
      ],
      "The current moment in time.": [
        "El momento actual."
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        "Este reembolso no puede reclamarse porque la transferencia bancaria ya fue realizada."
      ],
      "Contract terms": [
        "Términos del contrato"
      ],
      "Human-readable description of the whole purchase": [
        "Descripción legible de toda la compra"
      ],
      "Total price for the transaction": [
        "Precio total de la transacción"
      ],
      "URL for this purchase": [
        "URL para esta compra"
      ],
      "Max fee": [
        "Comisión máxima"
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        "Comisión de depósito total máxima aceptada por el comerciante para este contrato"
      ],
      "Time when this contract was generated": [
        "Momento en que se generó este contrato"
      ],
      "Payment deadline": [
        "Plazo de pago"
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        "Pasado este plazo, el comerciante no aceptará pagos para el contrato"
      ],
      "Refund deadline": [
        "Plazo de reembolso"
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        "Pasado este plazo, no se aceptarán reembolsos."
      ],
      "Wire transfer deadline": [
        "Plazo de transferencia bancaria"
      ],
      "Transfer deadline for the exchange": [
        "Plazo de transferencia para el exchange"
      ],
      "Time indicating when the order should be delivered": [
        "Fecha indicativa de entrega de la orden"
      ],
      "Where the order will be delivered": [
        "Dónde se entregará la orden"
      ],
      "Auto-refund delay": [
        "Plazo de reembolso automático"
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        "Cuánto tiempo debe intentar la billetera obtener un reembolso automático para la compra"
      ],
      "Extra info": [
        "Información extra"
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        "Datos adicionales que solo interpreta la interfaz del comerciante"
      ],
      "order created": [
        "orden creada"
      ],
      "pay deadline": [
        "plazo de pago"
      ],
      "refund deadline": [
        "plazo de reembolso"
      ],
      "delivery": [
        "entrega"
      ],
      "Order": [
        "Orden"
      ],
      "Claimed": [
        "Reclamado"
      ],
      "Claimed at": [
        "Reclamado el"
      ],
      "Timeline": [
        "Cronología"
      ],
      "Payment details": [
        "Detalles del pago"
      ],
      "Order status": [
        "Estado de la orden"
      ],
      "Unpaid": [
        "Impago"
      ],
      "Product list": [
        "Lista de productos"
      ],
      "refund missed: %1$s": [
        "reembolso no realizado: %1$s"
      ],
      "refund missed: %1$s: %2$s": [
        "reembolso no realizado: %1$s: %2$s"
      ],
      "refund created: %1$s": [
        "reembolso creado: %1$s"
      ],
      "refund created: %1$s: %2$s": [
        "reembolso creado: %1$s: %2$s"
      ],
      "refund taken: %1$s": [
        "reembolso cobrado: %1$s"
      ],
      "refund taken: %1$s: %2$s": [
        "reembolso cobrado: %1$s: %2$s"
      ],
      "The contract terms has a v1 order without choices_index.": [
        "Los términos del contrato tienen una orden v1 sin choices_index."
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        "Los términos del contrato tienen una orden v1 con un choices_index inválido."
      ],
      "wired %1$s": [
        "transferido %1$s"
      ],
      "wire deadline": [
        "plazo de transferencia"
      ],
      "Wired": [
        "Transferido"
      ],
      "Refund order": [
        "Reembolsar orden"
      ],
      "Not refundable": [
        "No reembolsable"
      ],
      "Next event in": [
        "Próximo evento en"
      ],
      "The order was wired.": [
        "La orden fue transferida."
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        "El procesamiento bancario puede demorar algunos días hábiles dependiendo de tu banco."
      ],
      "Refunded amount": [
        "Monto reembolsado"
      ],
      "Refund taken": [
        "Reembolso cobrado"
      ],
      "Status URL": [
        "URL de estado"
      ],
      "Refund URI": [
        "URI de reembolso"
      ],
      "Pay at": [
        "Pagar en"
      ],
      "Order status URL": [
        "URL de estado de la orden"
      ],
      "Payment URI": [
        "URI de pago"
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        "Estado de orden desconocido. Esto es un error, por favor contactá al administrador."
      ],
      "Invalid. Please enter letters and numbers only.": [
        "No válido. Ingresá únicamente letras y números."
      ],
      "Just letters and numbers from 2 to 7": [
        "Solo letras y números del 2 al 7"
      ],
      "The size of the key must be 32 characters": [
        "La clave debe tener 32 caracteres"
      ],
      "Internal ID on the system": [
        "ID interno en el sistema"
      ],
      "Useful to identify the device physically": [
        "Útil para identificar el dispositivo físicamente"
      ],
      "Verification algorithm": [
        "Algoritmo de verificación"
      ],
      "Algorithm used to verify transactions in offline mode": [
        "Algoritmo utilizado para verificar transacciones en modo sin conexión"
      ],
      "Device key": [
        "Clave del dispositivo"
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        "Asegurate de elegir una contraseña difícil de adivinar, o usá el generador aleatorio."
      ],
      "Your device needs to match exactly the same value": [
        "Tu dispositivo debe tener exactamente el mismo valor"
      ],
      "Generate random secret key": [
        "Generar clave secreta aleatoria"
      ],
      "Random": [
        "Aleatorio"
      ],
      "Create another": [
        "Crear otro"
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        "Podés escanear el siguiente código QR con tu dispositivo o guardar la clave antes de continuar."
      ],
      "OTP devices": [
        "Dispositivos OTP"
      ],
      "Delete selected devices from the database": [
        "Eliminar los dispositivos seleccionados de la base de datos"
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        "Aún no hay dispositivos, agregá más presionando el signo +"
      ],
      "Template id is unknown": [
        "El ID de la plantilla es desconocido"
      ],
      "The provided information is inconsistent with the current state of the template": [
        "La información provista es inconsistente con el estado actual de la plantilla"
      ],
      "Device:": [
        "Dispositivo:"
      ],
      "Algorithm to use to verify transactions in offline mode": [
        "Algoritmo a usar para verificar transacciones en modo sin conexión"
      ],
      "Not modified": [
        "Sin modificar"
      ],
      "Be sure to be very hard to guess or use the random generator": [
        "Asegurate de que sea muy difícil de adivinar o usá el generador aleatorio"
      ],
      "Your device need to have exactly the same value": [
        "Tu dispositivo debe tener exactamente el mismo valor"
      ],
      "Change key": [
        "Cambiar clave"
      ],
      "Is not the same": [
        "No coincide"
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        "Estás actualizando la contraseña para la instancia con ID \"%1$s\""
      ],
      "In order to verify that you have access.": [
        "Para verificar que tenés acceso."
      ],
      "Confirm change": [
        "Confirmar cambio"
      ],
      "Testing password change": [
        "Verificando cambio de contraseña"
      ],
      "Password changed": [
        "Contraseña cambiada"
      ],
      "The current password is wrong.": [
        "La contraseña actual es incorrecta."
      ],
      "No enough rights to change the password.": [
        "No tenés permisos suficientes para cambiar la contraseña."
      ],
      "Account not found.": [
        "Cuenta no encontrada."
      ],
      "Add element to the list": [
        "Agregar elemento a la lista"
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        "Hacé clic aquí para configurar el stock del producto. Si se deja así, el backend no controlará el stock."
      ],
      "Manage stock": [
        "Gestionar stock"
      ],
      "This product has been configured without stock control": [
        "Este producto fue configurado sin control de stock"
      ],
      "Infinite": [
        "Ilimitado"
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        "La merma no puede superar el stock actual y las entradas pendientes (máximo %1$s)"
      ],
      "Incoming": [
        "Entrante"
      ],
      "Lost": [
        "Perdido"
      ],
      "Current": [
        "Actual"
      ],
      "Remove stock control for this product": [
        "Quitar el control de stock para este producto"
      ],
      "without stock": [
        "sin stock"
      ],
      "Next restock": [
        "Próximo reabastecimiento"
      ],
      "Warehouse address": [
        "Dirección del depósito"
      ],
      "Invalid amount": [
        "Monto no válido"
      ],
      "Product identification to use in URLs (for internal use only).": [
        "Identificación del producto para usar en las URL (solo para uso interno)."
      ],
      "Illustration of the product for customers.": [
        "Ilustración del producto para los clientes."
      ],
      "Product name.": [
        "Nombre del producto."
      ],
      "Product description for customers.": [
        "Descripción del producto para los clientes."
      ],
      "Age restriction": [
        "Restricción de edad"
      ],
      "Is this product restricted for customer below certain age?": [
        "¿Este producto tiene restricción de edad para los clientes?"
      ],
      "Minimum age of the customer": [
        "Edad mínima del cliente"
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        "Unidad que describe la cantidad de producto vendida (p. ej. 2 kilogramos, 5 litros, 3 unidades, 5 metros) para los clientes."
      ],
      "Example: kg, items or liters": [
        "Ejemplo: kg, unidades o litros"
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        "Precio de venta para los clientes, impuestos incluidos, por las unidades indicadas del producto."
      ],
      "Stock": [
        "Stock"
      ],
      "Inventory for products with finite supply (for internal use only).": [
        "Inventario para productos con stock limitado (solo para uso interno)."
      ],
      "Taxes included in the product price, exposed to customers.": [
        "Impuestos incluidos en el precio del producto, visibles para los clientes."
      ],
      "Search by category description or id": [
        "Buscar por descripción o ID de categoría"
      ],
      "Categories where this product will be listed on.": [
        "Categorías en las que se listará este producto."
      ],
      "Money pot": [
        "Fondo"
      ],
      "Search by money pot description or id": [
        "Buscar por descripción o ID de fondo"
      ],
      "Money pots where this product will be listed on.": [
        "Fondos en los que se listará este producto."
      ],
      "Select one": [
        "Seleccioná uno"
      ],
      "Group": [
        "Grupo"
      ],
      "Search by group name or id": [
        "Buscar por nombre o ID de grupo"
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        "La instancia no existe. Es posible que haya sido eliminada mientras se agregaba el producto."
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        "La categoría no existe. Es posible que haya sido eliminada mientras se agregaba el producto."
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        "El grupo de productos no existe. Es posible que haya sido eliminado mientras se agregaba el producto."
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        "El fondo no existe. Es posible que haya sido eliminado mientras se agregaba el producto."
      ],
      "Add product to inventory": [
        "Agregar producto al inventario"
      ],
      "Product not found.": [
        "Producto no encontrado."
      ],
      "This change was made without outdated info.": [
        "Este cambio se realizó sin información desactualizada."
      ],
      "Sales": [
        "Ventas"
      ],
      "Sold": [
        "Vendido"
      ],
      "Free": [
        "Gratis"
      ],
      "Go to product update page": [
        "Ir a la página de actualización del producto"
      ],
      "Update": [
        "Actualizar"
      ],
      "Remove this product from the database": [
        "Eliminar este producto de la base de datos"
      ],
      "Update the product with new price": [
        "Actualizar el producto con el nuevo precio"
      ],
      "Update product with new price": [
        "Actualizar producto con nuevo precio"
      ],
      "Confirm update": [
        "Confirmar actualización"
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        "la pérdida no puede superar el stock actual más las entradas (máx %1$s)"
      ],
      "Add more elements to the inventory": [
        "Agregar más elementos al inventario"
      ],
      "Report elements lost in the inventory": [
        "Registrar elementos perdidos en el inventario"
      ],
      "New price for the product": [
        "Nuevo precio para el producto"
      ],
      "There are values with errors.": [
        "Hay valores con errores."
      ],
      "Update product with new stock and price": [
        "Actualizar producto con nuevo stock y precio"
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        "Aún no hay productos, agregá más presionando el signo +"
      ],
      "Product (ID: %1$s) has been deleted": [
        "El producto (ID: %1$s) fue eliminado"
      ],
      "Jump to product with the given product ID": [
        "Ir al producto con el ID indicado"
      ],
      "Product id": [
        "ID de producto"
      ],
      "Delete product": [
        "Eliminar producto"
      ],
      "Delete the product \"%1$s\"": [
        "Eliminar el producto \"%1$s\""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        "Si eliminás el producto llamado %1$s (ID: %2$s), se perderán el stock y la información relacionada"
      ],
      "Deleting a product cannot be undone.": [
        "La eliminación de un producto no puede deshacerse."
      ],
      "Product id:": [
        "ID de producto:"
      ],
      "Your browser does not support the canvas element.": [
        "Tu navegador no soporta el elemento canvas."
      ],
      "Bad gateway": [
        "Gateway incorrecto"
      ],
      "Service unavailable": [
        "Servicio no disponible"
      ],
      "Select date from which to show statistics": [
        "Seleccioná la fecha desde la que mostrar estadísticas"
      ],
      "Show chart": [
        "Mostrar gráfico"
      ],
      "Orders chart": [
        "Gráfico de órdenes"
      ],
      "Show table": [
        "Mostrar tabla"
      ],
      "Orders table": [
        "Tabla de órdenes"
      ],
      "Start from (%1$s)": [
        "Desde (%1$s)"
      ],
      "Orders statistics": [
        "Estadísticas de órdenes"
      ],
      "Since": [
        "Desde"
      ],
      "No order statistics yet.": [
        "Aún no hay estadísticas de órdenes."
      ],
      "# of orders since": [
        "Cantidad de órdenes desde"
      ],
      "hour": [
        "hora"
      ],
      "day": [
        "día"
      ],
      "week": [
        "semana"
      ],
      "weeks": [
        "semanas"
      ],
      "month": [
        "mes"
      ],
      "months": [
        "meses"
      ],
      "quarter": [
        "trimestre"
      ],
      "quarters": [
        "trimestres"
      ],
      "years": [
        "años"
      ],
      "Revenue chart": [
        "Gráfico de ingresos"
      ],
      "Revenue table": [
        "Tabla de ingresos"
      ],
      "Revenue statistics filter": [
        "Filtro de estadísticas de ingresos"
      ],
      "Time range": [
        "Rango de tiempo"
      ],
      "Select time range to group dataset by": [
        "Seleccioná el rango de tiempo para agrupar los datos"
      ],
      "Select the number of ranges to include in data set": [
        "Seleccioná la cantidad de rangos a incluir en el conjunto de datos"
      ],
      "Currency": [
        "Moneda"
      ],
      "Select the currency to show statistics for": [
        "Seleccioná la moneda para mostrar las estadísticas"
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        "Estadísticas de ingresos de los últimos %1$s %2$s para la moneda '%3$s'"
      ],
      "Start time": [
        "Hora de inicio"
      ],
      "No revenue statistics yet.": [
        "Aún no hay estadísticas de ingresos."
      ],
      "Revenue": [
        "Ingresos"
      ],
      "Must be greater that 0": [
        "Debe ser mayor que 0"
      ],
      "Too short": [
        "Demasiado corto"
      ],
      "You don't have enough permissions.": [
        "No tenés permisos suficientes."
      ],
      "There is a template with this identifier, please choose another one.": [
        "Ya existe una plantilla con este identificador, por favor elegí otro."
      ],
      "Identifier": [
        "Identificador"
      ],
      "Name of the template in URLs.": [
        "Nombre de la plantilla en las URL."
      ],
      "Template name": [
        "Nombre de la plantilla"
      ],
      "Describe what this template stands for": [
        "Describí para qué sirve esta plantilla"
      ],
      "Order summary": [
        "Resumen de la orden"
      ],
      "If specified here, this template will create orders with the same summary": [
        "Si se especifica, esta plantilla creará órdenes con el mismo resumen"
      ],
      "Summary is editable": [
        "El resumen es editable"
      ],
      "Allow the user to change the summary.": [
        "Permitir al usuario modificar el resumen."
      ],
      "If specified here, this template will create orders with the same price": [
        "Si se especifica, esta plantilla creará órdenes con el mismo precio"
      ],
      "Amount is editable": [
        "El monto es editable"
      ],
      "Allow the user to select the amount to pay.": [
        "Permitir al usuario seleccionar el monto a pagar."
      ],
      "Currency is editable": [
        "La moneda es editable"
      ],
      "Allow the user to change currency.": [
        "Permitir al usuario cambiar la moneda."
      ],
      "Supported currencies": [
        "Monedas soportadas"
      ],
      "Supported currencies: %1$s": [
        "Monedas soportadas: %1$s"
      ],
      "Minimum age": [
        "Edad mínima"
      ],
      "Is this contract restricted to some age?": [
        "¿Este contrato tiene restricción de edad?"
      ],
      "Payment timeout": [
        "Tiempo límite de pago"
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        "Cuánto tiempo tiene el cliente para completar el pago una vez creada la orden."
      ],
      "OTP device": [
        "Dispositivo OTP"
      ],
      "Use to verify transactions in offline mode.": [
        "Usar para verificar transacciones en modo sin conexión."
      ],
      "No OTP device.": [
        "Sin dispositivo OTP."
      ],
      "Add one first": [
        "Agregá uno primero"
      ],
      "No device": [
        "Sin dispositivo"
      ],
      "Add new templates": [
        "Agregar nuevas plantillas"
      ],
      "Load more templates before the first one": [
        "Cargar más plantillas antes de la primera"
      ],
      "Delete selected templates from the database": [
        "Eliminar las plantillas seleccionadas de la base de datos"
      ],
      "Use template to create new order": [
        "Usar plantilla para crear una nueva orden"
      ],
      "Generate a QR code for the template.": [
        "Generar un código QR para la plantilla."
      ],
      "Show QR": [
        "Mostrar QR"
      ],
      "Load more templates after the last one": [
        "Cargar más plantillas después de la última"
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        "Aún no hay plantillas, agregá más presionando el signo +"
      ],
      "Jump to template with the given template ID": [
        "Ir a la plantilla con el ID indicado"
      ],
      "Template identification": [
        "Identificación de plantilla"
      ],
      "Delete template": [
        "Eliminar plantilla"
      ],
      "Delete the template \"%1$s\"": [
        "Eliminar la plantilla \"%1$s\""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        "Si eliminás la plantilla %1$s (ID: %2$s) podrías perder información"
      ],
      "Deleting a template cannot be undone.": [
        "La eliminación de una plantilla no puede deshacerse."
      ],
      "Print": [
        "Imprimir"
      ],
      "The template configuration needs to be fixed.": [
        "La configuración de la plantilla debe ser corregida."
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        "La moneda de la plantilla es %1$s y no está en la lista de monedas soportadas."
      ],
      "If specified, this template will create order with the same summary": [
        "Si se especifica, esta plantilla creará órdenes con el mismo resumen"
      ],
      "If specified, this template will create orders with the same price": [
        "Si se especifica, esta plantilla creará órdenes con el mismo precio"
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        "Cuánto tiempo tiene el cliente para completar el pago una vez creada la orden."
      ],
      "An amount is required": [
        "Se requiere un monto"
      ],
      "An order summary is required": [
        "Se requiere un resumen de la orden"
      ],
      "No more stock for product with ID \"%1$s\".": [
        "Sin stock para el producto con ID \"%1$s\"."
      ],
      "New order from template": [
        "Nueva orden desde plantilla"
      ],
      "Amount of the order": [
        "Monto de la orden"
      ],
      "Slug": [
        "Slug"
      ],
      "Token family slug to use in URLs (for internal use only)": [
        "Slug de la familia de tokens para usar en las URL (solo para uso interno)"
      ],
      "Kind": [
        "Tipo"
      ],
      "Choose between a discount and a subscription": [
        "Elegí entre un descuento y una suscripción"
      ],
      "Start Date": [
        "Fecha de inicio"
      ],
      "The first day the coupon/subscription can be used.": [
        "El primer día en que el cupón/suscripción puede usarse."
      ],
      " If set to %1$s, it cannot be used before this date.": [
        " Si se establece en %1$s, no podrá usarse antes de esa fecha."
      ],
      "Expiration Date": [
        "Fecha de vencimiento"
      ],
      "The last day the coupon/subscription can be used.": [
        "El último día en que el cupón/suscripción puede usarse."
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        " Si se establece en %1$s, dejarán de ser válidos a partir de %2$s."
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        "Cuánto tiempo permanece válido el cupón/suscripción después de ser activado."
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        "Si lo activás el %1$s con una duración de 30 días, sigue siendo válido hasta el %2$s."
      ],
      "Validity Granularity": [
        "Granularidad de validez"
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        "Redondea la validez a una unidad de tiempo específica (como día, hora, minuto)."
      ],
      " If set to ": [
        " Si se establece en \"1 día\", un pase de 30 días comprado el %1$s es válido hasta el final del %2$s, no exactamente a la misma hora en que fue comprado."
      ],
      "Token Families": [
        "Familias de tokens"
      ],
      "Add token family": [
        "Agregar familia de tokens"
      ],
      "Valid Before": [
        "Válido antes de"
      ],
      "Go to token family update page": [
        "Ir a la página de actualización de la familia de tokens"
      ],
      "Remove this token family from the database": [
        "Eliminar esta familia de tokens de la base de datos"
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        "Aún no hay familias de tokens, agregá la primera presionando el signo +."
      ],
      "Token family has been deleted.": [
        "La familia de tokens fue eliminada."
      ],
      "Delete token family": [
        "Eliminar familia de tokens"
      ],
      "Delete the token family \"%1$s\"": [
        "Eliminar la familia de tokens \"%1$s\""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        "Si eliminás la familia de tokens %1$s (Slug: %2$s), todos los tokens emitidos dejarán de ser válidos."
      ],
      "Deleting a token family %1$s .": [
        "Eliminando la familia de tokens %1$s."
      ],
      "can't be undone": [
        "no puede deshacerse"
      ],
      "Token Family: %1$s": [
        "Familia de tokens: %1$s"
      ],
      "User-readable token family name": [
        "Nombre de la familia de tokens legible por el usuario"
      ],
      "Token family description for customers": [
        "Descripción de la familia de tokens para los clientes"
      ],
      "Incoming wire transfers": [
        "Transferencias bancarias entrantes"
      ],
      "Load more wire transfers preceding the first one": [
        "Cargar más transferencias bancarias antes de la primera"
      ],
      "Expected credit": [
        "Crédito esperado"
      ],
      "Confirmed": [
        "Confirmado"
      ],
      "Validated": [
        "Validado"
      ],
      "Executed on": [
        "Ejecutado el"
      ],
      "yes": [
        "sí"
      ],
      "no": [
        "no"
      ],
      "never": [
        "nunca"
      ],
      "unknown": [
        "desconocido"
      ],
      "Load more transfers after the last one": [
        "Cargar más transferencias después de la última"
      ],
      "Verified wire transfers": [
        "Transferencias bancarias verificadas"
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        "Aún no hay transferencias, agregá más presionando el signo +"
      ],
      "All accounts": [
        "Todas las cuentas"
      ],
      "Filter by account address": [
        "Filtrar por dirección de cuenta"
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        "Mostrar solo las transferencias que el proveedor de servicios de pago ya acreditó en tu cuenta bancaria."
      ],
      "Only show wire transfers confirmed by the merchant": [
        "Mostrar solo las transferencias confirmadas por el comerciante"
      ],
      "Verified": [
        "Verificado"
      ],
      "Wire transfer already confirmed.": [
        "La transferencia bancaria ya fue confirmada."
      ],
      "I have received the wire transfer": [
        "Recibí la transferencia bancaria"
      ],
      "Confirm the wire transfer": [
        "Confirmar la transferencia bancaria"
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        "La transferencia bancaria fue enviada y debería acreditarse en tu cuenta en cualquier momento. Podés confirmar manualmente la recepción usando la información de abajo."
      ],
      "Time": [
        "Hora"
      ],
      "Transfer ID": [
        "ID de transferencia"
      ],
      "It's not the same.": [
        "No coincide."
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        "Estás eliminando la instancia con ID \"%1$s\""
      ],
      "Instance": [
        "Instancia"
      ],
      "Write the instance name to confirm the deletion": [
        "Escribí el nombre de la instancia para confirmar la eliminación"
      ],
      "Purge": [
        "Purgar"
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        "Todos los datos serán eliminados permanentemente; de lo contrario, solo se revocará el acceso."
      ],
      "DELETE": [
        "ELIMINAR"
      ],
      "Instance id": [
        "ID de instancia"
      ],
      "Delete this instance": [
        "Eliminar esta instancia"
      ],
      "Must be one of '%1$s'": [
        "Debe ser uno de '%1$s'"
      ],
      "URL is invalid": [
        "La URL no es válida"
      ],
      "Webhook ID to use": [
        "ID del webhook a utilizar"
      ],
      "Event": [
        "Evento"
      ],
      "Payment": [
        "Pago"
      ],
      "Order settled": [
        "Orden liquidada"
      ],
      "Category added": [
        "Categoría agregada"
      ],
      "Category updated": [
        "Categoría actualizada"
      ],
      "Inventory added": [
        "Inventario agregado"
      ],
      "Inventory updated": [
        "Inventario actualizado"
      ],
      "Inventory deleted": [
        "Inventario eliminado"
      ],
      "The event of the webhook: why the webhook is used": [
        "El evento del webhook: para qué se usa el webhook"
      ],
      "Method": [
        "Método"
      ],
      "GET": [
        "GET"
      ],
      "POST": [
        "POST"
      ],
      "PUT": [
        "PUT"
      ],
      "PATCH": [
        "PATCH"
      ],
      "HEAD": [
        "HEAD"
      ],
      "Method used by the webhook": [
        "Método utilizado por el webhook"
      ],
      "URL": [
        "URL"
      ],
      "URL of the webhook where the customer will be redirected": [
        "URL del webhook a la que se redirigirá al cliente"
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        "El texto a continuación soporta el motor de plantillas %1$s. Cualquier cadena entre %2$s y %3$s será reemplazada por el valor de la variable correspondiente."
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        "Por ejemplo, %1$s será reemplazado por el precio de la orden."
      ],
      "The short list of variables are:": [
        "La lista resumida de variables es:"
      ],
      "order's description": [
        "descripción de la orden"
      ],
      "order's price": [
        "precio de la orden"
      ],
      "order's unique identification": [
        "identificación única de la orden"
      ],
      "the amount that was being refunded": [
        "el monto que se estaba reembolsando"
      ],
      "the reason entered by the merchant staff for granting the refund": [
        "el motivo ingresado por el personal del comerciante para otorgar el reembolso"
      ],
      "time of the refund in nanoseconds since 1970": [
        "momento del reembolso en nanosegundos desde 1970"
      ],
      "Http header": [
        "Cabecera HTTP"
      ],
      "Header template of the webhook": [
        "Plantilla de cabecera del webhook"
      ],
      "Http body": [
        "Cuerpo HTTP"
      ],
      "Body template used by the webhook.": [
        "Plantilla de cuerpo utilizada por el webhook."
      ],
      "Webhook deleted successfully": [
        "Webhook eliminado correctamente"
      ],
      "Add new webhooks": [
        "Agregar nuevos webhooks"
      ],
      "Load more webhooks before the first one": [
        "Cargar más webhooks antes del primero"
      ],
      "Event type": [
        "Tipo de evento"
      ],
      "Delete selected webhook from the database": [
        "Eliminar el webhook seleccionado de la base de datos"
      ],
      "Load more webhooks after the last one": [
        "Cargar más webhooks después del último"
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        "Aún no hay webhooks, agregá más presionando el signo +"
      ],
      "Webhook updated": [
        "Webhook actualizado"
      ],
      "Header": [
        "Cabecera"
      ],
      "Body": [
        "Cuerpo"
      ],
      "Body template used by the webhook": [
        "Plantilla de cuerpo utilizada por el webhook"
      ],
      "There is another instance with this username.": [
        "Ya existe otra instancia con este nombre de usuario."
      ],
      "Self provision": [
        "Autogestión"
      ],
      "Phone": [
        "Teléfono"
      ],
      "Contact phone number": [
        "Número de teléfono de contacto"
      ],
      "Accept the Terms of service": [
        "Aceptar los Términos del servicio"
      ],
      "I understand and agree to the %1$s": [
        "Entiendo y acepto los %1$s"
      ],
      "Terms of service": [
        "Términos del servicio"
      ],
      "You must accept the Terms of service to continue.": [
        "Debés aceptar los Términos del servicio para continuar."
      ],
      "Create": [
        "Crear"
      ],
      "The instance is not properly configured to allow MFA.": [
        "La instancia no está correctamente configurada para permitir MFA."
      ],
      "The instance \"%1$s\" was not found.": [
        "La instancia \"%1$s\" no fue encontrada."
      ],
      "Resetting access to the instance \"%1$s\"": [
        "Restableciendo el acceso a la instancia \"%1$s\""
      ],
      "Reset": [
        "Restablecer"
      ],
      "Language": [
        "Idioma"
      ],
      "Date format": [
        "Formato de fecha"
      ],
      "How the date is going to be displayed": [
        "Cómo se mostrará la fecha"
      ],
      "Merchant type": [
        "Tipo de comerciante"
      ],
      "Simplify UI based on the user usage.": [
        "Simplificar la interfaz según el uso del usuario."
      ],
      "Expert user": [
        "Usuario experto"
      ],
      "Taler developer": [
        "Desarrollador de Taler"
      ],
      "Unattended in-person offline vending": [
        "Venta presencial desatendida sin conexión"
      ],
      "In-person online point-of-sale with inventory": [
        "Punto de venta presencial en línea con inventario"
      ],
      "Digital publishing": [
        "Publicación digital"
      ],
      "E-commerce site": [
        "Sitio de comercio electrónico"
      ],
      "Developer mode": [
        "Modo desarrollador"
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        "Usá el modo desarrollador solo si conocés el funcionamiento de la aplicación. Algunas funciones habilitadas en este modo aún están en fase de pruebas."
      ],
      "Money pot deleted": [
        "Fondo eliminado"
      ],
      "Add new pots": [
        "Agregar nuevos fondos"
      ],
      "Load more pots before the first one": [
        "Cargar más fondos antes del primero"
      ],
      "Total": [
        "Total"
      ],
      "Delete selected pots from the database": [
        "Eliminar los fondos seleccionados de la base de datos"
      ],
      "Load more pots after the last one": [
        "Cargar más fondos después del último"
      ],
      "There are no money pots yet, add more pressing the + sign": [
        "Aún no hay fondos, agregá más presionando el signo +"
      ],
      "Missing currency name": [
        "Falta el nombre de la moneda"
      ],
      "Currency name must be only letters": [
        "El nombre de la moneda debe contener solo letras"
      ],
      "Value can only by number": [
        "El valor solo puede ser numérico"
      ],
      "The value is too high": [
        "El valor es demasiado alto"
      ],
      "The value is too precise": [
        "El valor tiene demasiada precisión decimal"
      ],
      "Invalid amount \"%1$s\": %2$s": [
        "Monto no válido \"%1$s\": %2$s"
      ],
      "Descripton": [
        "Descripción"
      ],
      "Totals": [
        "Totales"
      ],
      "There is already a money pot with the same id.": [
        "Ya existe un fondo con el mismo ID."
      ],
      "Product group deleted": [
        "Grupo de productos eliminado"
      ],
      "Add new group": [
        "Agregar nuevo grupo"
      ],
      "Load more groups before the first one": [
        "Cargar más grupos antes del primero"
      ],
      "Delete selected group from the database": [
        "Eliminar el grupo seleccionado de la base de datos"
      ],
      "Load more groups after the last one": [
        "Cargar más grupos después del último"
      ],
      "There are no product groups yet, add more pressing the + sign": [
        "Aún no hay grupos de productos, agregá más presionando el signo +"
      ],
      "Scheduled report deleted": [
        "Informe programado eliminado"
      ],
      "Scheduled reports": [
        "Informes programados"
      ],
      "Add new reports": [
        "Agregar nuevos informes"
      ],
      "Frequency": [
        "Frecuencia"
      ],
      "Delete selected scheduled report from the database": [
        "Eliminar el informe programado seleccionado de la base de datos"
      ],
      "There are no reports yet, add more pressing the + sign": [
        "Aún no hay informes, agregá más presionando el signo +"
      ],
      "No report generator configured in the server": [
        "No hay ningún generador de informes configurado en el servidor"
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        "Contactá al administrador del sistema para crear un generador de informes antes de programar uno."
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=n != 1;",
  "lang": "es",
  "completeness": 100
};

strings['en'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=(n != 1);",
        "lang": "en"
      },
      "Cancel": [
        ""
      ],
      "%1$s": [
        ""
      ],
      "Close": [
        ""
      ],
      "Continue": [
        ""
      ],
      "Clear": [
        ""
      ],
      "Confirm": [
        ""
      ],
      "Correct form": [
        ""
      ],
      "Comparing account details": [
        ""
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        ""
      ],
      "Field": [
        ""
      ],
      "In the form": [
        ""
      ],
      "Reported": [
        ""
      ],
      "Type": [
        ""
      ],
      "IBAN": [
        ""
      ],
      "Address": [
        ""
      ],
      "Host": [
        ""
      ],
      "Account ID": [
        ""
      ],
      "The account owner's legal name": [
        ""
      ],
      "The postal code of the account owner's address": [
        ""
      ],
      "Town": [
        ""
      ],
      "Bank host": [
        ""
      ],
      "Bank account": [
        ""
      ],
      "BIC": [
        ""
      ],
      "OK": [
        ""
      ],
      "Validate bank account: %1$s": [
        ""
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        ""
      ],
      "Step 1:": [
        ""
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        ""
      ],
      "Beneficiary": [
        ""
      ],
      "Step 2:": [
        ""
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        ""
      ],
      "Subject": [
        ""
      ],
      "Receiver postal code": [
        ""
      ],
      "Receiver town": [
        ""
      ],
      "Step 3:": [
        ""
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        ""
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        ""
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        ""
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        ""
      ],
      "Operation in progress...": [
        ""
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        ""
      ],
      "days": [
        ""
      ],
      "hours": [
        ""
      ],
      "minutes": [
        ""
      ],
      "seconds": [
        ""
      ],
      "Forever": [
        ""
      ],
      "%1$sM": [
        ""
      ],
      "%1$sY": [
        ""
      ],
      "%1$sd": [
        ""
      ],
      "%1$sh": [
        ""
      ],
      "%1$smin": [
        ""
      ],
      "%1$ssec": [
        ""
      ],
      "Change value to never": [
        ""
      ],
      "Change value to empty": [
        ""
      ],
      "Image must be smaller than 1 MB": [
        ""
      ],
      "Add": [
        ""
      ],
      "Remove": [
        ""
      ],
      "Country": [
        ""
      ],
      "Building number": [
        ""
      ],
      "Building name": [
        ""
      ],
      "Street": [
        ""
      ],
      "Post code": [
        ""
      ],
      "Town location": [
        ""
      ],
      "District": [
        ""
      ],
      "Country subdivision": [
        ""
      ],
      "Additional address lines": [
        ""
      ],
      "Orders": [
        ""
      ],
      "Inventory": [
        ""
      ],
      "Categories": [
        ""
      ],
      "Wire transfers": [
        ""
      ],
      "Templates": [
        ""
      ],
      "Product groups": [
        ""
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        ""
      ],
      "Statistics": [
        ""
      ],
      "Subscriptions and Discounts": [
        ""
      ],
      "Configuration": [
        ""
      ],
      "OTP Devices": [
        ""
      ],
      "Webhooks": [
        ""
      ],
      "Settings": [
        ""
      ],
      "Password": [
        ""
      ],
      "Access tokens": [
        ""
      ],
      "Connection": [
        ""
      ],
      "Personalization": [
        ""
      ],
      "Instances": [
        ""
      ],
      "New": [
        ""
      ],
      "List": [
        ""
      ],
      "Log out": [
        ""
      ],
      "Username": [
        ""
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        ""
      ],
      "Business name": [
        ""
      ],
      "Legal name of the business represented by this instance.": [
        ""
      ],
      "Email": [
        ""
      ],
      "Contact email": [
        ""
      ],
      "Phone number": [
        ""
      ],
      "Contact phone": [
        ""
      ],
      "Website URL": [
        ""
      ],
      "URL.": [
        ""
      ],
      "Logo": [
        ""
      ],
      "Logo image.": [
        ""
      ],
      "Pay transaction fee": [
        ""
      ],
      "Cover the transaction cost or pass it on to the user.": [
        ""
      ],
      "Physical location of the merchant.": [
        ""
      ],
      "Jurisdiction": [
        ""
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        ""
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        ""
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        ""
      ],
      "Refund delay": [
        ""
      ],
      "Time merchants have to refund an order.": [
        ""
      ],
      "Wire transfer delay": [
        ""
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        ""
      ],
      "Wire transfer rounding": [
        ""
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        ""
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        ""
      ],
      "No rounding": [
        ""
      ],
      "To second": [
        ""
      ],
      "To minute": [
        ""
      ],
      "To hour": [
        ""
      ],
      "To day": [
        ""
      ],
      "To week": [
        ""
      ],
      "To month": [
        ""
      ],
      "To quarter": [
        ""
      ],
      "To year": [
        ""
      ],
      "Expired": [
        ""
      ],
      "Required": [
        ""
      ],
      "Unauthorized": [
        ""
      ],
      "The code is not correct.": [
        ""
      ],
      "The challenge is not known anymore.": [
        ""
      ],
      "Too many attempts trying to solve the challenge.": [
        ""
      ],
      "Validation code sent.": [
        ""
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        ""
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        ""
      ],
      "Verification code": [
        ""
      ],
      "It will expire at %1$s": [
        ""
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        ""
      ],
      "Back": [
        ""
      ],
      "Verify": [
        ""
      ],
      "Failed to send the verification code.": [
        ""
      ],
      "The request was valid, but the server is refusing action.": [
        ""
      ],
      "The backend is not aware of the specified MFA challenge.": [
        ""
      ],
      "Code transmission failed.": [
        ""
      ],
      "Already solved.": [
        ""
      ],
      "It is too early to request another transmission of the challenge.": [
        ""
      ],
      "Multi-factor authentication required.": [
        ""
      ],
      "You need to complete all of this requirements.": [
        ""
      ],
      "You need to complete at least one of this requirements.": [
        ""
      ],
      "An SMS to the phone number ending with %1$s": [
        ""
      ],
      "An email to the address starting with %1$s": [
        ""
      ],
      "You have to wait until %1$s to send a new code.": [
        ""
      ],
      "I have a code": [
        ""
      ],
      "Send me a message": [
        ""
      ],
      "Logged in": [
        ""
      ],
      "Not found": [
        ""
      ],
      "Login required": [
        ""
      ],
      "Instance name.": [
        ""
      ],
      "Instance password.": [
        ""
      ],
      "Forgot password": [
        ""
      ],
      "Create new account": [
        ""
      ],
      "Invalid": [
        ""
      ],
      "Doesn't have the pattern of an email": [
        ""
      ],
      "Should start with +": [
        ""
      ],
      "A phone number consists of numbers only": [
        ""
      ],
      "Invalid value": [
        ""
      ],
      "Max 7 lines": [
        ""
      ],
      "Doesn't match": [
        ""
      ],
      "Instance created": [
        ""
      ],
      "Unauthorized.": [
        ""
      ],
      "Conflict.": [
        ""
      ],
      "Not found.": [
        ""
      ],
      "New password": [
        ""
      ],
      "Next password to be used": [
        ""
      ],
      "Repeat password": [
        ""
      ],
      "Confirm the same password": [
        ""
      ],
      "Please complete the marked fields and choose authorization method": [
        ""
      ],
      "Confirm operation": [
        ""
      ],
      "Check the password.": [
        ""
      ],
      "Instance not found.": [
        ""
      ],
      "Description": [
        ""
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        ""
      ],
      "Duration": [
        ""
      ],
      "Time the access token will be valid.": [
        ""
      ],
      "Refreshable access tokens can pose a security risk!": [
        ""
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        ""
      ],
      "Scope": [
        ""
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        ""
      ],
      "Allows all operations without limit.": [
        ""
      ],
      "Allows all operations to read information.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        ""
      ],
      "Allows all operations to read information with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        ""
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        ""
      ],
      "All (refreshable)": [
        ""
      ],
      "Spa": [
        ""
      ],
      "Spa (refreshable)": [
        ""
      ],
      "Choose one": [
        ""
      ],
      "Read only": [
        ""
      ],
      "All": [
        ""
      ],
      "Order simple": [
        ""
      ],
      "Order Point-of-Sale": [
        ""
      ],
      "Order management": [
        ""
      ],
      "Order full": [
        ""
      ],
      "Read only (refreshable)": [
        ""
      ],
      "Order simple (refreshable)": [
        ""
      ],
      "Order Point-of-Sale (refreshable)": [
        ""
      ],
      "Order management (refreshable)": [
        ""
      ],
      "Order full (refreshable)": [
        ""
      ],
      "Current password": [
        ""
      ],
      "Please complete the marked fields": [
        ""
      ],
      "Access token created": [
        ""
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        ""
      ],
      "Token": [
        ""
      ],
      "This token will never expire": [
        ""
      ],
      "This token will be available until %1$s": [
        ""
      ],
      "No 'admin' instance configured yet.": [
        ""
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        ""
      ],
      "Create access token": [
        ""
      ],
      "Load more devices before the first one": [
        ""
      ],
      "Load first page": [
        ""
      ],
      "Created at": [
        ""
      ],
      "Expires at": [
        ""
      ],
      "Never": [
        ""
      ],
      "Remove this access token": [
        ""
      ],
      "Delete": [
        ""
      ],
      "Load more devices after the last one": [
        ""
      ],
      "Load next page": [
        ""
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        ""
      ],
      "Forbidden.": [
        ""
      ],
      "Delete access token": [
        ""
      ],
      "Deleting an access token cannot be undone.": [
        ""
      ],
      "This is not a valid Bitcoin address.": [
        ""
      ],
      "This is not a valid Ethereum address.": [
        ""
      ],
      "This is not a valid host.": [
        ""
      ],
      "IBANs usually have more than 4 digits.": [
        ""
      ],
      "IBANs usually have fewer than 34 digits.": [
        ""
      ],
      "The IBAN's country code could not be retrieved.": [
        ""
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        ""
      ],
      "This account is not allowed.": [
        ""
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        ""
      ],
      "Wire method": [
        ""
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        ""
      ],
      "Select a wire method...": [
        ""
      ],
      "Routing": [
        ""
      ],
      "Routing number": [
        ""
      ],
      "Account": [
        ""
      ],
      "Account number": [
        ""
      ],
      "Code": [
        ""
      ],
      "Business Identifier Code": [
        ""
      ],
      "International Bank Account Number": [
        ""
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        ""
      ],
      "Unified Payment Interface": [
        ""
      ],
      "Bitcoin protocol": [
        ""
      ],
      "Ethereum protocol": [
        ""
      ],
      "Interledger protocol": [
        ""
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        ""
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        ""
      ],
      "Name of the account holder": [
        ""
      ],
      "John Doe": [
        ""
      ],
      "Legal name of the person holding the account.": [
        ""
      ],
      "Invalid url": [
        ""
      ],
      "URL must end with a '/'": [
        ""
      ],
      "URL must not contain params": [
        ""
      ],
      "URL must not hash param": [
        ""
      ],
      "Conflict": [
        ""
      ],
      "Server replied with \"bad request\".": [
        ""
      ],
      "Unauthorized, check credentials.": [
        ""
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        ""
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        ""
      ],
      "Unsupported type of account": [
        ""
      ],
      "Account:": [
        ""
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        ""
      ],
      "Endpoint URL": [
        ""
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        ""
      ],
      "Auth type": [
        ""
      ],
      "Choose the authentication type for the account info URL": [
        ""
      ],
      "Without authentication": [
        ""
      ],
      "With username and password": [
        ""
      ],
      "With token": [
        ""
      ],
      "Do not change": [
        ""
      ],
      "Username to access the account information.": [
        ""
      ],
      "Password to access the account information.": [
        ""
      ],
      "Access token to access the account information.": [
        ""
      ],
      "Match": [
        ""
      ],
      "Check where the information match against the server info.": [
        ""
      ],
      "Compare info from server with account form": [
        ""
      ],
      "Test": [
        ""
      ],
      "Server didn't like the request we made.": [
        ""
      ],
      "Account details": [
        ""
      ],
      "Check if the information matches the server info.": [
        ""
      ],
      "The bank account has been deleted.": [
        ""
      ],
      "Delete account": [
        ""
      ],
      "Delete the account \"%1$s\"": [
        ""
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        ""
      ],
      "Deleting an account can't be undone.": [
        ""
      ],
      "Bank accounts": [
        ""
      ],
      "Add new account": [
        ""
      ],
      "Owner's name": [
        ""
      ],
      "Delete selected accounts from the database": [
        ""
      ],
      "There are no accounts yet, add more pressing the + sign": [
        ""
      ],
      "You must provide a bank account to receive payments.": [
        ""
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        ""
      ],
      "Invalid. Please use only letters and numbers.": [
        ""
      ],
      "Name": [
        ""
      ],
      "Category name": [
        ""
      ],
      "Category deleted": [
        ""
      ],
      "Add new devices": [
        ""
      ],
      "ID": [
        ""
      ],
      "Total products": [
        ""
      ],
      "Delete selected category from the database": [
        ""
      ],
      "There are no categories yet, add more pressing the + sign": [
        ""
      ],
      "Id:": [
        ""
      ],
      "Name of the category": [
        ""
      ],
      "Products": [
        ""
      ],
      "Image": [
        ""
      ],
      "Load more products after the last one": [
        ""
      ],
      "There are no products in this category.": [
        ""
      ],
      "Account's KYC status": [
        ""
      ],
      "Exchange": [
        ""
      ],
      "Status": [
        ""
      ],
      "Ok": [
        ""
      ],
      "Action required": [
        ""
      ],
      "Warning": [
        ""
      ],
      "Error": [
        ""
      ],
      "Bank account verification required.": [
        ""
      ],
      "More information required.": [
        ""
      ],
      "Awaiting for account review.": [
        ""
      ],
      "Ready": [
        ""
      ],
      "Syncing...": [
        ""
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        ""
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        ""
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        ""
      ],
      "Incompatible core banking system.": [
        ""
      ],
      "Backend internal error. Contact administrator or check again later.": [
        ""
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        ""
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        ""
      ],
      "The account for wire transfers does not appear to be valid": [
        ""
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        ""
      ],
      "No exchange keys": [
        ""
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        ""
      ],
      "No transfers can be made from this account": [
        ""
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        ""
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        ""
      ],
      "Click here to complete this step.": [
        ""
      ],
      "We are waiting for the access token to be present. Check again later.": [
        ""
      ],
      "Awaiting AML review": [
        ""
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        ""
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        ""
      ],
      "Logic bug": [
        ""
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "Internal error": [
        ""
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        ""
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        ""
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        ""
      ],
      "Unsupported account": [
        ""
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        ""
      ],
      "Change value to unknown date": [
        ""
      ],
      "Enter description or id": [
        ""
      ],
      "No match found for that description or ID.": [
        ""
      ],
      "You must enter a valid product identifier.": [
        ""
      ],
      "Quantity must be greater than 0!": [
        ""
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        ""
      ],
      "Search product": [
        ""
      ],
      "Quantity": [
        ""
      ],
      "How many products will be added": [
        ""
      ],
      "Add from inventory": [
        ""
      ],
      "This product has %1$s applicable taxes configured.": [
        ""
      ],
      "No taxes configured for this product.": [
        ""
      ],
      "Amount": [
        ""
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        ""
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        ""
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        ""
      ],
      "Add tax to the tax list": [
        ""
      ],
      "Describe and add a product that is not in the inventory list": [
        ""
      ],
      "Add custom product": [
        ""
      ],
      "Complete information of the product": [
        ""
      ],
      "Must be a number.": [
        ""
      ],
      "Must be greater than 0.": [
        ""
      ],
      "Photo of the product.": [
        ""
      ],
      "Full product description.": [
        ""
      ],
      "Unit name": [
        ""
      ],
      "Name of the product unit.": [
        ""
      ],
      "Price per unit": [
        ""
      ],
      "Amount in the current currency.": [
        ""
      ],
      "How many products will be added.": [
        ""
      ],
      "Taxes": [
        ""
      ],
      "Total price": [
        ""
      ],
      "Must be greater than 0": [
        ""
      ],
      "Must have a refund deadline": [
        ""
      ],
      "Auto refund can't be after refund deadline": [
        ""
      ],
      "Must be in the future": [
        ""
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        ""
      ],
      "is not a valid URL": [
        ""
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        ""
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        ""
      ],
      "Manage products in order": [
        ""
      ],
      "%1$s products with a total price of %2$s.": [
        ""
      ],
      "Manage list of products in the order.": [
        ""
      ],
      "Remove this product from the order.": [
        ""
      ],
      "Products price sum": [
        ""
      ],
      "Total product price added up": [
        ""
      ],
      "Order price": [
        ""
      ],
      "Amount to be paid by the customer": [
        ""
      ],
      "Final order price": [
        ""
      ],
      "Summary": [
        ""
      ],
      "Title of the order to be shown to the customer": [
        ""
      ],
      "Shipping and fulfillment": [
        ""
      ],
      "Delivery date": [
        ""
      ],
      "Deadline for physical delivery assured by the merchant.": [
        ""
      ],
      "Delivery location": [
        ""
      ],
      "Address where the products will be delivered": [
        ""
      ],
      "Fulfillment URL": [
        ""
      ],
      "URL to which the user will be redirected after successful payment.": [
        ""
      ],
      "Fulfillment message": [
        ""
      ],
      "Message shown to the customer after paying for the order.": [
        ""
      ],
      "Taler payment options": [
        ""
      ],
      "Override default Taler payment settings for this order": [
        ""
      ],
      "Payment time": [
        ""
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        ""
      ],
      "Default": [
        ""
      ],
      "Refund time": [
        ""
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        ""
      ],
      "Wire transfer time": [
        ""
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        ""
      ],
      "Auto-refund time": [
        ""
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        ""
      ],
      "Maximum fee": [
        ""
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        ""
      ],
      "Create token": [
        ""
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        ""
      ],
      "Minimum age required": [
        ""
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        ""
      ],
      "Minimum age defined by the products is %1$s": [
        ""
      ],
      "No product with age restriction in this order": [
        ""
      ],
      "Additional information": [
        ""
      ],
      "Custom information to be included in the contract for this order.": [
        ""
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        ""
      ],
      "remove": [
        ""
      ],
      "Custom field name": [
        ""
      ],
      "Disabled": [
        ""
      ],
      "No deadline": [
        ""
      ],
      "Deadline at %1$s": [
        ""
      ],
      "Select date to show nearby orders": [
        ""
      ],
      "Only show unpaid orders": [
        ""
      ],
      "Only show paid orders": [
        ""
      ],
      "Paid": [
        ""
      ],
      "Only show orders with refunds": [
        ""
      ],
      "Refunded": [
        ""
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        ""
      ],
      "Not wired": [
        ""
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        ""
      ],
      "Completed": [
        ""
      ],
      "Remove all filters": [
        ""
      ],
      "Clear date filter": [
        ""
      ],
      "Jump to date (%1$s)": [
        ""
      ],
      "Gone.": [
        ""
      ],
      "UnavailableForLegalReasons.": [
        ""
      ],
      "Jump to order with the given product ID": [
        ""
      ],
      "Order id": [
        ""
      ],
      "Instance unknown": [
        ""
      ],
      "Order unknown": [
        ""
      ],
      "Create order": [
        ""
      ],
      "The instance doesn't exist": [
        ""
      ],
      "The order doesn't exist": [
        ""
      ],
      "Date": [
        ""
      ],
      "Refund": [
        ""
      ],
      "copy url": [
        ""
      ],
      "Load more orders after the last one": [
        ""
      ],
      "No orders have been found matching your query!": [
        ""
      ],
      "Duplicated": [
        ""
      ],
      "This value exceeds the refundable amount.": [
        ""
      ],
      "Forbidden": [
        ""
      ],
      "Gone": [
        ""
      ],
      "There are pending KYC requirements.": [
        ""
      ],
      "refund": [
        ""
      ],
      "Reason": [
        ""
      ],
      "Amount to be refunded": [
        ""
      ],
      "Max refundable:": [
        ""
      ],
      "Choose one...": [
        ""
      ],
      "Requested by the customer": [
        ""
      ],
      "Other": [
        ""
      ],
      "Why this order is being refunded": [
        ""
      ],
      "More information to give context": [
        ""
      ],
      "now": [
        ""
      ],
      "This is when the time for making refund has been expired.": [
        ""
      ],
      "This is when the time for making the payment has been expired.": [
        ""
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        ""
      ],
      "This wire transfer has been notified by the payment service provider.": [
        ""
      ],
      "This refund is waiting to be claimed by the customer.": [
        ""
      ],
      "This refund has been claimed by the customer.": [
        ""
      ],
      "The current moment in time.": [
        ""
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        ""
      ],
      "Contract terms": [
        ""
      ],
      "Human-readable description of the whole purchase": [
        ""
      ],
      "Total price for the transaction": [
        ""
      ],
      "URL for this purchase": [
        ""
      ],
      "Max fee": [
        ""
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        ""
      ],
      "Time when this contract was generated": [
        ""
      ],
      "Payment deadline": [
        ""
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        ""
      ],
      "Refund deadline": [
        ""
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        ""
      ],
      "Wire transfer deadline": [
        ""
      ],
      "Transfer deadline for the exchange": [
        ""
      ],
      "Time indicating when the order should be delivered": [
        ""
      ],
      "Where the order will be delivered": [
        ""
      ],
      "Auto-refund delay": [
        ""
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        ""
      ],
      "Extra info": [
        ""
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        ""
      ],
      "order created": [
        ""
      ],
      "pay deadline": [
        ""
      ],
      "refund deadline": [
        ""
      ],
      "delivery": [
        ""
      ],
      "Order": [
        ""
      ],
      "Claimed": [
        ""
      ],
      "Claimed at": [
        ""
      ],
      "Timeline": [
        ""
      ],
      "Payment details": [
        ""
      ],
      "Order status": [
        ""
      ],
      "Unpaid": [
        ""
      ],
      "Product list": [
        ""
      ],
      "refund missed: %1$s": [
        ""
      ],
      "refund missed: %1$s: %2$s": [
        ""
      ],
      "refund created: %1$s": [
        ""
      ],
      "refund created: %1$s: %2$s": [
        ""
      ],
      "refund taken: %1$s": [
        ""
      ],
      "refund taken: %1$s: %2$s": [
        ""
      ],
      "The contract terms has a v1 order without choices_index.": [
        ""
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        ""
      ],
      "wired %1$s": [
        ""
      ],
      "wire deadline": [
        ""
      ],
      "Wired": [
        ""
      ],
      "Refund order": [
        ""
      ],
      "Not refundable": [
        ""
      ],
      "Next event in": [
        ""
      ],
      "The order was wired.": [
        ""
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        ""
      ],
      "Refunded amount": [
        ""
      ],
      "Refund taken": [
        ""
      ],
      "Status URL": [
        ""
      ],
      "Refund URI": [
        ""
      ],
      "Pay at": [
        ""
      ],
      "Order status URL": [
        ""
      ],
      "Payment URI": [
        ""
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        ""
      ],
      "Invalid. Please enter letters and numbers only.": [
        ""
      ],
      "Just letters and numbers from 2 to 7": [
        ""
      ],
      "The size of the key must be 32 characters": [
        ""
      ],
      "Internal ID on the system": [
        ""
      ],
      "Useful to identify the device physically": [
        ""
      ],
      "Verification algorithm": [
        ""
      ],
      "Algorithm used to verify transactions in offline mode": [
        ""
      ],
      "Device key": [
        ""
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        ""
      ],
      "Your device needs to match exactly the same value": [
        ""
      ],
      "Generate random secret key": [
        ""
      ],
      "Random": [
        ""
      ],
      "Create another": [
        ""
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        ""
      ],
      "OTP devices": [
        ""
      ],
      "Delete selected devices from the database": [
        ""
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        ""
      ],
      "Template id is unknown": [
        ""
      ],
      "The provided information is inconsistent with the current state of the template": [
        ""
      ],
      "Device:": [
        ""
      ],
      "Algorithm to use to verify transactions in offline mode": [
        ""
      ],
      "Not modified": [
        ""
      ],
      "Be sure to be very hard to guess or use the random generator": [
        ""
      ],
      "Your device need to have exactly the same value": [
        ""
      ],
      "Change key": [
        ""
      ],
      "Is not the same": [
        ""
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        ""
      ],
      "In order to verify that you have access.": [
        ""
      ],
      "Confirm change": [
        ""
      ],
      "Testing password change": [
        ""
      ],
      "Password changed": [
        ""
      ],
      "The current password is wrong.": [
        ""
      ],
      "No enough rights to change the password.": [
        ""
      ],
      "Account not found.": [
        ""
      ],
      "Add element to the list": [
        ""
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        ""
      ],
      "Manage stock": [
        ""
      ],
      "This product has been configured without stock control": [
        ""
      ],
      "Infinite": [
        ""
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        ""
      ],
      "Incoming": [
        ""
      ],
      "Lost": [
        ""
      ],
      "Current": [
        ""
      ],
      "Remove stock control for this product": [
        ""
      ],
      "without stock": [
        ""
      ],
      "Next restock": [
        ""
      ],
      "Warehouse address": [
        ""
      ],
      "Invalid amount": [
        ""
      ],
      "Product identification to use in URLs (for internal use only).": [
        ""
      ],
      "Illustration of the product for customers.": [
        ""
      ],
      "Product name.": [
        ""
      ],
      "Product description for customers.": [
        ""
      ],
      "Age restriction": [
        ""
      ],
      "Is this product restricted for customer below certain age?": [
        ""
      ],
      "Minimum age of the customer": [
        ""
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        ""
      ],
      "Example: kg, items or liters": [
        ""
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        ""
      ],
      "Stock": [
        ""
      ],
      "Inventory for products with finite supply (for internal use only).": [
        ""
      ],
      "Taxes included in the product price, exposed to customers.": [
        ""
      ],
      "Search by category description or id": [
        ""
      ],
      "Categories where this product will be listed on.": [
        ""
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        ""
      ],
      "Money pots where this product will be listed on.": [
        ""
      ],
      "Select one": [
        ""
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        ""
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        ""
      ],
      "Product not found.": [
        ""
      ],
      "This change was made without outdated info.": [
        ""
      ],
      "Sales": [
        ""
      ],
      "Sold": [
        ""
      ],
      "Free": [
        ""
      ],
      "Go to product update page": [
        ""
      ],
      "Update": [
        ""
      ],
      "Remove this product from the database": [
        ""
      ],
      "Update the product with new price": [
        ""
      ],
      "Update product with new price": [
        ""
      ],
      "Confirm update": [
        ""
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        ""
      ],
      "Add more elements to the inventory": [
        ""
      ],
      "Report elements lost in the inventory": [
        ""
      ],
      "New price for the product": [
        ""
      ],
      "There are values with errors.": [
        ""
      ],
      "Update product with new stock and price": [
        ""
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        ""
      ],
      "Product (ID: %1$s) has been deleted": [
        ""
      ],
      "Jump to product with the given product ID": [
        ""
      ],
      "Product id": [
        ""
      ],
      "Delete product": [
        ""
      ],
      "Delete the product \"%1$s\"": [
        ""
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        ""
      ],
      "Deleting a product cannot be undone.": [
        ""
      ],
      "Product id:": [
        ""
      ],
      "Your browser does not support the canvas element.": [
        ""
      ],
      "Bad gateway": [
        ""
      ],
      "Service unavailable": [
        ""
      ],
      "Select date from which to show statistics": [
        ""
      ],
      "Show chart": [
        ""
      ],
      "Orders chart": [
        ""
      ],
      "Show table": [
        ""
      ],
      "Orders table": [
        ""
      ],
      "Start from (%1$s)": [
        ""
      ],
      "Orders statistics": [
        ""
      ],
      "Since": [
        ""
      ],
      "No order statistics yet.": [
        ""
      ],
      "# of orders since": [
        ""
      ],
      "hour": [
        ""
      ],
      "day": [
        ""
      ],
      "week": [
        ""
      ],
      "weeks": [
        ""
      ],
      "month": [
        ""
      ],
      "months": [
        ""
      ],
      "quarter": [
        ""
      ],
      "quarters": [
        ""
      ],
      "years": [
        ""
      ],
      "Revenue chart": [
        ""
      ],
      "Revenue table": [
        ""
      ],
      "Revenue statistics filter": [
        ""
      ],
      "Time range": [
        ""
      ],
      "Select time range to group dataset by": [
        ""
      ],
      "Select the number of ranges to include in data set": [
        ""
      ],
      "Currency": [
        ""
      ],
      "Select the currency to show statistics for": [
        ""
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        ""
      ],
      "Start time": [
        ""
      ],
      "No revenue statistics yet.": [
        ""
      ],
      "Revenue": [
        ""
      ],
      "Must be greater that 0": [
        ""
      ],
      "Too short": [
        ""
      ],
      "You don't have enough permissions.": [
        ""
      ],
      "There is a template with this identifier, please choose another one.": [
        ""
      ],
      "Identifier": [
        ""
      ],
      "Name of the template in URLs.": [
        ""
      ],
      "Template name": [
        ""
      ],
      "Describe what this template stands for": [
        ""
      ],
      "Order summary": [
        ""
      ],
      "If specified here, this template will create orders with the same summary": [
        ""
      ],
      "Summary is editable": [
        ""
      ],
      "Allow the user to change the summary.": [
        ""
      ],
      "If specified here, this template will create orders with the same price": [
        ""
      ],
      "Amount is editable": [
        ""
      ],
      "Allow the user to select the amount to pay.": [
        ""
      ],
      "Currency is editable": [
        ""
      ],
      "Allow the user to change currency.": [
        ""
      ],
      "Supported currencies": [
        ""
      ],
      "Supported currencies: %1$s": [
        ""
      ],
      "Minimum age": [
        ""
      ],
      "Is this contract restricted to some age?": [
        ""
      ],
      "Payment timeout": [
        ""
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        ""
      ],
      "OTP device": [
        ""
      ],
      "Use to verify transactions in offline mode.": [
        ""
      ],
      "No OTP device.": [
        ""
      ],
      "Add one first": [
        ""
      ],
      "No device": [
        ""
      ],
      "Add new templates": [
        ""
      ],
      "Load more templates before the first one": [
        ""
      ],
      "Delete selected templates from the database": [
        ""
      ],
      "Use template to create new order": [
        ""
      ],
      "Generate a QR code for the template.": [
        ""
      ],
      "Show QR": [
        ""
      ],
      "Load more templates after the last one": [
        ""
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        ""
      ],
      "Jump to template with the given template ID": [
        ""
      ],
      "Template identification": [
        ""
      ],
      "Delete template": [
        ""
      ],
      "Delete the template \"%1$s\"": [
        ""
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        ""
      ],
      "Deleting a template cannot be undone.": [
        ""
      ],
      "Print": [
        ""
      ],
      "The template configuration needs to be fixed.": [
        ""
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        ""
      ],
      "If specified, this template will create order with the same summary": [
        ""
      ],
      "If specified, this template will create orders with the same price": [
        ""
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        ""
      ],
      "An amount is required": [
        ""
      ],
      "An order summary is required": [
        ""
      ],
      "No more stock for product with ID \"%1$s\".": [
        ""
      ],
      "New order from template": [
        ""
      ],
      "Amount of the order": [
        ""
      ],
      "Slug": [
        ""
      ],
      "Token family slug to use in URLs (for internal use only)": [
        ""
      ],
      "Kind": [
        ""
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        ""
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        ""
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        ""
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        ""
      ],
      "Add token family": [
        ""
      ],
      "Valid Before": [
        ""
      ],
      "Go to token family update page": [
        ""
      ],
      "Remove this token family from the database": [
        ""
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        ""
      ],
      "Token family has been deleted.": [
        ""
      ],
      "Delete token family": [
        ""
      ],
      "Delete the token family \"%1$s\"": [
        ""
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        ""
      ],
      "Deleting a token family %1$s .": [
        ""
      ],
      "can't be undone": [
        ""
      ],
      "Token Family: %1$s": [
        ""
      ],
      "User-readable token family name": [
        ""
      ],
      "Token family description for customers": [
        ""
      ],
      "Incoming wire transfers": [
        ""
      ],
      "Load more wire transfers preceding the first one": [
        ""
      ],
      "Expected credit": [
        ""
      ],
      "Confirmed": [
        ""
      ],
      "Validated": [
        ""
      ],
      "Executed on": [
        ""
      ],
      "yes": [
        ""
      ],
      "no": [
        ""
      ],
      "never": [
        ""
      ],
      "unknown": [
        ""
      ],
      "Load more transfers after the last one": [
        ""
      ],
      "Verified wire transfers": [
        ""
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        ""
      ],
      "All accounts": [
        ""
      ],
      "Filter by account address": [
        ""
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        ""
      ],
      "Only show wire transfers confirmed by the merchant": [
        ""
      ],
      "Verified": [
        ""
      ],
      "Wire transfer already confirmed.": [
        ""
      ],
      "I have received the wire transfer": [
        ""
      ],
      "Confirm the wire transfer": [
        ""
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        ""
      ],
      "Time": [
        ""
      ],
      "Transfer ID": [
        ""
      ],
      "It's not the same.": [
        ""
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        ""
      ],
      "Instance": [
        ""
      ],
      "Write the instance name to confirm the deletion": [
        ""
      ],
      "Purge": [
        ""
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        ""
      ],
      "DELETE": [
        ""
      ],
      "Instance id": [
        ""
      ],
      "Delete this instance": [
        ""
      ],
      "Must be one of '%1$s'": [
        ""
      ],
      "URL is invalid": [
        ""
      ],
      "Webhook ID to use": [
        ""
      ],
      "Event": [
        ""
      ],
      "Payment": [
        ""
      ],
      "Order settled": [
        ""
      ],
      "Category added": [
        ""
      ],
      "Category updated": [
        ""
      ],
      "Inventory added": [
        ""
      ],
      "Inventory updated": [
        ""
      ],
      "Inventory deleted": [
        ""
      ],
      "The event of the webhook: why the webhook is used": [
        ""
      ],
      "Method": [
        ""
      ],
      "GET": [
        ""
      ],
      "POST": [
        ""
      ],
      "PUT": [
        ""
      ],
      "PATCH": [
        ""
      ],
      "HEAD": [
        ""
      ],
      "Method used by the webhook": [
        ""
      ],
      "URL": [
        ""
      ],
      "URL of the webhook where the customer will be redirected": [
        ""
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        ""
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        ""
      ],
      "The short list of variables are:": [
        ""
      ],
      "order's description": [
        ""
      ],
      "order's price": [
        ""
      ],
      "order's unique identification": [
        ""
      ],
      "the amount that was being refunded": [
        ""
      ],
      "the reason entered by the merchant staff for granting the refund": [
        ""
      ],
      "time of the refund in nanoseconds since 1970": [
        ""
      ],
      "Http header": [
        ""
      ],
      "Header template of the webhook": [
        ""
      ],
      "Http body": [
        ""
      ],
      "Body template used by the webhook.": [
        ""
      ],
      "Webhook deleted successfully": [
        ""
      ],
      "Add new webhooks": [
        ""
      ],
      "Load more webhooks before the first one": [
        ""
      ],
      "Event type": [
        ""
      ],
      "Delete selected webhook from the database": [
        ""
      ],
      "Load more webhooks after the last one": [
        ""
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        ""
      ],
      "Webhook updated": [
        ""
      ],
      "Header": [
        ""
      ],
      "Body": [
        ""
      ],
      "Body template used by the webhook": [
        ""
      ],
      "There is another instance with this username.": [
        ""
      ],
      "Self provision": [
        ""
      ],
      "Phone": [
        ""
      ],
      "Contact phone number": [
        ""
      ],
      "Accept the Terms of service": [
        ""
      ],
      "I understand and agree to the %1$s": [
        ""
      ],
      "Terms of service": [
        ""
      ],
      "You must accept the Terms of service to continue.": [
        ""
      ],
      "Create": [
        ""
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        ""
      ],
      "Resetting access to the instance \"%1$s\"": [
        ""
      ],
      "Reset": [
        ""
      ],
      "Language": [
        ""
      ],
      "Date format": [
        ""
      ],
      "How the date is going to be displayed": [
        ""
      ],
      "Merchant type": [
        ""
      ],
      "Simplify UI based on the user usage.": [
        ""
      ],
      "Expert user": [
        ""
      ],
      "Taler developer": [
        ""
      ],
      "Unattended in-person offline vending": [
        ""
      ],
      "In-person online point-of-sale with inventory": [
        ""
      ],
      "Digital publishing": [
        ""
      ],
      "E-commerce site": [
        ""
      ],
      "Developer mode": [
        ""
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        ""
      ],
      "Money pot deleted": [
        ""
      ],
      "Add new pots": [
        ""
      ],
      "Load more pots before the first one": [
        ""
      ],
      "Total": [
        ""
      ],
      "Delete selected pots from the database": [
        ""
      ],
      "Load more pots after the last one": [
        ""
      ],
      "There are no money pots yet, add more pressing the + sign": [
        ""
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        ""
      ],
      "Invalid amount \"%1$s\": %2$s": [
        ""
      ],
      "Descripton": [
        ""
      ],
      "Totals": [
        ""
      ],
      "There is already a money pot with the same id.": [
        ""
      ],
      "Product group deleted": [
        ""
      ],
      "Add new group": [
        ""
      ],
      "Load more groups before the first one": [
        ""
      ],
      "Delete selected group from the database": [
        ""
      ],
      "Load more groups after the last one": [
        ""
      ],
      "There are no product groups yet, add more pressing the + sign": [
        ""
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        ""
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        ""
      ],
      "There are no reports yet, add more pressing the + sign": [
        ""
      ],
      "No report generator configured in the server": [
        ""
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        ""
      ],
      "Description of the report. Possibly included in the report message": [
        ""
      ],
      "Where the report program should send the report": [
        ""
      ],
      "Source": [
        ""
      ],
      "Base URL to request the data from.": [
        ""
      ],
      "Type of the data source": [
        ""
      ],
      "Program": [
        ""
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        ""
      ],
      "Report frequency": [
        ""
      ],
      "Welcome!": [
        ""
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        ""
      ],
      "You need to associate a bank account to receive revenue.": [
        ""
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        ""
      ],
      "Hide for today": [
        ""
      ],
      "KYC verification needed": [
        ""
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        ""
      ],
      "The request reached a timeout, check your connection.": [
        ""
      ],
      "The request was cancelled.": [
        ""
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        ""
      ],
      "The server's response was malformed.": [
        ""
      ],
      "Could not complete the request due to a network problem.": [
        ""
      ],
      "Unexpected request error.": [
        ""
      ],
      "Unexpected error.": [
        ""
      ],
      "Add new instance": [
        ""
      ],
      "Edit": [
        ""
      ],
      "Change password": [
        ""
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        ""
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        ""
      ],
      "Only show active instances": [
        ""
      ],
      "Active": [
        ""
      ],
      "Only show deleted instances": [
        ""
      ],
      "Deleted": [
        ""
      ],
      "Show all instances": [
        ""
      ],
      "Delete instance": [
        ""
      ],
      "Delete the instance \"%1$s\"": [
        ""
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        ""
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        ""
      ],
      "Deleting an instance %1$s": [
        ""
      ],
      "This cannot be undone!": [
        ""
      ],
      "Purge the instance": [
        ""
      ],
      "Purge the instance \"%1$s\"": [
        ""
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        ""
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        ""
      ],
      "Purging an instance %1$s": [
        ""
      ],
      "checking compatibility with server...": [
        ""
      ],
      "Contacting the server failed": [
        ""
      ],
      "The server version is not supported": [
        ""
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        ""
      ],
      "Business Name": [
        ""
      ],
      "Available statistics": [
        ""
      ],
      "There are no statistics to list": [
        ""
      ],
      "title\u0004%1$s: Settings": [
        ""
      ],
      "title\u0004%1$s: New bank account": [
        ""
      ],
      "title\u0004%1$s: Bank accounts": [
        ""
      ],
      "title\u0004%1$s: Update bank Account": [
        ""
      ],
      "title\u0004%1$s: Orders": [
        ""
      ],
      "title\u0004%1$s: New order": [
        ""
      ],
      "title\u0004%1$s: Inventory": [
        ""
      ],
      "title\u0004%1$s: New product": [
        ""
      ],
      "title\u0004%1$s: Update product": [
        ""
      ],
      "title\u0004%1$s: Category": [
        ""
      ],
      "title\u0004%1$s: New category": [
        ""
      ],
      "title\u0004%1$s: Update category": [
        ""
      ],
      "title\u0004%1$s: Wire transfers": [
        ""
      ],
      "title\u0004%1$s: Webhooks": [
        ""
      ],
      "title\u0004%1$s: New webhook": [
        ""
      ],
      "title\u0004%1$s: Update webhook": [
        ""
      ],
      "title\u0004%1$s: OTP devices": [
        ""
      ],
      "title\u0004%1$s: New OTP device": [
        ""
      ],
      "title\u0004%1$s: Update OTP device": [
        ""
      ],
      "title\u0004%1$s: New template": [
        ""
      ],
      "title\u0004%1$s: Update template": [
        ""
      ],
      "title\u0004%1$s: Templates": [
        ""
      ],
      "title\u0004%1$s: Use template": [
        ""
      ],
      "title\u0004%1$s: Personalization": [
        ""
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        ""
      ],
      "title\u0004%1$s: Update token family": [
        ""
      ],
      "title\u0004%1$s: Access tokens": [
        ""
      ],
      "title\u0004%1$s: New access token": [
        ""
      ],
      "title\u0004New instance": [
        ""
      ],
      "title\u0004Instances": [
        ""
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=(n != 1);",
  "lang": "en",
  "completeness": 100
};

strings['de'] = {
  "locale_data": {
    "messages": {
      "": {
        "domain": "messages",
        "plural_forms": "nplurals=2; plural=n != 1;",
        "lang": "de"
      },
      "Cancel": [
        "Abbrechen"
      ],
      "%1$s": [
        "%1$s"
      ],
      "Close": [
        "Schließen"
      ],
      "Continue": [
        "Weiter"
      ],
      "Clear": [
        "Ausgangswert"
      ],
      "Confirm": [
        "Eingeben"
      ],
      "Correct form": [
        "Korrektur der Angaben"
      ],
      "Comparing account details": [
        "Vergleich der Kontodetails"
      ],
      "The connection to the account info URL was successful, but the reported account information does not match the details in the form.": [
        "Die Verbindung zur Kontoinformationen-URL ist zustandegekommen, aber die zurückgemeldeten Kontendaten unterscheiden sich von den Kontodetails im Formular."
      ],
      "Field": [
        "Feld"
      ],
      "In the form": [
        "Im Formular"
      ],
      "Reported": [
        "Gemeldet"
      ],
      "Type": [
        "Typ"
      ],
      "IBAN": [
        "IBAN"
      ],
      "Address": [
        "Adresse"
      ],
      "Host": [
        "Host"
      ],
      "Account ID": [
        "Konto-ID"
      ],
      "The account owner's legal name": [
        "Der rechtsgültige Vor- und Zuname des Kontoinhabers"
      ],
      "The postal code of the account owner's address": [
        "Postleitzahl der Adresse des Kontoinhabers"
      ],
      "Town": [
        "Ort"
      ],
      "Bank host": [
        "Server der Bank (Bank host)"
      ],
      "Bank account": [
        "Bankkonto"
      ],
      "BIC": [
        "BIC"
      ],
      "OK": [
        "OK"
      ],
      "Validate bank account: %1$s": [
        "Prüfung der Gültigkeit der Kontonummer: %1$s"
      ],
      "In order to prove that you are the beneficial owner of the bank account, you are required to wire a small amount to a specified bank account with the subject below.": [
        "Um nachzuweisen, dass Sie der wirtschaftlich Berechtigte des Bankkontos sind, müssen Sie einen kleinen Betrag auf das Bankkonto des Zahlungsdiensts mit dem folgenden Text im Mitteilungsfeld überweisen."
      ],
      "Step 1:": [
        "Schritt 1:"
      ],
      "Copy and paste this IBAN and the legal name of the beneficial owner into the respective fields in your preferred banking app or online banking website.": [
        "Kopieren Sie diese IBAN und fügen Sie diese mit dem Namen des Begünstigten in die entsprechenden Felder Ihrer Banking-App oder Ihrer Online-Banking-Website ein."
      ],
      "Beneficiary": [
        "Begünstigter"
      ],
      "Step 2:": [
        "Schritt 2:"
      ],
      "Copy this string and paste it into the 'Subject' or 'Purpose' field in your preferred banking app or online banking website.": [
        "Kopieren Sie diese Zeichenkette ins Feld „Buchungsvermerk“ (bzw. „Verwendungszweck“ oder \"Mitteilung an Empfänger\") Ihrer Banking-App oder Online-Banking-Webseite."
      ],
      "Subject": [
        "Buchungsvermerk"
      ],
      "Receiver postal code": [
        "Postleitzahl der Adresse des Begünstigten"
      ],
      "Receiver town": [
        "Stadt mit Sitz des Begünstigten"
      ],
      "Step 3:": [
        "Schritt 3:"
      ],
      "Select the smallest possible amount for a wire transfer in your preferred banking app or online banking website.": [
        "Wählen Sie in Ihrer Banking-App oder Ihrem Online-Banking den kleinstmöglichen Betrag für eine Überweisung aus."
      ],
      "Make sure ALL data is correct, especially the subject, and that you are choosing the bank account from which you definitely want to make the wire transfer. You can use the copy buttons (%1$s) to avoid typos or make use of the \"payto://\" URI below to copy just one value.": [
        "Vergewissern Sie sich, dass ALLE Daten und der Buchungsvermerk korrekt sind und Sie das richtige Bankkonto gewählt haben. Sie können die Daten durch Klicks auf die Kopiersymbole übernehmen (%1$s), um Fehler durch eigenhändige Eingabe zu vermeiden, oder den \"payto://\"-URI verwenden, um mit einer Angabe alles zu kopieren."
      ],
      "If your bank application allows you make a wire transfer using standard QR codes then try scanning the following:": [
        "Wenn Ihre Bank-App eine Überweisung mit QR-Codes ermöglicht, versuchen Sie, diesen Code zu scannen:"
      ],
      "As an alternative, in case that your bank already supports the 'PayTo URI' standard, you can use this %1$s link instead": [
        "Falls Ihre Bank den technischen Standard „payto:// URI“ bereits unterstützt, können Sie alternativ dazu den Link %1$s verwenden"
      ],
      "Operation in progress...": [
        "Die Verarbeitung ist im Gange..."
      ],
      "The operation will be automatically cancelled after %1$s seconds": [
        "Der Vorgang wird nach %1$s Sekunden automatisch abgebrochen"
      ],
      "days": [
        "Tage"
      ],
      "hours": [
        "Stunden"
      ],
      "minutes": [
        "Minuten"
      ],
      "seconds": [
        "Sekunden"
      ],
      "Forever": [
        "Unbegrenzt"
      ],
      "%1$sM": [
        "%1$sM"
      ],
      "%1$sY": [
        "%1$sY"
      ],
      "%1$sd": [
        "%1$sd"
      ],
      "%1$sh": [
        "%1$sh"
      ],
      "%1$smin": [
        "%1$smin"
      ],
      "%1$ssec": [
        "%1$ssec"
      ],
      "Change value to never": [
        "Wert auf „nie“ setzen"
      ],
      "Change value to empty": [
        "Wert annullieren"
      ],
      "Image must be smaller than 1 MB": [
        "Die Bilddatei muss kleiner als 1 MB sein"
      ],
      "Add": [
        "Hinzufügen"
      ],
      "Remove": [
        "Entfernen"
      ],
      "Country": [
        "Land"
      ],
      "Building number": [
        "Zusätzliche Adressangabe"
      ],
      "Building name": [
        "Name des Gebäudes"
      ],
      "Street": [
        "Str."
      ],
      "Post code": [
        "Postleitzahl"
      ],
      "Town location": [
        "Ortsteil"
      ],
      "District": [
        "Bezirk/Kanton"
      ],
      "Country subdivision": [
        "Region"
      ],
      "Additional address lines": [
        "Zusätzliche Adresszeilen"
      ],
      "Orders": [
        "Bestellungen"
      ],
      "Inventory": [
        "Lagerbestand"
      ],
      "Categories": [
        "Kategorien"
      ],
      "Wire transfers": [
        "Überweisungen"
      ],
      "Templates": [
        "Vorlagen"
      ],
      "Product groups": [
        "Artikel"
      ],
      "Money pots": [
        ""
      ],
      "Reports": [
        "Berichte"
      ],
      "Statistics": [
        "Statistiken"
      ],
      "Subscriptions and Discounts": [
        "Abos und Rabatte"
      ],
      "Configuration": [
        "Einstellungen"
      ],
      "OTP Devices": [
        "OTP-Geräte"
      ],
      "Webhooks": [
        "Webhooks"
      ],
      "Settings": [
        "Einstellungen"
      ],
      "Password": [
        "Passwort"
      ],
      "Access tokens": [
        "Zugangstoken"
      ],
      "Connection": [
        "Verbindung"
      ],
      "Personalization": [
        "Personalisierung"
      ],
      "Instances": [
        "Instanzen"
      ],
      "New": [
        "Neu"
      ],
      "List": [
        "Listen"
      ],
      "Log out": [
        "Abmelden"
      ],
      "Username": [
        "Benutzername"
      ],
      "Name of the instance in URLs. The 'admin' instance is special in that it is used to administer other instances.": [
        "Kürzel Ihres Betriebsnamens, der auch für eine Webadresse verwendet werden wird."
      ],
      "Business name": [
        "Firmenname"
      ],
      "Legal name of the business represented by this instance.": [
        "Offizieller Name des Geschäfts, der Firma oder des Verkaufsorts (z.B. wie im Handelsregister angegeben)."
      ],
      "Email": [
        "E-Mail"
      ],
      "Contact email": [
        "E-Mail-Adresse für allgemeinen Kontakt"
      ],
      "Phone number": [
        "Telefonnummer"
      ],
      "Contact phone": [
        "Telefonnummer für allgemeinen Kontakt"
      ],
      "Website URL": [
        "Webseiten-URL"
      ],
      "URL.": [
        "URL."
      ],
      "Logo": [
        "Logo (Signet)"
      ],
      "Logo image.": [
        "Abbildung des Firmenlogos."
      ],
      "Pay transaction fee": [
        "Transaktionsgebühren bezahlen"
      ],
      "Cover the transaction cost or pass it on to the user.": [
        "Gebühren aller Transaktionen übernehmen die Verkäufer (an) oder die Zahlenden (aus)."
      ],
      "Physical location of the merchant.": [
        "Niederlassung (Firmensitz) des Händlers oder Verkäufers."
      ],
      "Jurisdiction": [
        "Gerichtsstand"
      ],
      "Jurisdiction for legal disputes with the merchant.": [
        "Gerichtsstand der Firma."
      ],
      "Default cut-off times": [
        ""
      ],
      "These will be the values are going to be used if are not overriden in the order creation.": [
        ""
      ],
      "Payment delay": [
        "Zahlungsdetails"
      ],
      "Time customers have to pay an order before the offer expires by default.": [
        "Der Zeitraum, in dem Käufer eine Bestellung bezahlen müssen, bevor das Angebot regulär verfällt."
      ],
      "Refund delay": [
        "Zeitliche Verzögerung der automatischen Rückerstattung"
      ],
      "Time merchants have to refund an order.": [
        "Der Zeitraum, in dem Verkäufer Rückerstattungen für bereits bezahlte Bestellungen gewähren können."
      ],
      "Wire transfer delay": [
        "Überweisungsfrist"
      ],
      "Maximum time an exchange is allowed to delay wiring funds to the merchant, enabling it to aggregate smaller payments into larger wire transfers and reducing wire fees.": [
        "Der Zeitraum, in dem alle Kundenzahlungen zu einem Betrag zusammengefasst und vom Zahlungsdienst an das Bankkonto des Verkäufers überwiesen werden, um Überweisungsgebühren zu reduzieren."
      ],
      "Wire transfer rounding": [
        "Überweisungsfrist"
      ],
      "Interval to which wire deadlines should be rounded up to.": [
        "Dies ist die Rundung des Zeitraums auf ganze Zeiteinheiten, nach deren Ablauf die zusammengefassten Umsätze an das Bankkonto überwiesen werden."
      ],
      "As an example if you set the interval to day the wire transfer deadline will be rounded to midnight.": [
        "Wenn Sie beispielsweise das Intervall auf einen Tag festlegen, wird die Überweisungsfrist zu Mitternacht dieses Tages aufgerundet."
      ],
      "No rounding": [
        "Keine Rundung"
      ],
      "To second": [
        "Rundung auf eine Sekunde"
      ],
      "To minute": [
        "Rundung auf eine Minute"
      ],
      "To hour": [
        "Rundung auf eine Stunde"
      ],
      "To day": [
        "Rundung auf einen Tag"
      ],
      "To week": [
        "Rundung auf eine Woche"
      ],
      "To month": [
        "Rundung auf einen Monat"
      ],
      "To quarter": [
        "Rundung auf ein Vierteljahr"
      ],
      "To year": [
        "Rundung auf ein Jahr"
      ],
      "Expired": [
        "Abgelaufen"
      ],
      "Required": [
        "Erforderlich"
      ],
      "Unauthorized": [
        "Unberechtigter Zugriff"
      ],
      "The code is not correct.": [
        "Der eingegebene Code ist falsch."
      ],
      "The challenge is not known anymore.": [
        "Die Challenge ist nicht mehr bekannt."
      ],
      "Too many attempts trying to solve the challenge.": [
        "Zu viele Versuche die Challenge zu lösen."
      ],
      "Validation code sent.": [
        "Ein Bestätigungscode wurde gerade zugesendet."
      ],
      "The verification code sent to the phone number ending with \"%1$s\"": [
        "Ein Bestätigungscode wurde an die Telefonnummer gesendet, die mit \"%1$s\" endet"
      ],
      "The verification code sent to the email address starting with \"%1$s\"": [
        "Ein Bestätigungscode wurde an die E-Mailadresse gesendet, die mit \"%1$s\" beginnt"
      ],
      "Verification code": [
        "Bestätigungscode"
      ],
      "It will expire at %1$s": [
        "Ende der Gültigkeit %1$s"
      ],
      "The challenge is expired and can't be solved but you can go back and create a new challenge.": [
        "Das Prüfverfahren zur gesicherten Anmeldung ist abgelaufen und kann nicht mehr verwendet werden, es ist jedoch möglich, ein neues Prüfverfahren anzufordern (bitte gehen Sie im Browser einen Schritt zurück)."
      ],
      "Back": [
        "Zurück"
      ],
      "Verify": [
        "Prüfen"
      ],
      "Failed to send the verification code.": [
        "Verifizierungscode konnte nicht gesendet werden."
      ],
      "The request was valid, but the server is refusing action.": [
        "Die Anfrage war gültig, aber der Server verweigert die Bearbeitung."
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Dieser Anwendung ist die angegebene Multi-Faktor-Überprüfung nicht bekannt."
      ],
      "Code transmission failed.": [
        "Die Code-Übertragung ist fehlgeschlagen."
      ],
      "Already solved.": [
        "Bereits gelöst."
      ],
      "It is too early to request another transmission of the challenge.": [
        "Es muss noch gewartet werden, um eine weitere Übertragung des Überprüfungscodes zu verlangen."
      ],
      "Multi-factor authentication required.": [
        "Es ist eine Multi-Faktor-Authentifizierung erforderlich."
      ],
      "You need to complete all of this requirements.": [
        "Sie müssen alle dieser Bedingungen erfüllen."
      ],
      "You need to complete at least one of this requirements.": [
        "Sie müssen mindestens eine dieser Bedingungen erfüllen."
      ],
      "An SMS to the phone number ending with %1$s": [
        "SMS senden an die Telefonnummer, die mit %1$s endet"
      ],
      "An email to the address starting with %1$s": [
        "Bestätigungscode senden an die E-Mailadresse, die mit %1$s beginnt"
      ],
      "You have to wait until %1$s to send a new code.": [
        "Sie müssen bis %1$s warten, damit ein neuer Bestätigungscode gesendet werden kann."
      ],
      "I have a code": [
        "Ich habe bereits einen gültigen Bestätigungscode"
      ],
      "Send me a message": [
        "Bestätigungscode zusenden"
      ],
      "Logged in": [
        "Sie sind angemeldet"
      ],
      "Not found": [
        "Nicht gefunden"
      ],
      "Login required": [
        "Anmeldung erforderlich"
      ],
      "Instance name.": [
        "Name zur Anmeldung im Taler-Händlerportal."
      ],
      "Instance password.": [
        "Passwort für den Zugang zum Händlerportal."
      ],
      "Forgot password": [
        "Ich habe mein Passwort vergessen"
      ],
      "Create new account": [
        "Neues Benutzerkonto erstellen"
      ],
      "Invalid": [
        "Ungültig"
      ],
      "Doesn't have the pattern of an email": [
        "Dies entspricht keiner gültigen E-Mailadresse"
      ],
      "Should start with +": [
        "Die Nummer sollte mit + beginnen"
      ],
      "A phone number consists of numbers only": [
        "Eine Telefonnummer besteht nur aus Ziffern"
      ],
      "Invalid value": [
        "Ungültiger Wert"
      ],
      "Max 7 lines": [
        "Höchstens 7 Zeilen"
      ],
      "Doesn't match": [
        "Dies stimmt nicht überein"
      ],
      "Instance created": [
        "Die Instanz wurde angelegt"
      ],
      "Unauthorized.": [
        "Nicht autorisiert."
      ],
      "Conflict.": [
        "Es besteht ein Konflikt zwischen erwarteter und gesendeter Information."
      ],
      "Not found.": [
        "Die Information wurde nicht gefunden."
      ],
      "New password": [
        "Neues Passwort"
      ],
      "Next password to be used": [
        "Geben Sie hier ein neues Passwort ein"
      ],
      "Repeat password": [
        "Passwort wiederholen"
      ],
      "Confirm the same password": [
        "Bitte geben Sie das Passwort hier wiederholt ein"
      ],
      "Please complete the marked fields and choose authorization method": [
        "Sie müssen die gekennzeichneten Felder ausfüllen und eine Methode der Berechtigungsprüfung wählen"
      ],
      "Confirm operation": [
        "Vorgang bestätigen"
      ],
      "Check the password.": [
        "Überprüfen Sie das Passwort."
      ],
      "Instance not found.": [
        "Die Instanz wurde nicht gefunden."
      ],
      "Description": [
        "Beschreibung"
      ],
      "Helps you remember where this access token is being used before deleting it.": [
        "Dies hilft Ihnen zur Erinnerung, wo dieser Zugangstoken verwendet wird, bevor Sie ihn löschen."
      ],
      "Duration": [
        "Gültigkeitszeitraum"
      ],
      "Time the access token will be valid.": [
        "Der Zeitraum, in dem der Zugangstoken gültig ist."
      ],
      "Refreshable access tokens can pose a security risk!": [
        "Aktualisierbare Token können ein Sicherheitsrisiko darstellen!"
      ],
      "Refreshable access tokens can be refreshed before their lifetime ends, effectively giving any bearer access without expiration. Only use this if you know what you are doing and you have evaluated associated risks especially in respect to the permissions granted by the scope.": [
        "Aktualisierbare Token können vor Ablauf ihrer Lebensdauer aktualisiert werden, wodurch alle ihre Besitzer effektiv eine zeitlich unbegrenzte Zugangsberechtigung haben würde. Verwenden Sie diese daher nur, wenn Sie wissen, was Sie tun und die damit verbundenen Risiken insbesondere im Hinblick auf den zugewiesenen Einsatzbereich der Berechtigung richtig einschätzen können."
      ],
      "Scope": [
        "Einsatzbereich des Zugangstokens"
      ],
      "The scope defines the set of permissions for the access token. Refreshable tokens has the permission to extend the expiration time.": [
        "Der Einsatzbereich definiert die Berechtigungen eines Zugangstokens. Bei aktualisierbaren Token können ihre Besitzer die Gültigkeitszeit unbegrenzt verlängern."
      ],
      "Allows all operations without limit.": [
        "Dies erlaubt alle Vorgänge ohne jede Einschränkung."
      ],
      "Allows all operations to read information.": [
        "Dies ermöglicht allen Vorgängen, Informationen zu lesen."
      ],
      "Allows the creation of orders and checking of payment status.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen sowie die Überprüfung des Zahlungsstatus."
      ],
      "Allows the creation of orders, checking of payment status and inventory locking.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, die Überprüfung des Zahlungsstatus und das Sperren des Lagerbestands."
      ],
      "Allows the creation of orders, checking of payment status and refunds.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, die Überprüfung des Zahlungsstatus sowie Rückerstattungen."
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, das Sperren des Lagerbestands sowie Rückerstattungen."
      ],
      "Allows all operations to read information with extendable expiration time.": [
        "Dies ermöglicht allen Vorgängen das Einlesen von Informationen mit einer verlängerbaren Verfallszeit."
      ],
      "Allows the creation of orders and checking of payment status with extendable expiration time.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen sowie die Überprüfung des Zahlungsstatus mit verlängerbarer Verfallszeit."
      ],
      "Allows the creation of orders, checking of payment status and inventory locking with extendable expiration time.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, die Überprüfung des Zahlungsstatus sowie das Sperren des Lagerbestands mit verlängerbarer Verfallszeit."
      ],
      "Allows the creation of orders, checking of payment status and refunds with extendable expiration time.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, die Überprüfung des Zahlungsstatus sowie Rückerstattungen mit verlängerbarer Verfallszeit."
      ],
      "Allows the creation of orders, checking of payment status, inventory locking and refunds with extendable expiration time.": [
        "Dies ermöglicht die Erstellung von Bestellungen und Barrechnungen, die Überprüfung des Zahlungsstatus sowie das Sperren des Lagerbestands und Rückerstattungen mit verlängerbarer Verfallszeit."
      ],
      "All (refreshable)": [
        "Alle (aktualisierbar)"
      ],
      "Spa": [
        "SPA"
      ],
      "Spa (refreshable)": [
        "SPA (aktualisierbar)"
      ],
      "Choose one": [
        "Bitte wählen Sie eine Option aus"
      ],
      "Read only": [
        "Schreibgeschützt"
      ],
      "All": [
        "Alle"
      ],
      "Order simple": [
        "Einfache Bestellungen"
      ],
      "Order Point-of-Sale": [
        "Bestellungen an der Verkaufsstelle (POS)"
      ],
      "Order management": [
        "Verwaltung der Bestellungen"
      ],
      "Order full": [
        "Komplexe Bestellungen"
      ],
      "Read only (refreshable)": [
        "Schreibgeschützt (aktualisierbar)"
      ],
      "Order simple (refreshable)": [
        "Einfache Bestellungen (aktualisierbar)"
      ],
      "Order Point-of-Sale (refreshable)": [
        "Bestellungen an der Verkaufsstelle (aktualisierbar)"
      ],
      "Order management (refreshable)": [
        "Verwaltung der Bestellungen (aktualisierbar)"
      ],
      "Order full (refreshable)": [
        "Komplexe Bestellungen (aktualisierbar)"
      ],
      "Current password": [
        "Aktuelles Passwort dieser Instanz"
      ],
      "Please complete the marked fields": [
        "Bitte füllen Sie die Felder mit verpflichtenden Angaben aus"
      ],
      "Access token created": [
        "Zugangstoken wurde erzeugt"
      ],
      "Copy the value of the access token and save it, as you cannot retrieve it again.": [
        "Kopieren und speichern Sie den Zugangstoken sofort, da Sie ihn nicht erneut abrufen können."
      ],
      "Token": [
        "Zugangstoken"
      ],
      "This token will never expire": [
        "Dieser Zugangstoken wird nie ungültig"
      ],
      "This token will be available until %1$s": [
        "Dieser Zugangstoken ist verfügbar bis %1$s"
      ],
      "No 'admin' instance configured yet.": [
        "Es wurde noch keine Instanz 'admin' konfiguriert."
      ],
      "Create an 'admin' instance to begin using the merchant backoffice.": [
        "Erstellen Sie eine Instanz 'admin', um Merchant Backoffice erstmalig zu verwenden."
      ],
      "Create access token": [
        "Zugangstoken erzeugen"
      ],
      "Load more devices before the first one": [
        "Mehr Geräte vor ein erstes Gerät laden"
      ],
      "Load first page": [
        "Erste Seite laden"
      ],
      "Created at": [
        "Erstellungsdatum"
      ],
      "Expires at": [
        "Wird ungültig zum Zeitpunkt"
      ],
      "Never": [
        "Nie"
      ],
      "Remove this access token": [
        "Diesen Zugangstoken entfernen"
      ],
      "Delete": [
        "Löschen"
      ],
      "Load more devices after the last one": [
        "Mehr Geräte nach dem letzten Gerät laden"
      ],
      "Load next page": [
        "Nächste Seite laden"
      ],
      "There are no active sessions yet, add one by pressing the + sign": [
        "Es bestehen noch keine aktiven Sitzungen, Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Forbidden.": [
        "Unzulässig."
      ],
      "Delete access token": [
        "Zugangstoken löschen"
      ],
      "Deleting an access token cannot be undone.": [
        "Das Löschen eines Zugangstoken kann nicht rückgängig gemacht werden."
      ],
      "This is not a valid Bitcoin address.": [
        "Dies ist keine gültige Bitcoin-Adresse."
      ],
      "This is not a valid Ethereum address.": [
        "Dies ist keine zulässige Ethereum-Adresse."
      ],
      "This is not a valid host.": [
        "Dies ist kein gültiger Host."
      ],
      "IBANs usually have more than 4 digits.": [
        "Eine IBAN besteht normalerweise aus mehr als 4 Ziffern."
      ],
      "IBANs usually have fewer than 34 digits.": [
        "Eine IBAN besteht normalerweise aus weniger als 34 Ziffern."
      ],
      "The IBAN's country code could not be retrieved.": [
        "Der IBAN-Ländercode wurde nicht gefunden."
      ],
      "The IBAN is invalid because the checksum is wrong.": [
        "Die IBAN-Nummer ist ungültig, die Prüfsumme ist falsch."
      ],
      "This account is not allowed.": [
        "Dieses Konto ist nicht zulässig."
      ],
      "None of the supported wire method of the server are currently supported by this app. Server settings: %1$s": [
        "Keine der gängigen Übertragungsmethoden des Servers wird zurzeit von dieser Anwendung unterstützt. Server-Einstellungen: %1$s"
      ],
      "Wire method": [
        "Überweisungsmethode"
      ],
      "Select the method you want to use to transfer your earnings to your business account.": [
        "Wählen Sie die Methode, mit der Sie Ihre Einnahmen an Ihr Geschäftskonto überweisen möchten."
      ],
      "Select a wire method...": [
        "Wählen Sie eine Überweisungsmethode..."
      ],
      "Routing": [
        "Bankleitzahlensystem"
      ],
      "Routing number": [
        "Bankleitzahl"
      ],
      "Account": [
        "Konto"
      ],
      "Account number": [
        "Kontonummer"
      ],
      "Code": [
        "Code"
      ],
      "Business Identifier Code": [
        "Business Identifier Code (BIC)"
      ],
      "International Bank Account Number": [
        "IBAN (Internationale Bankkontonummer)"
      ],
      "your bank account number, e.g. DE12 0000 1111 2222 3333 00": [
        "Ihre IBAN, z.B. CH12 0000 1111 2222 3333 00"
      ],
      "Unified Payment Interface": [
        "Unified Payment Interface (UPI)"
      ],
      "Bitcoin protocol": [
        "Bitcoin-Protokoll"
      ],
      "Ethereum protocol": [
        "Ethereum-Protokoll"
      ],
      "Interledger protocol": [
        "Interledger-Protokoll"
      ],
      "Enter the data without a scheme. A subpath may be included:": [
        "Geben Sie die Daten ohne Schema ein. Ein Pfad kann darin enthalten sein:"
      ],
      "Cyclos host": [
        ""
      ],
      "cyclos account": [
        "Alle Konten"
      ],
      "Name of the account holder": [
        "Name des Kontoinhabers"
      ],
      "John Doe": [
        "Max Muster"
      ],
      "Legal name of the person holding the account.": [
        "Rechtsgültiger Name des Kontoinhabers."
      ],
      "Invalid url": [
        "ungültige URL"
      ],
      "URL must end with a '/'": [
        "Die URL muss mit '/' enden"
      ],
      "URL must not contain params": [
        "Die URL darf keine Parameter enthalten"
      ],
      "URL must not hash param": [
        "Die URL darf keinen Hash-Parameter enthalten"
      ],
      "Conflict": [
        "Konflikt"
      ],
      "Server replied with \"bad request\".": [
        "Der Server antwortete mit \"bad request\"."
      ],
      "Unauthorized, check credentials.": [
        "Unzulässiger Vorgang, bitte die Zugangsdaten (Token, Anmeldename, Passwort) überprüfen."
      ],
      "The endpoint does not seem to be a Taler Revenue API.": [
        "Die Gegenstelle scheint keine Taler-Einzahlungsschnittstelle (Taler Revenue API) zu sein."
      ],
      "The request was made correctly, but the bank's server did not respond with the appropriate value for 'credit_account', so we cannot confirm that it is the same bank account.": [
        "Die Anfrage war richtig gestellt, doch der Server der Bank antwortete nicht mit dem passenden Wert (für 'credit_account'), so dass wir nicht bestätigen können, dass es sich um dasselbe Bankkonto handelt."
      ],
      "Unsupported type of account": [
        "Nicht unterstützter Kontotyp"
      ],
      "Account:": [
        "Konto:"
      ],
      "If the bank supports Taler Revenue API then you can add the endpoint URL below to keep the revenue information in sync.": [
        "Wenn die kontoführende Bank die Schnittstelle Taler Revenue API unterstützt, können Sie die untenstehende Gegenstelle (endpoint URL) hinzufügen, um die Umsatzinformationen zwischen dem Backend und dem Bankkonto zu synchronisieren."
      ],
      "Endpoint URL": [
        "Gegenstelle (endpoint URL)"
      ],
      "From where the merchant can download information about incoming wire transfers to this account": [
        "Informationsquelle zu eingehenden Überweisungen auf dieses Bankkonto"
      ],
      "Auth type": [
        "Authentifizierungsmethode"
      ],
      "Choose the authentication type for the account info URL": [
        "Wählen Sie die Authentifizierungsmethode zum Zugriff auf das Bankkonto, um die eingegangenen Überweisungen abzufragen"
      ],
      "Without authentication": [
        "Ohne Authentifizierung"
      ],
      "With username and password": [
        "Mit Benutzername und Passwort"
      ],
      "With token": [
        "Mit Zugangstoken"
      ],
      "Do not change": [
        "Lassen Sie dies unverändert"
      ],
      "Username to access the account information.": [
        "Benutzername für den Zugriff auf die Kontoinformationen."
      ],
      "Password to access the account information.": [
        "Passwort für den Zugriff auf die Kontoinformationen."
      ],
      "Access token to access the account information.": [
        "Zugangstoken für den Zugriff auf die Kontoinformationen."
      ],
      "Match": [
        "Übereinstimmung"
      ],
      "Check where the information match against the server info.": [
        "Prüfung der Übereinstimmung dieser Information und der Daten auf dem Server."
      ],
      "Compare info from server with account form": [
        "Vergleich der Information des Servers mit den Bankkonto-Formulardaten"
      ],
      "Test": [
        "Test"
      ],
      "Server didn't like the request we made.": [
        "Der Server war mit unserer Anfrage nicht einverstanden."
      ],
      "Account details": [
        "Kontodetails"
      ],
      "Check if the information matches the server info.": [
        "Bitte prüfen Sie, ob die Information und die Daten auf dem Server übereinstimmen."
      ],
      "The bank account has been deleted.": [
        "Die Verknüpfung mit dem Bankkonto wurde erfolgreich gelöscht."
      ],
      "Delete account": [
        "Wählen Sie ein Konto"
      ],
      "Delete the account \"%1$s\"": [
        "Artikel \"%1$s\" löschen"
      ],
      "Invalid payto: \"%1$s\"": [
        ""
      ],
      "If you delete the account with name %1$s its information will be lost": [
        "Wenn Sie das Konto mit der Bezeichnung %1$s löschen, gehen alle zugehörigen Informationen verloren"
      ],
      "Deleting an account can't be undone.": [
        "Das Löschen eines Zugangstoken kann nicht rückgängig gemacht werden."
      ],
      "Bank accounts": [
        "Bankkonten"
      ],
      "Add new account": [
        "Neues Konto hinzufügen"
      ],
      "Owner's name": [
        "Name des Kontoinhabers"
      ],
      "Delete selected accounts from the database": [
        "Löschen ausgewählter Konten von der Datenbank"
      ],
      "There are no accounts yet, add more pressing the + sign": [
        "Es sind noch keine Konten angelegt, Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "You must provide a bank account to receive payments.": [
        "Sie müssen ein Bankkonto verknüpfen, um Einnahmen an dieses Konto zu überweisen."
      ],
      "Without this information, you cannot create new payment orders that are transferred to a bank account.": [
        "Ohne diese Informationen können Sie keine neuen Zahlungsabwicklungen erstellen, die an ein Bankkonto überwiesen werden."
      ],
      "Invalid. Please use only letters and numbers.": [
        "Ungültig. Bitte geben Sie nur Buchstaben und Zahlen ein."
      ],
      "Name": [
        "Name"
      ],
      "Category name": [
        "Kategoriename"
      ],
      "Category deleted": [
        "Die Kategorie wurde gelöscht"
      ],
      "Add new devices": [
        "Neue Geräte hinzufügen"
      ],
      "ID": [
        "ID"
      ],
      "Total products": [
        "Gesamte Artikelmenge"
      ],
      "Delete selected category from the database": [
        "Ausgewählte Kategorie aus der Datenbank löschen"
      ],
      "There are no categories yet, add more pressing the + sign": [
        "Es gibt noch keine Kategorien. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Id:": [
        "ID:"
      ],
      "Name of the category": [
        "Benennung der Kategorie (Warengruppe)"
      ],
      "Products": [
        "Artikel"
      ],
      "Image": [
        "Bild"
      ],
      "Load more products after the last one": [
        "Weitere Artikel nach dem letzten laden"
      ],
      "There are no products in this category.": [
        "Es befinden sich keine Artikel in dieser Kategorie."
      ],
      "Account's KYC status": [
        "KYC-Status des Bankkontos"
      ],
      "Exchange": [
        "Zahlungsdienstleister"
      ],
      "Status": [
        "Status"
      ],
      "Ok": [
        "OK"
      ],
      "Action required": [
        "Sie müssen noch eine Aktion ausführen (eine Überweisung oder eine KYC-Prüfung ist erforderlich)"
      ],
      "Warning": [
        "Warnung"
      ],
      "Error": [
        "Fehler"
      ],
      "Bank account verification required.": [
        "Eine Bankkonto-Verifizierung ist erforderlich."
      ],
      "More information required.": [
        "Weitere Informationen sind erforderlich."
      ],
      "Awaiting for account review.": [
        "Es wird auf die Überprüfung des Kontos gewartet."
      ],
      "Ready": [
        "Bereit zum Einsatz"
      ],
      "Syncing...": [
        "Die Daten werden eingelesen..."
      ],
      "Payment service internal error. Contact administrator or check again later.": [
        "Interner Fehler des Zahlungsdiensts. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Merchant backend internal error. Contact administrator or check again later.": [
        "Interner Fehler im Backend. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Payment service timeout. Contact administrator or check again later.": [
        "Zeitüberschreitung der Antwort des Zahlungsdiensts. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Payment service unreachable. Contact administrator or check again later.": [
        "Der Zahlungsdienst ist nicht erreichbar. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Incompatible core banking system.": [
        "Inkompatibles Kernbankensystem."
      ],
      "Backend internal error. Contact administrator or check again later.": [
        "Interner Fehler im Backend. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Payment service response is invalid. Contact administrator or check again later.": [
        "Die Antwort des Zahlungsdiensts ist ungültig. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Payment service provider can't make a wire transfer to this account.": [
        ""
      ],
      "No pending kyc verification!": [
        "Eine KYC-Prüfung ist nicht (mehr) ausstehend!"
      ],
      "The account for wire transfers does not appear to be valid": [
        "Das Konto für Überweisungen scheint nicht gültig zu sein"
      ],
      "The backend service responded with \"%1$s\" which is invalid.": [
        "Das Backend hat mit \"%1$s\" geantwortet, was ungültig ist."
      ],
      "No exchange keys": [
        "Es sind keine Schlüssel des Exchange vorhanden"
      ],
      "The backend service is still synchronizing with the payment service provider.": [
        "Das Backend synchronisiert zurzeit noch mit dem Zahlungsdienst."
      ],
      "No transfers can be made from this account": [
        "Von diesem Bankkonto kann keine Überweisung erfolgen"
      ],
      "The core banking system cannot perform wire transfers between the payment service provider's accounts and your bank accounts. Thus you cannot use this payment service provider. Sincerely, the Taler Exchange.": [
        "Das Kernbankensystem kann keine Überweisungen zwischen dem Bankkonto des Zahlungsdiensts und Ihren Bankkonten durchführen. Daher können Sie diesen Zahlungsdienst nicht nutzen. Der Taler Exchange."
      ],
      "You must undergo a KYC (Know Your Customer) process as required by financial regulations or laws": [
        ""
      ],
      "The payment service provider requires more information.": [
        "Der Zahlungsdienst verlangt mehr Informationen."
      ],
      "Click here to complete this step.": [
        "Klicken Sie hier, um diesen Schritt abzuschließen."
      ],
      "We are waiting for the access token to be present. Check again later.": [
        "Bitte warten Sie auf die Erzeugung des Zugangstokens und prüfen diese zu einem späteren Zeitpunkt erneut."
      ],
      "Awaiting AML review": [
        "Eine AML-Überprüfung steht noch aus"
      ],
      "This account cannot be used. The payment service provider must verify the account information manually.": [
        "Dieses Konto kann nicht verwendet werden. Der Zahlungsdienst führt eine manuelle Überprüfung der Kontoinformationen durch."
      ],
      "This account has been successfully configured for use with the payment service provider.": [
        "Dieses Konto ist bereit für die Nutzung mit diesem Zahlungsdienst."
      ],
      "Logic bug": [
        "Logischer Fehler"
      ],
      "The backend service detected an internal error, contact the system administrator or check again later.": [
        "Das Backend hat einen internen Fehler festgestellt. Wenden Sie sich an den Systemadministrator oder prüfen Sie später erneut."
      ],
      "Internal error": [
        "Interner Systemfehler"
      ],
      "The payment service provider detected an internal error, contact the system administrator or check again later.": [
        "Interner Fehler des Zahlungsdiensts. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "The merchant service provider detected an internal error, contact the system administrator or check again later.": [
        "Interner Fehler des Zahlungsdiensts. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "The backend service could not contact the payment service provider due to a timeout, contact the system administrator or check again later.": [
        "Das Backend konnte den Zahlungsdienst aufgrund einer Zeitüberschreitung nicht kontaktieren. Wenden Sie sich an den Systemadministrator oder prüfen Sie später erneut."
      ],
      "Unable to reach the payment service provider, contact the system administrator or check again later.": [
        "Der Zahlungsdienst ist zurzeit nicht erreichbar. Wenden Sie sich an den Administrator oder prüfen Sie später erneut."
      ],
      "Unsupported account": [
        "Nicht unterstützter Kontotyp"
      ],
      "This exchange does not support the given account.": [
        ""
      ],
      "The payment service provider replied with an invalid status, contact the system administrator or check again later.": [
        "Der Zahlungsdienst hat mit einem ungültigen Status geantwortet. Wenden Sie sich an den Systemadministrator oder prüfen Sie später erneut."
      ],
      "Change value to unknown date": [
        "Wert auf unbekanntes Datum ändern"
      ],
      "Enter description or id": [
        "Geben Sie die Beschreibung oder eine ID ein"
      ],
      "No match found for that description or ID.": [
        "Für diese Beschreibung oder ID wurde keine Übereinstimmung gefunden."
      ],
      "You must enter a valid product identifier.": [
        "Sie müssen eine gültige Artikelkennung eingeben."
      ],
      "Quantity must be greater than 0!": [
        "Die Menge muss größer als 0 sein!"
      ],
      "This quantity exceeds remaining stock. Currently, only %1$s units remain unreserved in stock.": [
        "Diese Menge überschreitet den Bestand. Momentan sind nur %1$s Stück im Inventar ohne Vorbestellung."
      ],
      "Search product": [
        "Artikel suchen"
      ],
      "Quantity": [
        "Menge"
      ],
      "How many products will be added": [
        "Wie viele Artikel hinzugefügt werden"
      ],
      "Add from inventory": [
        "Vom Bestand hinzufügen"
      ],
      "This product has %1$s applicable taxes configured.": [
        "Für diesen Artikel ist ein Steuersatz von %1$s angelegt."
      ],
      "No taxes configured for this product.": [
        "Für diesen Artikel sind keine Steuern angelegt."
      ],
      "Amount": [
        "Betrag"
      ],
      "Taxes can be in currencies that differ from the main currency used by the merchant.": [
        "Steuern können in einer anderen Währung sein als die Hauptwährung, welche für Verkäufe normalerweise verwendet wird."
      ],
      "Enter the currency and value separated by a colon (e.g., &quot;USD:2.3&quot;).": [
        "Geben Sie Währung und Betrag mit einem Doppelpunkt getrennt ein, z.B. &quot;CH:2.3&quot; oder &quot;EUR:2,3&quot;."
      ],
      "Legal name of the tax, e.g. VAT or import duties.": [
        "Offizielle Bezeichnung der Steuer, z.B. Mehrwertsteuer oder Einfuhrsteuer."
      ],
      "Add tax to the tax list": [
        "Steuersatz zur Liste der Steuern hinzufügen"
      ],
      "Describe and add a product that is not in the inventory list": [
        "Bisher nicht inventarisierte Artikel beschreiben und hinzufügen"
      ],
      "Add custom product": [
        "Individuellen Artikel hinzufügen"
      ],
      "Complete information of the product": [
        "Informationen zum Artikel vervollständigen"
      ],
      "Must be a number.": [
        "Dieser Wert muss eine Nummer sein."
      ],
      "Must be greater than 0.": [
        "Dieser Wert muss größer als Null sein."
      ],
      "Photo of the product.": [
        "Abbildung des Artikels."
      ],
      "Full product description.": [
        "Vollständige Artikelbeschreibung."
      ],
      "Unit name": [
        "Art der Mengeneinheit"
      ],
      "Name of the product unit.": [
        "Bezeichnung der Einheit des Artikels."
      ],
      "Price per unit": [
        "Preis pro Mengeneinheit"
      ],
      "Amount in the current currency.": [
        "Betrag in der aktuellen Währung."
      ],
      "How many products will be added.": [
        "Wie viele Artikel hinzugefügt werden."
      ],
      "Taxes": [
        "Steuern"
      ],
      "Total price": [
        "Gesamtpreis"
      ],
      "Must be greater than 0": [
        "Dieser Wert muss größer als Null sein"
      ],
      "Must have a refund deadline": [
        "Es sollte eine Rückerstattungsfrist geben"
      ],
      "Auto refund can't be after refund deadline": [
        "Eine automatische Rückerstattung kann nicht nach der Rückerstattungsfrist erfolgen"
      ],
      "Must be in the future": [
        "Dieser Wert sollte in der Zukunft liegen"
      ],
      "Either fulfillment url or fulfillment message must be specified.": [
        "Es müssen entweder fulfillment-URL oder fulfillment message angegeben werden."
      ],
      "is not a valid URL": [
        "ist keine gültige URL"
      ],
      "No active bank accounts configured. At least one bank account must be available to create new orders": [
        ""
      ],
      "Product with ID \"%1$s\" is out of stock.": [
        "Der Artikel mit der ID \"%1$s\" ist nicht auf Lager."
      ],
      "No exchange would accept a payment because of KYC requirements.": [
        "Aufgrund von KYC-Bedingungen, die nicht erfüllt werden, könnte kein Zahlungsdienst Buchungen annehmen."
      ],
      "Manage products in order": [
        "Artikel in der Bestellung verwalten"
      ],
      "%1$s products with a total price of %2$s.": [
        "%1$s Artikel zu einer Gesamtsumme von %2$s."
      ],
      "Manage list of products in the order.": [
        "Liste der Artikel in der Bestellung verwalten."
      ],
      "Remove this product from the order.": [
        "Diesen Artikel aus der Bestellung entfernen."
      ],
      "Products price sum": [
        "Summe der Preise der Artikel"
      ],
      "Total product price added up": [
        "Gesamtpreis des Artikels hinzugerechnet"
      ],
      "Order price": [
        "Preis eines Artikels"
      ],
      "Amount to be paid by the customer": [
        "Vom Kunden zu zahlender Betrag"
      ],
      "Final order price": [
        "Endgültiger Bestellwert"
      ],
      "Summary": [
        "Zusammenfassung"
      ],
      "Title of the order to be shown to the customer": [
        "Bezeichnung der Bestellung, die den Kunden angezeigt wird"
      ],
      "Shipping and fulfillment": [
        "Versand und Lieferung"
      ],
      "Delivery date": [
        "Lieferdatum"
      ],
      "Deadline for physical delivery assured by the merchant.": [
        "Vom Händler zugesicherte Zustellfrist."
      ],
      "Delivery location": [
        "Lieferadresse"
      ],
      "Address where the products will be delivered": [
        "Zustelladresse der Artikel"
      ],
      "Fulfillment URL": [
        "Adresse digitaler Dienstleistung (Fulfillment-URL)"
      ],
      "URL to which the user will be redirected after successful payment.": [
        "URL der von Kunden zu besuchenden Adresse nach erfolgter Bezahlung."
      ],
      "Fulfillment message": [
        "Fulfillment message (Nachricht an Zahlende über bereitgestelltes digitales Gut)"
      ],
      "Message shown to the customer after paying for the order.": [
        "Die Nachricht, die den Kunden nach der Bezahlung der Bestellung angezeigt wird."
      ],
      "Taler payment options": [
        "Taler-Zahlungsoptionen"
      ],
      "Override default Taler payment settings for this order": [
        "Überschreibe die vorgegebenen Zahlungseinstellungen im Taler-System für diese Bestellung"
      ],
      "Payment time": [
        "Zahlungsdatum"
      ],
      "Time for the customer to pay before the offer expires. Inventory products will be reserved until this deadline. The time starts after the order is created.": [
        "Der Zeitraum, in dem die Käufer bezahlen müssen, bevor das Vertragsangebot verfällt. Inventarisierte Artikel für ein aktuelles Angebot werden bis zum Ablauf dieses Zeitraums reserviert. Der Zeitablauf beginnt mit der Erstellzeit der Bestellung."
      ],
      "Default": [
        "Standardeinstellung"
      ],
      "Refund time": [
        "Rückerstattungsdatum"
      ],
      "Time while the order can be refunded by the merchant. Time starts after the order is created.": [
        "Der Zeitraum, in dem die Bestellung vom Verkäufer erstattet werden kann. Die Zeitdauer beginnt mit der Erstellzeit der Bestellungen."
      ],
      "Wire transfer time": [
        "Zeitpunkt der Überweisung"
      ],
      "Time for the exchange to make the wire transfer. Time starts after the order is created.": [
        "Der Zeitraum, nach dessen Ablauf der Zahlungsdienst die Einnahmen überweist. Die Zeitdauer beginnt mit der Erstellzeit der Bestellung."
      ],
      "Auto-refund time": [
        "Zeitdauer für automatische Rückerstattungen"
      ],
      "Time until which the wallet will automatically check for refunds without user interaction.": [
        "Zeit, bis zu der das Wallet automatisch und ohne Benutzerinteraktion auf Rückerstattungen prüft."
      ],
      "Maximum fee": [
        "Maximale Gebührenhöhe"
      ],
      "Maximum fees the merchant is willing to cover for this order. Higher deposit fees must be covered in full by the consumer.": [
        "Die maximale Gebührenhöhe, die ein Verkäufer für eine Bestellung zu übernehmen bereit ist. Einlösegebühren, die über dieser liegen, sind komplett von den Käufern zu übernehmen."
      ],
      "Create token": [
        "Token erzeugen"
      ],
      "If the order ID is easy to guess, the token will prevent other users from claiming the order.": [
        "Selbst wenn die ID einer Bestellung leicht zu erraten wäre, verhindert der Token, dass die Bestellung von Unberechtigten übernommen werden könnte."
      ],
      "Minimum age required": [
        "Mindestalter erforderlich"
      ],
      "Any value greater than 0 will limit the coins able be used to pay this contract. If empty the age restriction will be defined by the products": [
        "Eine Zahl größer als 0 schränkt ein, welches e-Geld zur Bezahlung dieses Kaufvertrags verwendet werden kann. Bleibt das Feld leer, werden Altersbeschränkungen durch die Artikel selbst festgelegt"
      ],
      "Minimum age defined by the products is %1$s": [
        "Das Mindestalter für den Erwerb dieses Artikels ist %1$s"
      ],
      "No product with age restriction in this order": [
        "Es befindet sich kein Artikel mit einer Altersbeschränkung in dieser Bestellung"
      ],
      "Additional information": [
        "Zusätzliche Informationen"
      ],
      "Custom information to be included in the contract for this order.": [
        "Individuelle Informationen, die in den Kaufvertrag für diese Bestellung aufgenommen werden sollen."
      ],
      "You must enter a value in JavaScript Object Notation (JSON).": [
        "Sie müssen einen Wert im Format JavaScript Object Notation (JSON) eingeben."
      ],
      "remove": [
        "Entfernen"
      ],
      "Custom field name": [
        "Benutzerdefinierter Feldname"
      ],
      "Disabled": [
        "Deaktiviert"
      ],
      "No deadline": [
        "Keine Zahlungsfrist"
      ],
      "Deadline at %1$s": [
        "Frist bis %1$s"
      ],
      "Select date to show nearby orders": [
        "Bitte wählen Sie ein Datum, um die Bestellungen dieses Zeitraums anzuzeigen"
      ],
      "Only show unpaid orders": [
        "Nur unbezahlte Bestellungen anzeigen"
      ],
      "Only show paid orders": [
        "Nur bezahlte Bestellungen anzeigen"
      ],
      "Paid": [
        "Bezahlt"
      ],
      "Only show orders with refunds": [
        "Nur Bestellungen mit erfolgter Rückerstattung anzeigen"
      ],
      "Refunded": [
        "Rückerstattet"
      ],
      "Show only paid orders for which the wire transfer is still pending.": [
        "Nur bezahlte Bestellungen anzeigen, für welche die Überweisung noch aussteht."
      ],
      "Not wired": [
        "Nicht überwiesen"
      ],
      "Only display orders that have already been transferred by the payment service provider": [
        "Nur Bestellungen anzeigen, die vom Zahlungsdienst bereits an das Händlerbankkonto überwiesen wurden"
      ],
      "Completed": [
        "Überwiesen"
      ],
      "Remove all filters": [
        "Alle Filter aufheben"
      ],
      "Clear date filter": [
        "Datumsfilter aufheben"
      ],
      "Jump to date (%1$s)": [
        "Springe zum Datum (%1$s)"
      ],
      "Gone.": [
        "Nicht mehr vorhanden."
      ],
      "UnavailableForLegalReasons.": [
        "Aus rechtlichen Gründen nicht verfügbar."
      ],
      "Jump to order with the given product ID": [
        "Zur Bestellung mit angegebener Artikel-ID gehen"
      ],
      "Order id": [
        "Bestellnummer"
      ],
      "Instance unknown": [
        "Unbekannte Instanz"
      ],
      "Order unknown": [
        "Unbekannte Bestellung"
      ],
      "Create order": [
        "Bestellung erzeugen"
      ],
      "The instance doesn't exist": [
        "Die Instanz existiert nicht"
      ],
      "The order doesn't exist": [
        "Die Bestellung existiert nicht"
      ],
      "Date": [
        "Datum"
      ],
      "Refund": [
        "Rückerstattung"
      ],
      "copy url": [
        "URL kopieren"
      ],
      "Load more orders after the last one": [
        "Nach der letzten Bestellung weitere laden"
      ],
      "No orders have been found matching your query!": [
        "Es wurden keine Bestellungen gefunden, die zu Ihrer Abfrage passen!"
      ],
      "Duplicated": [
        "Dupliziert"
      ],
      "This value exceeds the refundable amount.": [
        "Dieser Wert übersteigt den erstattungsfähigen Betrag."
      ],
      "Forbidden": [
        "Verboten"
      ],
      "Gone": [
        "Nicht mehr vorhanden"
      ],
      "There are pending KYC requirements.": [
        "Es sind noch KYC-Bedingungen zu erfüllen (Prüfung der wirtschaftlich Berechtigten von Konten)."
      ],
      "refund": [
        "Rückerstattung"
      ],
      "Reason": [
        "Buchungsvermerk"
      ],
      "Amount to be refunded": [
        "Zu erstattender Betrag"
      ],
      "Max refundable:": [
        "Maximale Rückerstattung:"
      ],
      "Choose one...": [
        "Bitte wählen Sie eine Option aus..."
      ],
      "Requested by the customer": [
        "Vom Käufer angefordert"
      ],
      "Other": [
        "Sonstiges"
      ],
      "Why this order is being refunded": [
        "Grund für die Erstattung dieser Bestellung"
      ],
      "More information to give context": [
        "Weitere Informationen für eine genauere Beschreibung"
      ],
      "now": [
        "jetzt"
      ],
      "This is when the time for making refund has been expired.": [
        "Zu diesem Zeitpunkt ist die Rückerstattungsfrist abgelaufen."
      ],
      "This is when the time for making the payment has been expired.": [
        "Zu diesem Zeitpunkt ist die Zahlungsfrist abgelaufen."
      ],
      "This is when the wire transfer is going to be executed by the payment service provider.": [
        "Zu diesem Zeitpunkt ist der Aufschub für die Überweisung durch den Zahlungsdienst abgelaufen."
      ],
      "This wire transfer has been notified by the payment service provider.": [
        "Diese Überweisung wurde vom Zahlungsdienst gemeldet."
      ],
      "This refund is waiting to be claimed by the customer.": [
        "Diese Rückerstattung kann vom Käufer beantragt werden."
      ],
      "This refund has been claimed by the customer.": [
        "Diese Rückerstattung wurde vom Käufer verlangt."
      ],
      "The current moment in time.": [
        "Der jetzige Zeitpunkt."
      ],
      "This refund can't be claimed because the wire transfer has already be made.": [
        "Diese Rückerstattung kann nicht mehr beantragt werden, da die Zahlung des Käufers bereits überwiesen wurde."
      ],
      "Contract terms": [
        "Vertragsbedingungen"
      ],
      "Human-readable description of the whole purchase": [
        "Für Menschen lesbare Information über den gesamten Kaufvorgang"
      ],
      "Total price for the transaction": [
        "Gesamtpreis der Transaktion"
      ],
      "URL for this purchase": [
        "URL für diesen Kauf"
      ],
      "Max fee": [
        "Höchster Gebührenbetrag"
      ],
      "Maximum total deposit fee accepted by the merchant for this contract": [
        "Maximale Einlösegeühr, die ein Verkäufer für diesen Kaufvertrag selbst tragen will"
      ],
      "Time when this contract was generated": [
        "Zeitpunkt, zu dem der Kaufvertrag erstellt wurde"
      ],
      "Payment deadline": [
        "Zahlungsfrist"
      ],
      "After this deadline, the merchant won't accept payments for the contract": [
        "Nach Ablauf dieser Frist akzeptiert ein Verkäufer für den Vertrag keinen Rechnungsausgleich (Bezahlung durch Käufer)"
      ],
      "Refund deadline": [
        "Rückerstattungsfrist"
      ],
      "After this deadline has passed, no refunds will be accepted.": [
        "Nach Ablauf dieser Frist werden keine Rückerstattungen mehr akzeptiert."
      ],
      "Wire transfer deadline": [
        "Überweisungsfrist"
      ],
      "Transfer deadline for the exchange": [
        "Frist der Überweisung vom Zahlungsdienstleister an das Bankkonto"
      ],
      "Time indicating when the order should be delivered": [
        "Zeitangabe, wann die Bestellung geliefert werden soll"
      ],
      "Where the order will be delivered": [
        "Zustelladresse der Bestellung"
      ],
      "Auto-refund delay": [
        "Zeitliche Verzögerung der automatischen Rückerstattung"
      ],
      "How long the wallet should try to get an automatic refund for the purchase": [
        "So lange sollte ein Wallet versuchen, eine automatische Rückerstattung auf den Kaufvertrag zu erhalten"
      ],
      "Extra info": [
        "Weitere Informationen"
      ],
      "Extra data that is only interpreted by the merchant frontend": [
        "Zusätzliche Daten, die nur im Verkäufer-Frontend verarbeitet werden"
      ],
      "order created": [
        "Die Bestellung wurde angelegt"
      ],
      "pay deadline": [
        "Zahlungsfrist"
      ],
      "refund deadline": [
        "Rückerstattungsfrist"
      ],
      "delivery": [
        "Lieferung"
      ],
      "Order": [
        "Bestellung"
      ],
      "Claimed": [
        "Schon für jemanden reserviert"
      ],
      "Claimed at": [
        "Reserviert für"
      ],
      "Timeline": [
        "Zeitleiste"
      ],
      "Payment details": [
        "Zahlungsdetails"
      ],
      "Order status": [
        "Bestellstatus"
      ],
      "Unpaid": [
        "Noch nicht bezahlt"
      ],
      "Product list": [
        "Artikelliste"
      ],
      "refund missed: %1$s": [
        "Nicht verlangte Rückerstattung: %1$s"
      ],
      "refund missed: %1$s: %2$s": [
        "Nicht verlangte Rückerstattung: %1$s: %2$s"
      ],
      "refund created: %1$s": [
        "Rückerstattung gewährt: %1$s"
      ],
      "refund created: %1$s: %2$s": [
        "Rückerstattung gewährt: %1$s: %2$s"
      ],
      "refund taken: %1$s": [
        "Dem Käufer zugegangene Rückerstattung: %1$s"
      ],
      "refund taken: %1$s: %2$s": [
        "Dem Käufer zugegangene Rückerstattung: %1$s: %2$s"
      ],
      "The contract terms has a v1 order without choices_index.": [
        "Die Vertragsbedingungen haben eine Bestellung der Version v1 (ohne choices_index)."
      ],
      "The contract terms has a v1 order with a bad choices_index.": [
        "Die Vertragsbedingungen haben eine Bestellung der Version v1 (mit einem schlechten choices_index)."
      ],
      "wired %1$s": [
        "überwiesen %1$s"
      ],
      "wire deadline": [
        "Überweisungszeitpunkt"
      ],
      "Wired": [
        "Überwiesen"
      ],
      "Refund order": [
        "Zahlbetrag der Bestellung zurückerstatten"
      ],
      "Not refundable": [
        "Nicht erstattungsfähig"
      ],
      "Next event in": [
        "Nächster Event in"
      ],
      "The order was wired.": [
        "Die Zahlung wurde überwiesen."
      ],
      "Bank processing can take a few business days, depending on your bank.": [
        "Die Verarbeitung der Überweisung kann je nach Finanzinstitut einige Bankarbeitstage dauern."
      ],
      "Refunded amount": [
        "Rückerstattungsbetrag"
      ],
      "Refund taken": [
        "Erhaltener Rückerstattungsbetrag"
      ],
      "Status URL": [
        "Status-URL"
      ],
      "Refund URI": [
        "Rückerstattungs-URI"
      ],
      "Pay at": [
        "Zahlungs-URL"
      ],
      "Order status URL": [
        "Bestellstatus-URL"
      ],
      "Payment URI": [
        "Zahlungs-URI"
      ],
      "Unknown order status. This is an error, please contact the administrator.": [
        "Unbekannter Bestellstatus. Dies ist ein Fehler, bitte kontaktieren Sie den Administrator."
      ],
      "Invalid. Please enter letters and numbers only.": [
        "Ungültig. Bitte geben Sie nur Buchstaben und Zahlen ein."
      ],
      "Just letters and numbers from 2 to 7": [
        "Nur Buchstaben und Zahlen von 2 bis 7"
      ],
      "The size of the key must be 32 characters": [
        "Die Schlüssellänge muss 32 Zeichen betragen"
      ],
      "Internal ID on the system": [
        "Interne ID auf dem System"
      ],
      "Useful to identify the device physically": [
        "Dies ist nützlich, um das Gerät physisch zu identifizieren"
      ],
      "Verification algorithm": [
        "Überprüfungsalgorithmus"
      ],
      "Algorithm used to verify transactions in offline mode": [
        "Algorithmus zum Überprüfen von Transaktionen im Offline-Modus"
      ],
      "Device key": [
        "Geräteschlüssel (Device key)"
      ],
      "Be sure to choose a password that is hard to guess, or use the random generator.": [
        "Das Passwort muss schwer zu erraten sein - andernfalls verwenden Sie den Zufallszahlengenerator."
      ],
      "Your device needs to match exactly the same value": [
        "Ihr Gerät muss genau das gleiche Ergebnis anzeigen"
      ],
      "Generate random secret key": [
        "Zufälligen privaten Schlüssel erzeugen"
      ],
      "Random": [
        "Zufallsbasiert"
      ],
      "Create another": [
        "Weitere erzeugen"
      ],
      "You can scan the next QR code with your device or save the key before continuing.": [
        "Sie können den nächsten QR-Code mit Ihrem Gerät scannen oder den Schlüssel speichern, bevor Sie fortfahren."
      ],
      "OTP devices": [
        "OTP-Geräte"
      ],
      "Delete selected devices from the database": [
        "Ausgewählte Geräte aus der Datenbank entfernen"
      ],
      "There are no devices to list yet, add more by pressing the + sign": [
        "Es gibt noch keine Geräte. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Template id is unknown": [
        "Die Vorlagen-ID ist unbekannt"
      ],
      "The provided information is inconsistent with the current state of the template": [
        "Die bereitgestellten Informationen stimmen nicht mit dem aktuellen Stand der Vorlage überein"
      ],
      "Device:": [
        "Gerät:"
      ],
      "Algorithm to use to verify transactions in offline mode": [
        "Algorithmus zum Überprüfen von Transaktionen im Offline-Modus"
      ],
      "Not modified": [
        "Unverändert"
      ],
      "Be sure to be very hard to guess or use the random generator": [
        "Das Passwort muss schwer zu erraten sein oder aus einem Zufallszahlengenerator stammen"
      ],
      "Your device need to have exactly the same value": [
        "Ihr Gerät muss genau das gleiche Ergebnis anzeigen"
      ],
      "Change key": [
        "Schlüssel ändern"
      ],
      "Is not the same": [
        "ungleich"
      ],
      "You are updating the password for the instance with ID \"%1$s\"": [
        "Sie erneuern nun das Passwort für die Instanz mit der ID \"%1$s\""
      ],
      "In order to verify that you have access.": [
        "Um zu überprüfen, ob der Zugang gewährt wird."
      ],
      "Confirm change": [
        "Änderung bestätigen"
      ],
      "Testing password change": [
        "Die Passwortänderung wird überprüft"
      ],
      "Password changed": [
        "Passwort geändert"
      ],
      "The current password is wrong.": [
        "Das aktuelle Passwort ist falsch."
      ],
      "No enough rights to change the password.": [
        "Es bestehen keine ausreichenden Rechte, um das Passwort zu ändern."
      ],
      "Account not found.": [
        "Das Bankkonto wurde nicht gefunden."
      ],
      "Add element to the list": [
        "Ein Element zur Liste hinzufügen"
      ],
      "Click here to configure the product's stock. If left as is, the backend will not control stock.": [
        "Klicken Sie hier, um den Lagerbestand des Artikels zu konfigurieren. Falls dieses Programm den Bestand nicht überwachen soll, lassen Sie seine Grundeinstellung unverändert."
      ],
      "Manage stock": [
        "Bestand verwalten"
      ],
      "This product has been configured without stock control": [
        "Dieser Artikel wurde ohne Bestandskontrolle angelegt"
      ],
      "Infinite": [
        "Unbegrenzt"
      ],
      "Shrinkage cannot exceed the current stock and incoming supplies (maximum %1$s)": [
        "Der Schwund kann nicht den aktuellen Bestand und die Menge der Zulieferung übersteigen (maximal %1$s)"
      ],
      "Incoming": [
        "Neu zugehend"
      ],
      "Lost": [
        "Abgehend (z.B. Schwund)"
      ],
      "Current": [
        "Aktuell"
      ],
      "Remove stock control for this product": [
        "Bestandskontrolle für diesen Artikel entfernen"
      ],
      "without stock": [
        "ohne Bestand"
      ],
      "Next restock": [
        "Nächste Anlieferung"
      ],
      "Warehouse address": [
        "Adresse des Lagers"
      ],
      "Invalid amount": [
        "Kein gültiger Betrag"
      ],
      "Product identification to use in URLs (for internal use only).": [
        "Produktidentifikation zur Nutzung in URLs (nur für den internen Gebrauch)."
      ],
      "Illustration of the product for customers.": [
        "Abbildung des Artikels für Kunden."
      ],
      "Product name.": [
        "Artikelbezeichnung."
      ],
      "Product description for customers.": [
        "Artikelbeschreibung, die Kunden zu sehen bekommen."
      ],
      "Age restriction": [
        "Altersbeschränkung"
      ],
      "Is this product restricted for customer below certain age?": [
        "Besteht für diesen Artikel eine Verkaufsbeschränkung unterhalb eines bestimmten Alters?"
      ],
      "Minimum age of the customer": [
        "Mindestalter von Käufern"
      ],
      "Unit describing quantity of product sold (e.g. 2 kilograms, 5 liters, 3 items, 5 meters) for customers.": [
        "Die den Käufern angezeigte Mengeneinheit des Artikels im Verkauf (z.B. 2 Kilogramm, 5 Liter, 3 Stück, 5 Meter)."
      ],
      "Example: kg, items or liters": [
        "Beispiel: kg, Stück oder Liter"
      ],
      "Sale price for customers, including taxes, for above units of the product.": [
        "Verkaufspreis an Endkunden, inklusive Steuern, für jede oben genannte Mengeneinheit des Artikels."
      ],
      "Stock": [
        "Bestand"
      ],
      "Inventory for products with finite supply (for internal use only).": [
        "Lagerbestand für Artikel mit begrenztem Vorrat (nur für den internen Gebrauch)."
      ],
      "Taxes included in the product price, exposed to customers.": [
        "Im Artikelpreis enthaltene Steuern, die den Käufern angezeigt werden."
      ],
      "Search by category description or id": [
        "Nach Kategoriebeschreibung oder -ID suchen"
      ],
      "Categories where this product will be listed on.": [
        "Kategorien, in denen dieser Artikel aufgeführt sein wird."
      ],
      "Money pot": [
        ""
      ],
      "Search by money pot description or id": [
        "Nach Artikelbeschreibung oder Artikel-ID suchen"
      ],
      "Money pots where this product will be listed on.": [
        "Kategorien, in denen dieser Artikel aufgeführt sein wird."
      ],
      "Select one": [
        "Wählen Sie ein Konto"
      ],
      "Group": [
        ""
      ],
      "Search by group name or id": [
        "Nach Artikelbeschreibung oder Artikel-ID suchen"
      ],
      "The instance doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The category doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The product group doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "The money pot doesn't exist. Maybe it was remove while adding the product.": [
        ""
      ],
      "Add product to inventory": [
        "Artikel zum Lagerbestand hinzufügen"
      ],
      "Product not found.": [
        "Der Artikel wurde nicht gefunden."
      ],
      "This change was made without outdated info.": [
        "Diese Änderung wurde ohne bisher bekannte Daten durchgeführt."
      ],
      "Sales": [
        "Sales"
      ],
      "Sold": [
        "Verkauft"
      ],
      "Free": [
        "Kostenlos"
      ],
      "Go to product update page": [
        "Zur Seite der Artikelaktualisierung gehen"
      ],
      "Update": [
        "Aktualisieren"
      ],
      "Remove this product from the database": [
        "Diesen Artikel aus der Datenbank entfernen"
      ],
      "Update the product with new price": [
        "Artikel mit neuem Preis aktualisieren"
      ],
      "Update product with new price": [
        "Artikel mit neuem Verkaufspreis aktualisieren"
      ],
      "Confirm update": [
        "Aktualisierung bestätigen"
      ],
      "lost can't be greater that current + incoming (max %1$s)": [
        "Der Schwund kann nicht größer sein als der aktuelle Bestand und die Menge der Zulieferung (max %1$s)"
      ],
      "Add more elements to the inventory": [
        "Mehr Elemente zum Lagerbestand hinzufügen"
      ],
      "Report elements lost in the inventory": [
        "Aus dem Lagerbestand verlorene Elemente melden"
      ],
      "New price for the product": [
        "Neuer Preis für den Artikel"
      ],
      "There are values with errors.": [
        "Einige Werte sind fehlerhaft."
      ],
      "Update product with new stock and price": [
        "Artikel mit neuem Bestand und Preis aktualisieren"
      ],
      "There are no products to list yet, add more by pressing the + sign": [
        "Es gibt noch keine Artikel. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Product (ID: %1$s) has been deleted": [
        "Der Artikel (ID: %1$s) wurde gelöscht"
      ],
      "Jump to product with the given product ID": [
        "Zum Artikel mit der angegebenen Artikel-ID springen"
      ],
      "Product id": [
        "Artikel-ID"
      ],
      "Delete product": [
        "Artikel löschen"
      ],
      "Delete the product \"%1$s\"": [
        "Artikel \"%1$s\" löschen"
      ],
      "If you delete the product named %1$s (ID: %2$s ), the stock and related information will be lost": [
        "Wenn Sie den Artikel mit der Bezeichnung %1$s (ID: %2$s) löschen, gehen seine Bestandsdaten und alle zugehörigen Informationen verloren"
      ],
      "Deleting a product cannot be undone.": [
        "Das Löschen eines Artikels kann nicht rückgängig gemacht werden."
      ],
      "Product id:": [
        "Artikel-ID:"
      ],
      "Your browser does not support the canvas element.": [
        "Ihr Browser unterstützt nicht das Canvas-Element."
      ],
      "Bad gateway": [
        "502 Bad gateway"
      ],
      "Service unavailable": [
        "Der Dienst ist nicht verfügbar"
      ],
      "Select date from which to show statistics": [
        "Bitte wählen Sie das Datum, ab dem die Statistik angezeigt werden soll"
      ],
      "Show chart": [
        "Diagramm anzeigen"
      ],
      "Orders chart": [
        "Bestellungen als Diagramm"
      ],
      "Show table": [
        "Tabelle anzeigen"
      ],
      "Orders table": [
        "Tabellarische Übersicht der Bestellungen"
      ],
      "Start from (%1$s)": [
        "Start von (%1$s)"
      ],
      "Orders statistics": [
        "Statistik der Bestellungen"
      ],
      "Since": [
        "Seit"
      ],
      "No order statistics yet.": [
        "Es wurde noch keine Bestellstatistik erstellt."
      ],
      "# of orders since": [
        "Anzahl der Bestellungen seit"
      ],
      "hour": [
        "Stunde"
      ],
      "day": [
        "Tag"
      ],
      "week": [
        "Woche"
      ],
      "weeks": [
        "Wochen"
      ],
      "month": [
        "Monat"
      ],
      "months": [
        "Monate"
      ],
      "quarter": [
        "Quartal"
      ],
      "quarters": [
        "Quartale"
      ],
      "years": [
        "Jahre"
      ],
      "Revenue chart": [
        "Umsatzdiagramm"
      ],
      "Revenue table": [
        "Tabellarische Übersicht der Umsätze"
      ],
      "Revenue statistics filter": [
        "Umsatzstatistik-Filter"
      ],
      "Time range": [
        "Zeitraum"
      ],
      "Select time range to group dataset by": [
        "Wählen Sie den Zeitraum für die Darstellung der Daten"
      ],
      "Select the number of ranges to include in data set": [
        "Wählen Sie die Anzahl der Zeiträume für die Datensätze, die angezeigt werden sollen"
      ],
      "Currency": [
        "Währung"
      ],
      "Select the currency to show statistics for": [
        "Bitte wählen Sie die Währung, für die Statistiken angezeigt werden sollen"
      ],
      "Revenue statistics over the past %1$s %2$s for currency '%3$s'": [
        "Umsatzstatistik der letzten %1$s %2$s für Währung '%3$s'"
      ],
      "Start time": [
        "Beginn"
      ],
      "No revenue statistics yet.": [
        "Es wurde noch keine Umsatzstatistik erstellt."
      ],
      "Revenue": [
        "Umsätze (Einnahmen)"
      ],
      "Must be greater that 0": [
        "Dieser Wert muss größer als Null sein"
      ],
      "Too short": [
        "Zu kurz"
      ],
      "You don't have enough permissions.": [
        "Sie haben keine ausreichende Berechtigung."
      ],
      "There is a template with this identifier, please choose another one.": [
        "Es gibt bereits eine Vorlage mit dieser Kennung, bitte wählen Sie eine andere."
      ],
      "Identifier": [
        "Eindeutige Kennung"
      ],
      "Name of the template in URLs.": [
        "Name der Vorlage in URLs."
      ],
      "Template name": [
        "Name der Vorlage"
      ],
      "Describe what this template stands for": [
        "Beschreiben Sie, wofür diese Vorlage stehen soll"
      ],
      "Order summary": [
        "Zusammenfassung der Bestellung"
      ],
      "If specified here, this template will create orders with the same summary": [
        "Falls angegeben, wird diese Vorlage Bestellungen mit der gleichen Zusammenfassung erzeugen"
      ],
      "Summary is editable": [
        "Die Zusammenfassung kann umgeschrieben werden"
      ],
      "Allow the user to change the summary.": [
        "Den Nutzern die Bearbeitung der Zusammenfassung erlauben."
      ],
      "If specified here, this template will create orders with the same price": [
        "Diese Vorlage wird Bestellungen zum stets gleichen Preis erzeugen"
      ],
      "Amount is editable": [
        "Der Betrag lässt sich verändern"
      ],
      "Allow the user to select the amount to pay.": [
        "Den Nutzern die Auswahl des Zahlbetrags erlauben."
      ],
      "Currency is editable": [
        "Die Währung ist veränderbar"
      ],
      "Allow the user to change currency.": [
        "Den Nutzern die Änderung der Währung erlauben."
      ],
      "Supported currencies": [
        "Unterstützte Währungen"
      ],
      "Supported currencies: %1$s": [
        "Unterstützte Währungen: %1$s"
      ],
      "Minimum age": [
        "Mindestalter"
      ],
      "Is this contract restricted to some age?": [
        "Verlangt dieser Kaufvertrag ein bestimmtes Mindestalter?"
      ],
      "Payment timeout": [
        "Die Zahlungsfrist ist verstrichen nach"
      ],
      "How much time the customer has to complete the payment once the order was created.": [
        "Wie lange der Käufer Zeit hat, um zu bezahlen, nachdem die Bestellung angelegt wurde."
      ],
      "OTP device": [
        "OTP-Gerät"
      ],
      "Use to verify transactions in offline mode.": [
        "Verwenden zum Überprüfen von Transaktionen im Offline-Modus."
      ],
      "No OTP device.": [
        "Kein OTP-Gerät."
      ],
      "Add one first": [
        "Fügen Sie zuerst ein erstes hinzu"
      ],
      "No device": [
        "Kein Gerät"
      ],
      "Add new templates": [
        "Neue Vorlagen hinzufügen"
      ],
      "Load more templates before the first one": [
        "Mehrere Vorlagen vor der ersten laden"
      ],
      "Delete selected templates from the database": [
        "Ausgewählte Vorlagen aus der Datenbank löschen"
      ],
      "Use template to create new order": [
        "Vorlage verwenden, um eine neue Bestellung anzulegen"
      ],
      "Generate a QR code for the template.": [
        "QR-Code für die Vorlage erstellen."
      ],
      "Show QR": [
        "QR-Code anzeigen"
      ],
      "Load more templates after the last one": [
        "Weitere Vorlagen nach der letzten laden"
      ],
      "There are no templates to list yet, add more by pressing the + sign": [
        "Es gibt noch keine Vorlagen. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Jump to template with the given template ID": [
        "Zur Vorlage mit der angegebenen Vorlagen-ID springen"
      ],
      "Template identification": [
        "Vorlagenidentifikation"
      ],
      "Delete template": [
        "Vorlage löschen"
      ],
      "Delete the template \"%1$s\"": [
        "Vorlage \"%1$s\" löschen"
      ],
      "If you delete the template %1$s (ID: %2$s) you may loose information": [
        "Wenn Sie die Vorlage %1$s (ID: %2$s) löschen, können Information verlorengehen"
      ],
      "Deleting a template cannot be undone.": [
        "Das Löschen einer Vorlage kann nicht rückgängig gemacht werden."
      ],
      "Print": [
        "Drucken"
      ],
      "The template configuration needs to be fixed.": [
        "Die Detaileinstellung der Vorlage muss korrigiert werden."
      ],
      "The currency of the template is %1$s and is not in the list of supported currencies.": [
        "Die Währung der Vorlage lautet %1$s, steht aber nicht in der Liste der unterstützten Währungen."
      ],
      "If specified, this template will create order with the same summary": [
        "Falls angegeben, wird diese Vorlage Bestellungen mit der gleichen Zusammenfassung erzeugen"
      ],
      "If specified, this template will create orders with the same price": [
        "Diese Vorlage wird Bestellungen zum stets gleichen Preis erzeugen"
      ],
      "How much time has the customer to complete the payment once the order was created.": [
        "Dies bestimmt die Zeitdauer zur Bezahlung nach einer erfolgten Bestellung."
      ],
      "An amount is required": [
        "Ein Betrag ist erforderlich"
      ],
      "An order summary is required": [
        "Eine Zusammenfassung der Bestellung ist erforderlich"
      ],
      "No more stock for product with ID \"%1$s\".": [
        "Es gibt keinen Bestand für den Artikel mit der ID \"%1$s\"."
      ],
      "New order from template": [
        "Neue Bestellung aus einer Vorlage erzeugen"
      ],
      "Amount of the order": [
        "Summe der Bestellung"
      ],
      "Slug": [
        "Slug (benutzer- und suchmaschinenfreundlicher Text als Bestandteil einer URL)"
      ],
      "Token family slug to use in URLs (for internal use only)": [
        "Slug der Token-Familie zur Benutzung in URLs (nur für interne Zwecke)"
      ],
      "Kind": [
        "Art"
      ],
      "Choose between a discount and a subscription": [
        ""
      ],
      "Start Date": [
        "Ende"
      ],
      "The first day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, it cannot be used before this date.": [
        ""
      ],
      "Expiration Date": [
        "Wird ungültig zum Zeitpunkt"
      ],
      "The last day the coupon/subscription can be used.": [
        ""
      ],
      " If set to %1$s, they are no longer valid from %2$s.": [
        ""
      ],
      "How long the coupon/subscription remains valid after being activated.": [
        ""
      ],
      "If you activate it on %1$s with duration of 30 days, it remains valid until %2$s.": [
        ""
      ],
      "Validity Granularity": [
        "Rundungsgenauigkeit des Gültigkeitszeitraums"
      ],
      "Rounds the validity to a specific unit of time (like day, hour, minute).": [
        ""
      ],
      " If set to “1 day”, a 30-day pass bought on %1$s is valid until the end of %2$s, not exactly at the same time of day you purchased it.": [
        ""
      ],
      "Token Families": [
        "Tokenfamilien"
      ],
      "Add token family": [
        "Tokenfamilie hinzufügen"
      ],
      "Valid Before": [
        "Gültig vor"
      ],
      "Go to token family update page": [
        "Zur Aktualisierungsseite für Tokenfamilien gehen"
      ],
      "Remove this token family from the database": [
        "Diese Token aus der Datenbank entfernen"
      ],
      "There are no token families yet, add the first one by pressing the + sign.": [
        "Es sind noch keine Token-Familien angelegt. Sie können diese mit dem +-Zeichen hinzufügen."
      ],
      "Token family has been deleted.": [
        "Die Tokenfamilie wurde gelöscht."
      ],
      "Delete token family": [
        "Tokenfamilie löschen"
      ],
      "Delete the token family \"%1$s\"": [
        "Tokenfamilie \"%1$s\" löschen"
      ],
      "If you delete the %1$s token family (Slug: %2$s), all issued tokens will become invalid.": [
        "Wenn Sie die Tokenfamilie %1$s (SLUG: %2$s) löschen, werden alle ausgestellten Token ungültig."
      ],
      "Deleting a token family %1$s .": [
        "Tokenfamilie %1$s wird gelöscht."
      ],
      "can't be undone": [
        "Das kann nicht rückgängig gemacht werden"
      ],
      "Token Family: %1$s": [
        "Tokenfamilie: %1$s"
      ],
      "User-readable token family name": [
        "Benutzerfreundliche Bezeichnung der Tokenfamilie"
      ],
      "Token family description for customers": [
        "Tokenfamilien-Beschreibung für Kunden"
      ],
      "Incoming wire transfers": [
        "Erwartete Überweisungen"
      ],
      "Load more wire transfers preceding the first one": [
        "Weitere Überweisungen vor der ersten laden"
      ],
      "Expected credit": [
        "Erwartete Gutschrift"
      ],
      "Confirmed": [
        "Bestätigt"
      ],
      "Validated": [
        "Überprüft (validiert)"
      ],
      "Executed on": [
        "Ausführungsdatum"
      ],
      "yes": [
        "ja"
      ],
      "no": [
        "nein"
      ],
      "never": [
        "nie"
      ],
      "unknown": [
        "unbekannt"
      ],
      "Load more transfers after the last one": [
        "Mehr Überweisungen nach der letzten laden"
      ],
      "Verified wire transfers": [
        "Überprüfte und bestätigte Überweisungen"
      ],
      "There are no transfers to list yet, add more by pressing the + sign": [
        "Es gibt noch keine Überweisungen anzuzeigen. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "All accounts": [
        "Alle Konten"
      ],
      "Filter by account address": [
        "Filtern nach Kontoadressen"
      ],
      "Only display transfers that have already been transferred to your bank account by the payment service provider.": [
        "Nur Überweisungen anzeigen, die vom Zahlungsdienst bereits an Ihr Bankkonto überwiesen wurden."
      ],
      "Only show wire transfers confirmed by the merchant": [
        "Nur Überweisungen anzeigen, die vom Verkäufer als auf dem Bankkonto eingegangen bestätigt sind"
      ],
      "Verified": [
        "Verifizierte (bestätigte) Überweisungen"
      ],
      "Wire transfer already confirmed.": [
        "Die Überweisung ist bereits bestätigt."
      ],
      "I have received the wire transfer": [
        "Ich habe die Überweisung erhalten"
      ],
      "Confirm the wire transfer": [
        "Bestätigen der Überweisung"
      ],
      "The wire transfer has been sent and should be in your bank account in any time. You can manually confirm the reception using the information below.": [
        "Die Überweisung wurde ausgeführt und sollte in Kürze auf Ihrem Bankkonto eingehen. Mithilfe der unten stehenden Informationen können Sie die Gutschrift manuell überprüfen und bestätigen."
      ],
      "Time": [
        "Zeit"
      ],
      "Transfer ID": [
        "Transfer-ID"
      ],
      "It's not the same.": [
        "Dies stimmt nicht überein."
      ],
      "You are deleting the instance with ID \"%1$s\"": [
        "Sie löschen nun die Instanz mit der ID \"%1$s\""
      ],
      "Instance": [
        "Instanz"
      ],
      "Write the instance name to confirm the deletion": [
        "Schreiben Sie den Namen der Instanz hier hinein, um die Löschung zu bestätigen"
      ],
      "Purge": [
        "Vollständig verwerfen"
      ],
      "All the data will be fully deleted, otherwise only the access will be removed.": [
        "Alle Daten werden vollständig gelöscht, andernfalls wird nur der Zugang entfernt."
      ],
      "DELETE": [
        "LÖSCHEN"
      ],
      "Instance id": [
        "Instanz-ID"
      ],
      "Delete this instance": [
        "Löschung dieser Instanz"
      ],
      "Must be one of '%1$s'": [
        "Muss eines von '%1$s' sein"
      ],
      "URL is invalid": [
        "URL ist ungültig"
      ],
      "Webhook ID to use": [
        "zu verwendende Webhook-ID"
      ],
      "Event": [
        "Event"
      ],
      "Payment": [
        "Zahlung"
      ],
      "Order settled": [
        "Die Bestellung wurde bezahlt und dem Konto gutgeschrieben"
      ],
      "Category added": [
        "Kategorie hinzugefügt"
      ],
      "Category updated": [
        "Die Kategorie wurde aktualisiert"
      ],
      "Inventory added": [
        "Der Bestand wurde hinzugefügt"
      ],
      "Inventory updated": [
        "Der Bestand wurde aktualisiert"
      ],
      "Inventory deleted": [
        "Bestand gelöscht"
      ],
      "The event of the webhook: why the webhook is used": [
        "Event (Anlass, Bedingung) für einen Webhook, um durch diesen nachfolgende Prozesse auszulösen"
      ],
      "Method": [
        "Methode"
      ],
      "GET": [
        "GET"
      ],
      "POST": [
        "POST"
      ],
      "PUT": [
        "PUT"
      ],
      "PATCH": [
        "PATCH"
      ],
      "HEAD": [
        "HEAD"
      ],
      "Method used by the webhook": [
        "Methode, die der Webhook verwendet"
      ],
      "URL": [
        "URL"
      ],
      "URL of the webhook where the customer will be redirected": [
        "URL des Webhooks, zu der die Käufer nach der Bezahlung weitergeleitet werden"
      ],
      "The text below supports the %1$s template engine. Any string between %2$s and %3$s will be replaced with the value of the corresponding variable.": [
        "Der folgende Text unterstützt %1$s Vorlagen-Ersteller. Jede Zeichenkette zwischen %2$s und %3$s wird durch den Wert der entsprechenden Variablen ersetzt."
      ],
      "For example, %1$s will be replaced with the the order's price.": [
        "Beispielsweise wird %1$s durch den Bestellwert ersetzt."
      ],
      "The short list of variables are:": [
        "Einige der Variablen sind:"
      ],
      "order's description": [
        "Beschreibung der Bestellung"
      ],
      "order's price": [
        "Gesamtpreis der Bestellung"
      ],
      "order's unique identification": [
        "Laufende Nummer der Bestellung"
      ],
      "the amount that was being refunded": [
        "Der erstattete Betrag"
      ],
      "the reason entered by the merchant staff for granting the refund": [
        "Der vom Personal des Verkäufers angegebene Grund für die Gewährung einer Erstattung"
      ],
      "time of the refund in nanoseconds since 1970": [
        "Zeitpunkt der Erstattung in Nanosekunden seit 1970"
      ],
      "Http header": [
        "HTTP-Header"
      ],
      "Header template of the webhook": [
        "Vorlage für den Webhook-Header"
      ],
      "Http body": [
        "HTTP-Body"
      ],
      "Body template used by the webhook.": [
        "Vorlage für den Webhook-Body."
      ],
      "Webhook deleted successfully": [
        "Webhook wurde erfolgreich gelöscht"
      ],
      "Add new webhooks": [
        "Neue Webhooks hinzufügen"
      ],
      "Load more webhooks before the first one": [
        "Mehr Webhooks vor dem ersten laden"
      ],
      "Event type": [
        "Event-Typ"
      ],
      "Delete selected webhook from the database": [
        "Ausgewählten Webhook aus der Datenbank löschen"
      ],
      "Load more webhooks after the last one": [
        "Mehr Webhooks nach dem letzten laden"
      ],
      "There are no webhooks to list yet, add more by pressing the + sign": [
        "Es gibt noch keine Webhooks. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Webhook updated": [
        "Webhook aktualisiert"
      ],
      "Header": [
        "Header"
      ],
      "Body": [
        "Body"
      ],
      "Body template used by the webhook": [
        "Vorlage, die für den Webhook-Body verwendet wird"
      ],
      "There is another instance with this username.": [
        "Es besteht bereits eine andere Instanz mit diesem Benutzernamen."
      ],
      "Self provision": [
        "Erstellen Sie Ihr eigenes Konto im Taler-Händlerportal"
      ],
      "Phone": [
        "Telefon"
      ],
      "Contact phone number": [
        "Telefonnummer für allgemeinen Kontakt"
      ],
      "Accept the Terms of service": [
        "Allgemeine Geschäftsbedingungen"
      ],
      "I understand and agree to the %1$s": [
        "Ich verstehe und akzeptiere die %1$s"
      ],
      "Terms of service": [
        "Allgemeine Geschäftsbedingungen"
      ],
      "You must accept the Terms of service to continue.": [
        "Um fortzufahren müssen Sie zuerst die Allgemeinen Geschäftsbedingungen dieser Verwaltungssoftware akzeptieren."
      ],
      "Create": [
        "Anlegen"
      ],
      "The instance is not properly configured to allow MFA.": [
        ""
      ],
      "The instance \"%1$s\" was not found.": [
        "Die Instanz \"%1$s\" wurde nicht gefunden."
      ],
      "Resetting access to the instance \"%1$s\"": [
        "Zurücksetzen des Zugangs zur Instanz \"%1$s\""
      ],
      "Reset": [
        "Zurücksetzen"
      ],
      "Language": [
        "Sprache"
      ],
      "Date format": [
        "Datumsformat"
      ],
      "How the date is going to be displayed": [
        "Wie das Datum angezeigt wird"
      ],
      "Merchant type": [
        "Merchant-Typus"
      ],
      "Simplify UI based on the user usage.": [
        "Passen Sie hier den Komplexitätsgrad der Benutzeroberfläche für verschiedene Benutzer an."
      ],
      "Expert user": [
        "Erfahrener Benutzer (expert user)"
      ],
      "Taler developer": [
        "Entwickler (Taler developer)"
      ],
      "Unattended in-person offline vending": [
        "Personalloser Verkauf, z.B. Hofläden mit Vertrauenskassen (Unattended in-person offline vending)"
      ],
      "In-person online point-of-sale with inventory": [
        "Verkaufsstelle mit Internetzugang und Bestandserfassung (In-person online point-of-sale with inventory)"
      ],
      "Digital publishing": [
        "Vertrieb digitaler Güter (Digital publishing)"
      ],
      "E-commerce site": [
        "Onlineshops (E-commerce site)"
      ],
      "Developer mode": [
        "Entwicklermodus"
      ],
      "Only use developer mode if you know how the application works. Some features enabled in this mode are still under testing.": [
        "Verwenden Sie den Entwicklermodus nur, wenn Sie wissen, wie die Anwendung funktioniert. Einige der in diesem Modus aktivierten Funktionen befinden sich noch in der Testphase."
      ],
      "Money pot deleted": [
        "Bestand gelöscht"
      ],
      "Add new pots": [
        "Neue Vorlagen hinzufügen"
      ],
      "Load more pots before the first one": [
        "Mehrere Vorlagen vor der ersten laden"
      ],
      "Total": [
        "Gesamtpreis"
      ],
      "Delete selected pots from the database": [
        "Löschen ausgewählter Konten von der Datenbank"
      ],
      "Load more pots after the last one": [
        "Weitere Artikel nach dem letzten laden"
      ],
      "There are no money pots yet, add more pressing the + sign": [
        "Es sind noch keine Konten angelegt, Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Missing currency name": [
        ""
      ],
      "Currency name must be only letters": [
        ""
      ],
      "Value can only by number": [
        ""
      ],
      "The value is too high": [
        ""
      ],
      "The value is too precise": [
        "Wert auf „nie“ setzen"
      ],
      "Invalid amount \"%1$s\": %2$s": [
        "Ungültiger Betrag \"%1$s\": %2$s"
      ],
      "Descripton": [
        "Beschreibung"
      ],
      "Totals": [
        "Gesamte Artikelmenge"
      ],
      "There is already a money pot with the same id.": [
        "Es besteht bereits eine andere Instanz mit diesem Benutzernamen."
      ],
      "Product group deleted": [
        "Artikelliste"
      ],
      "Add new group": [
        "Neues Konto hinzufügen"
      ],
      "Load more groups before the first one": [
        "Mehr Webhooks vor dem ersten laden"
      ],
      "Delete selected group from the database": [
        "Löschen ausgewählter Konten von der Datenbank"
      ],
      "Load more groups after the last one": [
        "Weitere Artikel nach dem letzten laden"
      ],
      "There are no product groups yet, add more pressing the + sign": [
        "Es gibt noch keine Artikel. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "Scheduled report deleted": [
        ""
      ],
      "Scheduled reports": [
        ""
      ],
      "Add new reports": [
        "Neue Vorlagen hinzufügen"
      ],
      "Frequency": [
        ""
      ],
      "Delete selected scheduled report from the database": [
        "Ausgewählte Kategorie aus der Datenbank löschen"
      ],
      "There are no reports yet, add more pressing the + sign": [
        "Es gibt noch keine Kategorien. Sie können diese mit dem +-Zeichen hinzufügen"
      ],
      "No report generator configured in the server": [
        "Auf dem Server ist kein Berichtsgenerator eingerichtet."
      ],
      "Contact the system administrator to create a report generator before scheduling one.": [
        "Bitte wenden Sie sich an die Systemadministration, um einen Berichtsgenerator einzurichten, bevor Sie einen Bericht planen."
      ],
      "Description of the report. Possibly included in the report message": [
        "Beschreibung des Berichts. Wird möglicherweise in der Berichtsnachricht angezeigt."
      ],
      "Where the report program should send the report": [
        "Wohin das Berichtssystem den Bericht senden soll."
      ],
      "Source": [
        "Quelle"
      ],
      "Base URL to request the data from.": [
        "Basis‑URL, von der die Daten abgerufen werden."
      ],
      "Type of the data source": [
        "Art der Datenquelle"
      ],
      "Program": [
        "Programm"
      ],
      "Merchant backend configuration section specifying the program to use to transmit the report": [
        "Konfiguration im Merchant‑Backend, die festlegt, welches Programm zum Versenden des Berichts verwendet wird."
      ],
      "Report frequency": [
        "Berichtshäufigkeit"
      ],
      "Welcome!": [
        "Willkommen!"
      ],
      "The application is in a unexpected state and can't recover from here. You can report the problem to the developers at %1$s": [
        "Die Anwendung befindet sich in einem unerwarteten Betriebszustand. Bitte seien Sie so nett und melden das Problem den Entwicklern unter %1$s"
      ],
      "You need to associate a bank account to receive revenue.": [
        "Sie müssen ein Bankkonto verknüpfen, um Einnahmen aus Überweisungen auf dieses Konto zu erhalten."
      ],
      "Without this the merchant backend will refuse to create new orders.": [
        "Ohne dies wird Taler Merchant Backend keine neuen Bestellungen erzeugen."
      ],
      "Hide for today": [
        "Für heute nicht anzeigen"
      ],
      "KYC verification needed": [
        "Eine KYC-Überprüfung ist notwendig (Know-Your-Customer)"
      ],
      "Some transfers are on hold until the KYC process is completed. Visit the KYC section in the left-hand menu for more information.": [
        "Einige Überweisungen werden bis zum Abschluss des KYC-Prozesses zurückgehalten. Bitte gehen Sie zum KYC-Status im Hauptmenü links für weitere Informationen."
      ],
      "The request reached a timeout, check your connection.": [
        "Die Anfrage hat ihr Zeitlimit erreicht, überprüfen Sie bitte Ihre Internetverbindung."
      ],
      "The request was cancelled.": [
        "Die Anfrage wurde abgebrochen."
      ],
      "Too many requests were made to the server, and this action was throttled.": [
        "Es wurden gleichzeitig zu viele Anfragen an denselben Server gestellt, daher ist diese Aktion gedrosselt worden."
      ],
      "The server's response was malformed.": [
        "Die Antwort des Servers auf die Anfrage war fehlerhaft."
      ],
      "Could not complete the request due to a network problem.": [
        "Die Anfrage konnte aufgrund eines Netzwerkproblems nicht abgeschlossen werden."
      ],
      "Unexpected request error.": [
        "Unerwarteter Fehler bei der Anfrage."
      ],
      "Unexpected error.": [
        "Unerwarteter Fehler."
      ],
      "Add new instance": [
        "Neue Instanz hinzufügen"
      ],
      "Edit": [
        "Bearbeiten"
      ],
      "Change password": [
        "Passwort ändern"
      ],
      "There are no instances yet. Add one by pressing the '+' sign.": [
        "Es gibt noch keine Instanzen. Sie können diese mit dem +-Zeichen hinzufügen."
      ],
      "Instance \"%1$s\" (ID: %2$s) has been deleted.": [
        "Instanz \"%1$s\" (ID: %2$s) wurde gelöscht."
      ],
      "Only show active instances": [
        "Zeige nur aktive Instanzen"
      ],
      "Active": [
        "Aktiv"
      ],
      "Only show deleted instances": [
        "Zeige nur gelöschte Instanzen"
      ],
      "Deleted": [
        "Gelöscht"
      ],
      "Show all instances": [
        "Zeige alle Instanzen"
      ],
      "Delete instance": [
        "Instanz löschen"
      ],
      "Delete the instance \"%1$s\"": [
        "Instanz \"%1$s\" löschen"
      ],
      "If you delete the instance named %1$s (ID: %2$s), the merchant will no longer be able to process orders and refunds": [
        "Wenn Sie die Instanz mit der Bezeichnung %1$s (ID: %2$s) löschen, wird sie keine weiteren Bestellungen oder Rückerstattungen bearbeiten können"
      ],
      "This action deletes the instance's private key, but preserves all transaction data. You can still access the transaction data after having deleted the instance.": [
        "Dieser Vorgang löscht den privaten Schlüssel der Instanz, lässt jedoch alle Transaktionsdaten unberührt. Sie können daher auch weiterhin nach der Löschung der Instanz auf diese Daten zugreifen."
      ],
      "Deleting an instance %1$s": [
        "Löschung der Instanz %1$s"
      ],
      "This cannot be undone!": [
        "Das kann nicht rückgängig gemacht werden!"
      ],
      "Purge the instance": [
        "Instanz löschen"
      ],
      "Purge the instance \"%1$s\"": [
        "Instanz \"%1$s\" wird endgültig verworfen"
      ],
      "If you purge the instance named %1$s (ID: %2$s), you will also delete all of its transaction data!": [
        "Falls Sie die Instanz %1$s (ID: %2$s) vollständig verwerfen, löschen Sie damit auch unwiderruflich alle Transaktionsdaten!"
      ],
      "The instance will disappear from your list and you will no longer be able to access its data.": [
        "Die Instanz wird von Ihrer Liste gestrichen und alle ihre Daten werden nicht mehr zugänglich sein."
      ],
      "Purging an instance %1$s": [
        "Die Instanz %1$s wird endgültig verworfen"
      ],
      "checking compatibility with server...": [
        "Prüfe Kompatibilität mit dem Server..."
      ],
      "Contacting the server failed": [
        "Der Kontaktversuch mit dem Server ist fehlgeschlagen"
      ],
      "The server version is not supported": [
        "Die Serverversion wird nicht unterstützt"
      ],
      "Supported version \"%1$s\", server version \"%2$s\".": [
        "Unterstützte Version \"%1$s\", Serverversion \"%2$s\"."
      ],
      "Business Name": [
        "Firmenname"
      ],
      "Available statistics": [
        "Verfügbare Statistiken"
      ],
      "There are no statistics to list": [
        "Es gibt noch keine Statistiken anzuzeigen"
      ],
      "title\u0004%1$s: Settings": [
        "%1$s: Einstellungen"
      ],
      "title\u0004%1$s: New bank account": [
        "%1$s: Neues Bankkonto"
      ],
      "title\u0004%1$s: Bank accounts": [
        "%1$s: Bankkonten"
      ],
      "title\u0004%1$s: Update bank Account": [
        "%1$s: Bankkonto aktualisieren"
      ],
      "title\u0004%1$s: Orders": [
        "%1$s: Bestellungen"
      ],
      "title\u0004%1$s: New order": [
        "%1$s: Neue Bestellung"
      ],
      "title\u0004%1$s: Inventory": [
        "%1$s: Lagerbestand"
      ],
      "title\u0004%1$s: New product": [
        "%1$s: Neuer Artikel"
      ],
      "title\u0004%1$s: Update product": [
        "%1$s: Artikel aktualisieren"
      ],
      "title\u0004%1$s: Category": [
        "%1$s: Kategorie"
      ],
      "title\u0004%1$s: New category": [
        "%1$s: Neue Kategorie"
      ],
      "title\u0004%1$s: Update category": [
        "%1$s: Kategorie aktualisieren"
      ],
      "title\u0004%1$s: Wire transfers": [
        "%1$s: Überweisungen"
      ],
      "title\u0004%1$s: Webhooks": [
        "%1$s: Webhooks"
      ],
      "title\u0004%1$s: New webhook": [
        "%1$s: Neuer Webhook"
      ],
      "title\u0004%1$s: Update webhook": [
        "%1$s: Webhook aktualisieren"
      ],
      "title\u0004%1$s: OTP devices": [
        "%1$s: OTP-Geräte"
      ],
      "title\u0004%1$s: New OTP device": [
        "%1$s: Neues OTP-Gerät"
      ],
      "title\u0004%1$s: Update OTP device": [
        "%1$s: OTP-Gerät aktualisieren"
      ],
      "title\u0004%1$s: New template": [
        "%1$s: Neue Vorlage"
      ],
      "title\u0004%1$s: Update template": [
        "%1$s: Vorlage aktualisieren"
      ],
      "title\u0004%1$s: Templates": [
        "%1$s: Vorlagen"
      ],
      "title\u0004%1$s: Use template": [
        "%1$s: Vorlage verwenden"
      ],
      "title\u0004%1$s: Personalization": [
        "%1$s: Personalisierung"
      ],
      "title\u0004%1$s: Discounts & Suscriptions": [
        ""
      ],
      "title\u0004%1$s: New token family": [
        "%1$s: Neue Tokenfamilie"
      ],
      "title\u0004%1$s: Update token family": [
        "%1$s: Tokenfamilie aktualisieren"
      ],
      "title\u0004%1$s: Access tokens": [
        "%1$s: Zugangstoken"
      ],
      "title\u0004%1$s: New access token": [
        "%1$s: Neuer Zugangstoken"
      ],
      "title\u0004New instance": [
        "Neue Instanz"
      ],
      "title\u0004Instances": [
        "Instanzen"
      ]
    }
  },
  "domain": "messages",
  "plural_forms": "nplurals=2; plural=n != 1;",
  "lang": "de",
  "completeness": 96
};

